import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { addEmptyStateTranslations } from "./translations/emptyStates";
import { addTransactionStatusRetrievalTranslations } from "./translations/transactionStatusRetrieval";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          card: "Card",
          update: "Update",
          providedate:"Please provide Date",
          percentage: "Percentage",
          flat: "Flat",
          pleaseEnterValidEmail:"Please enter a valid email",
          processingFeeType: "Processing Fee Type",
          processingFeePercentage: "Processing Fee (%)",
          processingFeeFlat: "Processing Fee (Flat)",
          editDiscountRateConfiguration: "Edit discount rate configuration",
          createNewDiscountRateConfiguration: "Create new discount rate configuration",
          
// Report validation messages
pleaseSelectAtLeastOneColumn: "Please select at least one column for the report",
pleaseSelectAtLeastOneTransactionStatus: "Please select at least one transaction status",
pleaseSelectValidDateRange: "Please select a valid date range",
pleaseSelectRoleForUser: "Please select a role for this user",
pleaseSelectAtLeastOneTransaction: "Please select at least one transaction",


          
          // Validation messages for discount rates
          cardNameIsRequired: "Card name is required",
          mdrMustBeBetween0And10: "MDR must be between 0 and 10",
          vatMustBeBetween0And20: "VAT must be between 0 and 20",
          capLimitMustBeGreaterThanOrEqualTo0: "Cap Limit must be greater than or equal to 0",
          processingFeePercentageMustBeBetween0And100: "Processing Fee (%) must be between 0 and 100",
          processingFeeFlatMustBeGreaterThanOrEqualTo0: "Processing Fee (Flat) must be greater than or equal to 0",
          atLeastOneTerminalMustBeSelected: "At least one terminal must be selected if 'Apply to All Terminals' is unchecked",
          
          // Success/Error messages for settings
          discountRateCreated: "Discount rate created",
          discountRateUpdated: "Discount rate updated",
          discountRateDeleted: "Discount rate deleted",
          deviceDeleted: "Device deleted",
          notAllowedToModifyThisDevice: "Not allowed to modify this device",
          pleaseSelectValidTime: "Please select valid time",
          updatedSuccessfully: "Updated successfully",
          mdrPercentageCannotBeGreaterThan10: "MDR percentage cannot be greater than 10%",
          vatPercentageCannotBeGreaterThan15: "VAT percentage cannot be greater than 15%",
          processingFeePercentageCannotBeGreaterThan30: "Processing Fee percentage cannot be greater than 30%",
          
          dashboard: "Dashboard",
          allBranches: "All branches",
          purchaseTransactions: "Purchase Transactions",
          refunds: "Refunds",
          successRate: "Success Rate",
          schema: "Card scheme",

          totalPurchaseAmount: "Total amount of purchase transactions",
          totalRefundAmount: "Total amount of refund transactions",
          successfulTransactionsPercentage: "Percentage of successful transactions",
          weeklySales: "Weekly sales",
          weeklyReports: "Weekly reports by day",
          terminalHealth: "Terminal Health",
          inactiveTerminals: "Offline terminals",
          activeTerminals: "Online terminals",
          totalTerminals: "Total Terminals",
          clickToFilter: "click to filter",
          viewTerminals: "View terminals",
          error: "Error",
          "Session Ended, please login again": "Session Ended, please login again",
          notifications: "Notifications",
          seeAll: "See all",
          downloadReport: "Download report",
          dateRange: "Date range",
          reportType: "Report type",
          resetToDefault: "Reset to default",
          download: "Download",
          downloadAll: "Download all",
          previewingFirst: "Previewing first",
          downloadForFullList: "Download the full list to see all transactions.",
          of: "of",
          cancel: "Cancel",
          ok: "OK",
          merchant: "Merchant",
          acquirerCode:"Acquirer Code",
          transactions: "Transactions",
          showing: "Showing",
          manageColumns: "Manage columns",
          selectedColumn: "Selected column",
          id: "ID",
          uuid: "UUID",
          ownerName:"Merchant name ",

          amount: "Amount",
          status: "Status",
          cardType: "Card Type",
          date: "Date",
          indate: "init date",
          businessName:"Business Name",
          terminalId: "Terminal Id",
           MDR: "MDR",
          rrn: "RRN",
          refNumber: "Ref Number",
          receipt: "Receipt",
          transactionId: "Transaction id",
          transactionTimeline: "Transaction Timeline",
          totalProcessingTime: "Total Processing Time",
          notAvailable: "Not Available",
          timelineUnavailable: "Timeline Unavailable",
          timelineDataNotAvailable: "Timeline data is not available for this transaction",
          detailedTimelineNotAvailable: "Detailed timeline breakdown is not available for this transaction",
          
          action: "Action",
          done: "Done",
          settings: "Settings",
          account: "Account",
          reconciliation: "Reconciliation",
          discountRates: "Discount rates",
          trustedDevices: "Trusted devices",
          confirmationEmailSent: "A confirmation email has been sent",
          create: "Create",
          edit: "Edit",
          delete: "Delete",

          active: "Active",
          inactive: "Inactive",
          options: "Options",
          discountRateConfiguration: "Discount Rate Configuration",
          cardName: "Card name",
          mdr: "MDR",
          vat: "VAT",
          capLimit: "Cap Limit",
          processingFee: "Processing Fee",
          bank: "Bank",
          terminals: "Terminals",
          applyToAll: "Apply to All",
          save: "Save",
          grid: "Grid",
          table: "Table",
          viewOnMap: "View on Map",
          noTerminalsFound: "No terminals found",
          reportEmailQueued: "Report is being generated. A download link will be sent to your email.",
          reportDownloaded: "Report downloaded",
          reportGenerationFailed: "Failed to generate report",
          reportPdfNotSupportedLarge: "PDF export is not available when you have more than {{count}} terminals. Please choose CSV or XLSX — the report will be emailed to you.",
          unassigned: "Unassigned",
          branchScope: "Branch Scope",
          singleBranch: "Single Branch",
         singleBranchDesc: "Restrict this account access to a specific branch only",
          allBranchesDesc: "Allow this account to access all branches",
          allStatuses:"All statuses",
          connectionStatus: "Connection status",
          terminalStatusHint: "Updated nightly. A terminal that just transacted may stay Inactive until the next run.",
          noResultsOnThisPage: "No terminals on this page match the connection filter. Try another page.",
          lastQualifyingTransaction: "Last qualifying transaction",
          daysSinceLastTransaction: "Days since last qualifying transaction",
          neverTransacted: "No qualifying transaction yet",
          newlyActivated: "Newly activated",
          lastConnection: "Last connection",
          neverConnected: "Never connected",
          monthlyTransactionValue: "Monthly transaction value",
          monthlyValueFlag: "Monthly threshold",
          metThreshold: "Met threshold",
          belowThreshold: "Below threshold",
          lowTransactionFee: "Low transaction fee",
          activity: "Activity",
          today: "Today",
          never: "Never",
          daysCount_one: "{{count}} day",
          daysCount_other: "{{count}} days",
          inactivitySettings: "Inactivity Config",
          valueMustBeBetween: "Value must be between {{min}} and {{max}}",
          inactivityPeriod: "Inactivity period",
          inactivityPeriodHelp: "A terminal with no approved purchase for this long is shown as Inactive. Newly activated terminals count as Active for one period.",
          minMonthlyThreshold: "Monthly transaction threshold (SAR)",
          minMonthlyThresholdHelp: "Terminals below this month-to-date total are flagged.",
          lowTransactionFeeHelp: "Display only. No fee is charged by the system.",
          inactivitySettingsSaved: "Inactivity settings saved",
          terminalsChangedStatus: "{{count}} terminals changed status",
          terminalsChangedMonthlyFlag: "{{count}} terminals changed monthly flag",
          inactivityChangeSummaryIncomplete: "The change summary may be incomplete.",
          failedToLoadInactivityConfig: "Failed to load inactivity settings",
          failedToUpdateInactivityConfig: "Failed to save inactivity settings",
          retry: "Retry",
          transactionStatus: "Transaction Status",
          initialized: "Initialized",
          pending: "Pending",
          approved: "Completed",
          canceled: "Canceled",
          DECLINED: "Declined",
          DECLINED_ar: "مرفوضة",
          terminalNotConnected: "Terminal not connected",
          transactionSchema: "Transaction Schema",
          mada: "Mada",
          visa: "Visa",
          mastercard: "Mastercard",
          jcb: "JCB",
          apply: "Apply",
          fileFormat: "File format",
          startDate: "Start Date",
          endDate: "End Date",
          selectedRange: "Selected range",
          columnsToInclude: "Columns to include",
          schemes: "Schemes",
          scheme: "Scheme",
          "cashier name": "Cashier Name",
          "terminal id": "Terminal Id",
          "branch name": "Branch Name",
          checkAll: "Check all",
          exportSettings: "Export settings",
          branchDetails: "Branch details",
          branchName: "Branch",
          branchAddress: "Branch address",
          paymentInfo: "Payment information",
          customerInfo: "Customer information",
          downloadReceipt: "Download receipt",
          
          madaApp: "Mada App",
          madaId: "Mada Id",
          location: "Location",
          terminalDetails: "Terminal details",
          terminalReset: "Terminal Reset",
          terminalResetDescription: "Use this feature to cancel ongoing transactions or reset the terminal API connection before the timeout period expires.",
          terminalResetWarning: "⚠️ This will interrupt any active transaction processing on the terminal.",
          resetTerminalApi: "Reset Terminal API",
          cashierName: "Cashier",
          cashierUsername: "Cashier Username",
          financeUsername: "Finance Username",
          terminalManagerUsername: "Terminal Manager Username",
          financeEmail: "Finance Email",
          terminalManagerEmail: "Terminal Manager Email",

          cashierId: "Cashier ID",
          financeId: "Finance ID",
          terminalManagerId: "Terminal Manager ID",
          model: "Model",
          serialNo: "Serial No.",
          brand: "Brand",
          deviceInfo: "Device Information",
          batteryLevel: "Battery level",
          "Incorrect username or password": "Incorrect username or password",
          bluetooth: "Bluetooth",
          bluetoothConnection: "Bluetooth connection",
          wifi: "WiFi",
          wifiConnection: "WiFi connection",
          manufacturer: "Manufacturer",
          madaAppInstalled: "Mada app installed",
          updatedOn: "Updated on",
          totalRequests: "Total Requests",
          // approved: "Approved",
          declined: "Declined",
          management: "Management",
          bulkUpload: "Bulk upload",
          cashiers: "Cashiers",
          financ: "Finance",
          terminalManagers: "Terminal Managers",
          users: "Users",
          branches: "Branches",
          username: "Username",
          role: "Role",
          userStatus: "User status",
          manageUser: "Manage the current status and role of this User.",
          activate: "Activate",
          filterByCardScheme:"Filter By Card Name",
          address: "Address",
          noOfTerminals: "No. of assigned terminals",
          branchStatus: "Branch status",
          manageBranch: "Manage the current status of this branch.",
          branchCode: "Branch code",
          deactivateBranchWarning:
            "Do you want to deactivate this branch? Deactivating will pause all transactions and activities for this branch.",
          deactivateBranch: "Deactivate Branch",
          activateBranch: "Activate Branch",
          deactivateuserWarning:
            "Do you want to deactivate this user? Deactivating will theme from accessing the system.",
          deactivateUser: "Deactivate user",
          activateUser: "Activate user",
          editName: "Edit Name",
          usernameAlreadyExists: "Username already exists",
          invalidRequestData: "Invalid request data",
          pleaseEnterName: "Please enter a name",
          nameUpdated: "Name updated successfully",
          errorUpdatingName: "Error updating name",
          logout: "Logout",
          password: "Password",
          
          conpassword: "Confirm password",
          login: "Login",
          loginToYourAccount: "Login to your account",
         
          menu: "Menu",
          search: "Search",
          TerminalConnectionUpdates: "Terminal connection updates will appear here.",
          madeWith: "Made with",
          filters: "Filters",
          type: "Type",
          filterTransactions: "Filter transactions",
          Page: "Page",
          results: "results",
          selectListColumns: "Select the columns you would like to see on the list",
          applyFilters: "Apply filters to find the exact transactions you need.",
          addTerminal: "Add terminal",
          terminalModel: "Terminal model",
          madaPackage: "Mada package",
          selectTerminalModel: "Select terminal model",
          selectMadaPackage: "Select mada package",
          provider: "Provider",
          selectTerminalProvider: "Select terminal provider",
          INITIALIZED: "Initilized",
          APPROVED: "Approved",
          APPROVED_ar: "مقبولة",
          versionCode: "Version Code",

          TERMINAL_NOT_CONNECTED_ar: "الجهاز غير متصل",
          TERMINAL_NOT_CONNECTED: "Not Connected",
          // DECLINED:"DECLINED",
          CANCELED_ar: "ملغي",
          CANCELED: "Canceled",
         TERMINAL_MISCONF:"Misconfigured",
          PENDING: "Pending",
          details: "Details",

          newRecon: "New Reconciliation",
          terminal: "Terminal",
          close: "Close",
          reassaignCashier: "Reassign Cashier",
          cancle: "Cancel",


        
          makeNewRecon: "Make a new reconciliation",
          balanced: "Balanced",
          unbalanced: "Unbalanced",
          reconciliations: "Reconciliations",
          print: "print",
          reconDetails: "Reconciliation details",
          adduser: "Add User",
          addbranch: "Add Branch",
          fullname: "Full name",
          selectabranch: "Select a branch",
          selectarole: "Select a role",
          selectaterminal: "Select a terminal",
          createnewuser: "Create a new user",
          createnewusersub: "Add a new user to your system",
          createnewbranch: "Create a new branch",
          createnewbranchsub: "Add a new branch to your system",
          purchase: "Purchase",
          refund: "Refund",

          settlementReport: "Settlement Report",
          filePreview: "File Preview",
          no: "No.",
          from: "From",
          to: "To",
          reportRange: "Report Range",
          bankSettlementTotal: "Bank Settlement Total",
          totalAmountInNeoPaasPortal: "Total Amount in NeoPaas Portal",
          noOfTransactionsInBankSettlementFile: "No. of Transactions in Bank Settlement File",
          existsInFileOnly: "Exists in File Only",
          existsInSystemOnly: "Exists in System Only",
          noOfTransactionsInNeoPaasPortal: "No. of Transactions in NeoPaas Portal",
          matched: "Matched",
          mismatched: "Mismatched",
          terminalStatus: "Terminal Status",
          totalMdrInBankSettlement: "Total MDR in Bank Settlement",
          totalVatInBankSettlement: "Total VAT in Bank Settlement",
          totalNetInBankSettlement: "Total Net in Bank Settlement",
          totalMdrInNeoPaasPortal: "Total MDR in NeoPaas Portal",
          totalVatInNeoPaasPortal: "Total VAT in NeoPaas Portal",
          totalNetInNeoPaasPortal: "Total Net in NeoPaas Portal",
          matchedTransactions: "Matched Transactions",
          missingTransactions: "Missing Transactions",
          extraTransactions: "Extra Transactions",
          missingRrn: "Missing RRN",
          amountMismatch: "Amount Mismatch",
          acquirerCodeMismatch: "Acquirer Code Mismatch",
          cardMismatch: "Card Mismatch",
          cardMissmatch: "Card Mismatch",
          incompleteTransactions: "Incomplete Transactions",
          mdrIssues: "MDR Issues",
          vatIssues: "VAT Issues",
          feeIssues: "Fee Issues",
          netIssues: "Net Issues",
          transactionComparison: "Transaction Comparison",
          totalTransactions: "Total Transactions",
          financialSummary: "Financial Summary",
          transactionDetails: "Transaction Details",
          summary: "Summary",
          totalMDR: "Total MDR",
          totalVAT: "Total VAT",
          totalNet: "Total Net",
          transactionsMissingFromFile: "Transactions Missing From File",
          transactionsMissingFromSystem: "Transactions Missing From System",
          transactionSummary: "Transaction Summary",
          financialBreakdown: "Financial Breakdown",
          bankSettlement: "Bank Settlement",
          neoPaaSPortal: "NeoPaaS Portal",
          detailedTransactions: "Detailed Transactions",
          noOfTransactionsInTheBankSettlementFile: "No. of Transactions in Bank Settlement File",
          totalMDRInBankSettlement: "Total MDR in Bank Settlement",
          totalVATInBankSettlement: "Total VAT in Bank Settlement",
          totalMDRInNeoPaasPortal: "Total MDR in NeoPaaS Portal",
          totalVATInNeoPaasPortal: "Total VAT in NeoPaaS Portal",
         
          acquiererCodeMissmatch: "Acquirer Code Mismatch",
          mdrMissmatch: "MDR Mismatch",
          vatMissmatch: "VAT Mismatch",
          feeMissmatch: "Fee Mismatch",
          netAmountMissmatch: "Net Amount Mismatch",
          amountMissmatch: "Amount Mismatch",
          typeMissmatch: "Type Mismatch",
          missingRRN: "Missing RRN",
          noFileUploaded: "No file uploaded yet",
          totalAmountInNeoPaaSPortal: "Total Amount in NeoPaaS Portal",
          difference: "Difference",
       
          exportCsv: "Export CSV",
          // Added translation for 'Please select a date range'
          pleaseSelectDateRange: "Please select a date range",
          uploadBankStatementHint: "Upload bank statement of your account in CSV format. Ensure the file contains valid data.",

            onlyCsvXlsxExcelSupported: "Only CSV, XLSX, and Excel spreadsheet formats are supported",
           
            uploadFailed: "upload failed.",
       failed: "Failed",
            clickOrDragToUpload: "Click or drag file to this area to upload",
            
        

            uploading: "Uploading",
            startSettlement: "Start Settlement",
            parsingFile: "Parsing File",
            processingSettlement: "Processing Settlement",
            pleaseWait: "Please wait...",
            noDataAvailable: "No data available",
            
            // Duplicate detection
            duplicateTransactionsDetected: "Duplicate Transactions Detected",
            duplicateTransactionsDescription: "Found {{count}} duplicate transaction(s) in the uploaded file",
            duplicateSummary: "Duplicate Summary",
            totalDuplicates: "Total Duplicates",
            duplicatesByRRN: "Duplicates by RRN",
            duplicatesByTransaction: "Duplicates by Transaction Match",
            duplicateRRN: "Duplicate RRN",
            duplicateTransaction: "Duplicate Transaction",
            duplicate: "Duplicate",
            originalTransaction: "Original Transaction",
            removeDuplicatesAndContinue: "Remove Duplicates & Continue",
            duplicatesRemovedSuccessfully: "{{count}} duplicate(s) removed successfully",

            merchantOnBoarding: "Merchant Onboarding",
            addCashier: "Add new Merchant and their details to the system",
            personalInformation: "Personal Information",
            businessInformation: "Business Information",
            brachMsp: "Branches, MSPs ...",
            step1: "Step 1",
            confirmPassword: "Confirm Password",
            next: "Next",
            back: "Back",
            passwordtooweak: "Password is too weak. Please choose a stronger password that includes at least 8 characters, an uppercase letter, a lowercase letter, a number, and a special character.",
            step2: "Step 2",
            buisinessName: "Business Name",
            cr: "CR",
            email: "Email",
            mobileNumber: "Mobile Number",
          
            selectBank: "Select Bank",
            step3: "Step 3",
            branchesMspCashier: "Branches, MSPs, and Cashiers",
            addBranch: "Add Branch",
            branch: "Branch",

            addCashiera: "Add Cashier",
            removeCashier: "Remove Cashier",
            reconStatus: "Recon Status",
            removeBranch: "Remove Branch",
            name: "Name",
            cashierUserName: "Cashier Username",
            cashierPassword: "Cashier Password (must be changed on first login)",
            msp: "MSP",
            selectMsp: "Select MSP",
            terminalDiscountDetails: "Terminal Discount Breakdown",
            searchByTerminalNo: "Search by terminal number",
            ascending: "Ascending",
            descending: "Descending",
            noData: "No data",
            sortBy: "Sort by",
            fullNameReq: "Full name is required",
            invalidFullName: "Invalid full name",
            usernameReq: "Username is required",
            invalidUserNameReq: "Invalid username",
            passwordReq: "Password is required",
            passwordNotMatch: "Passwords do not match",
            businessNameReq: "Business name is required",
            invalidBusinessName: "Invalid business name",
            crReq: "CR is required",
            invalidCr: "Invalid CR",
            emailReq: "Email is required",
            invalidEmail: "Invalid email",
            mobileNumberReq: "Mobile number is required",
            invalidMobileNumber: "Invalid mobile number",
            bankSelectionReq: "Bank selection is required",
            addOneBranch: "add at least one branch",
            VAT: "VAT",
            branchNameReq: "Branch name is required",
            invalidBranchNAme: "Invalid branch name",
            branchAddressReq: "Branch address is required",
            invalidBranchAddress: "Invalid branch address",
            addOnecashier: "add at least one cashier",
            cashierNameReq: "Cashier name is required",
            reportFile: "Report File",
            invalidCashierName: "Invalid cashier name",
          // cashierNameReq:"Cashier username is required",
          // invalidCashierName:"Invalid cashier username",
          cashierPasswordReq: "Cashier password is required",
          invalidCashierPassword: "Invalid cashier password",
          mspReq: "MSP is required",
          terminalModelReq: "Terminal Model is required",
          terminalIdReq: "Terminal ID is required",
          onboardingSuccess: "Onboarding successful",
          creditCount: "Credit Count",
          creditTotal: "Credit Total",
          debitCount: "Debit Count",
          debitTotal: "Debit Total",
          madaHost: "Mada Host",
       
          discrepency: "Discrepancy",
          ballanced: "Ballanced",
          posTerminal: "Pos Terminal",
          removecashier: "Remove Cashier",
          reconciliationReport: "Reconciliation report",
          fullName: " Full name",
          settlement: "Settlement",
          region: "Region",
          city: "City",
          district: "District",
          terminalIdLength: "Terminal id should be between 8 and 16 digits long",
          terminalIdNumbersOnly: "Terminal ID must contain numbers only",
          forgot: "  Forgot Password?",
          reset: "Reset Password",
          resetyour: "Reset Your Password ",
          emailv: "Verify Email",
          validEmail: "Please enter a valid email address.",
          discounts:"Discounts & fees",
          verify:"verify",
          netAmount:"Net",
          "Your filters did not return any results.": "Your filters did not return any results.",
          userInformationSettings: "User Information Settings",
          emailVerificationRequired: "Email Verification Required",
          emailVerificationDescription: "Please verify your email to proceed.",
          actionCanceled: "Action canceled.",
          enterTheCode:"OTP verification",
          codeSent:"A code has been sent to your email ",
          code:"Code",
          "Sorry, the page you visited does not exist": "Sorry, the page you visited does not exist.",
          ecrProviderReq: "ECR Provider is required",
          "Are you licensed with an ECR provider?": "Are you licensed with an ECR provider?",
          net:"Net",
          reportenttoyouremailSuccessfully: "Your transaction report is being generated. You will receive a secure download link via email once it's ready.",
          "acquirer code": "Acquirer Code",
          fee: "Fee",
          cardScheme: "Card Scheme",
          downloadSelectedReceipts: "Download Selected Receipts",
          changePassword: "Change Password",
          passwordResetDescription: "A password reset link will be sent to your email.",
          sendPasswordResetLink: "Send Password Reset Link",
          token:"token",
          removeTrustedDevice: "Remove Trusted Device",
          removeTrustedDeviceDescription: "Are you sure you want to remove this trusted device?",
          removeDevice: "Remove Device",
          autoReconciliation: "Auto Reconciliation",
          "Only CSV, XLSX, and Excel spreadsheet formats are supported": "Only CSV, XLSX, and Excel spreadsheet formats are supported",
          nobusiness: "No Business",
          autoReconciliationTime: "Auto Reconciliation Time",
          receiveReconciliationStatusViaEmail: "Receive Reconciliation Status via Email",
          reconciliationSettings: "Reconciliation Settings",
          
          // Response Timeout Settings
          responseTimeout: "Response Timeout",
          responseTimeoutSettings: "Response Timeout Settings",
          timeoutInformation: "Timeout Information",
          timeoutDescription: "Configure the maximum time (in seconds) to wait for a response from payment terminals. This affects transaction processing time.",
          currentTimeout: "Current Timeout",
          newTimeoutValue: "New Timeout Value",
          seconds: "Seconds",
          timeoutRange: "Allowed range",
          timeoutMustBeBetween5And300: "Timeout must be between 5 and 300 seconds",
          timeoutUpdatedSuccessfully: "Timeout updated successfully",
          failedToLoadTimeout: "Failed to load timeout settings",
          failedToUpdateTimeout: "Failed to update timeout",
          viewOnly: "View Only",
          merchantCanEditInSettings: "Merchant can edit this in their settings",
          companyInfo: "Company Info",
          companyName: "Company Name",
          companyAddress: "Company Address",
          adjustTimeout: "Adjust Timeout",
          quickPresets: "Quick Presets",
          fineTune: "Fine-tune",
          veryFast: "Very Fast",
          fast: "Fast",
          moderate: "Moderate",
          slow: "Slow",
          verySlow: "Very Slow",
          
          merchantToken: "Merchant Token",
          merchantTokenDescription: "Configure your Neoleap integration token for transaction processing",
          neoleapToken: "Neoleap Token",
          enterNeoleapToken: "Enter your Neoleap token",
          neoleapTokenOptional: "Optional: You can add this token later in settings",
          tokenCannotBeEmpty: "Token cannot be empty",
          tokenTooShort: "Token must be at least 10 characters",
          tokenUpdatedSuccessfully: "Token updated successfully",
          failedToFetchToken: "Failed to fetch token",
          failedToUpdateToken: "Failed to update token",
          saveChanges: "Save Changes",
          
          operationSystem: "Operating System",
          browser: "Browser",
          cashier:"Cashier",
          terminalNo: "Terminal No.",
          "no terminal": "No Terminal",
          "missconfiguration": "Missconfiguration",
          "timeout": "Timeout",
          version: "Version",
          reconciliationHistory: "Reconciliation History",
          "card type": "Card Type",
          total:"Total",
          SAR:"SAR",
          USD:"USD",
          EUR:"EUR",
          "Select ecr provider: ": "Select ecr provider: ",
          GBP:"GBP",
          providers:"providers",
          "mada app": "Mada App",
          ipAddress: "IP Address",
          addedOn: "Added On",
          "OTP must be 6 digits":"OTP must be 6 digits",  
          discountFeesByCardScheme: "Discount Fees by Card Scheme",
          "Incorrect OTP": "Incorrect OTP",
          discountFeesByTerminal: "Discount Fees by Terminal",
          totalDiscount: "Total Discount",
          schemeDiscountBreakdown: "Scheme Discount Breakdown",
          contributionByScheme: "Contribution by Scheme",
          allTimeDiscountFeesByTerminal: "All Time Discount Fees by Terminal",
          allTimeTerminalDiscountBreakdown: "All Time Terminal Discount Breakdown",
          withNetOf: "with net of",
          terminalDiscountBreakdown: "All Time Terminal Discount Breakdown",
          fromTotalOf: "from total of",
          selectCardScheme: "Select Card Scheme",
          selectTerminals: "Select Terminals",
          "Email is not verified": "Email is not verified",
          "Account deactivated": "Account deactivated",
          "Account is pending for activation, please wait for activation or contact support for more assistance.": "Account is pending for activation, please wait for activation or contact support for more assistance.",
          "Your registration has been rejected, please contact support for more assistance.": "Your registration has been rejected, please contact support for more assistance.",
          "Account branch deactivated": "Account branch deactivated",
          
          // ECR Dashboard
          "ecr.dashboard.title": "ECR Provider Dashboard",
          "ecr.dashboard.subtitle": "Monitor your merchants, terminals, and license usage",
          "ecr.dashboard.associatedMerchants": "Associated Merchants",
          "ecr.dashboard.activeMerchants": "Active merchants",
          "ecr.dashboard.totalTerminals": "Total Terminals",
          "ecr.dashboard.acrossAllMerchants": "Across all merchants",
          "ecr.dashboard.totalLicenses": "Total Licenses",
          "ecr.dashboard.purchasedLicenses": "Purchased licenses",
          "ecr.dashboard.remainingLicenses": "Remaining Licenses",
          "ecr.dashboard.licensesAvailable": "Licenses available",
          "ecr.dashboard.lowLicensesWarning": "Low license availability",
          "ecr.dashboard.noLicensesRemaining": "No licenses available",
          "ecr.dashboard.pendingLicenseAssignment": "Pending admin assignment",
          "ecr.dashboard.awaitingAdminAssignment": "Awaiting admin assignment",
          "ecr.dashboard.licenseAssignmentRequired": "License Assignment Required",
          "ecr.dashboard.licenseAssignmentDescription": "Your account is pending license assignment from the administrator. Please contact support to have licenses allocated to your account.",
          "ecr.dashboard.totalMerchants": "Total Merchants",
          "ecr.dashboard.merchantsSubtitle": "Associated merchants",
          "ecr.dashboard.activeTerminals": "Active Terminals",
          "ecr.dashboard.terminalsSubtitle": "Terminals in use",
          "ecr.dashboard.licensesSubtitle": "Purchased licenses",
          "ecr.dashboard.consumedLicenses": "Consumed Licenses",
          "ecr.dashboard.consumed": "consumed",
          "ecr.dashboard.daysUntilExpiry": "Days Until Expiry",
          "ecr.dashboard.daysRemaining": "days remaining",
          "ecr.dashboard.expiringWarning": "Expiring soon!",
          "ecr.dashboard.licenseConsumption": "License Consumption",
          "ecr.dashboard.licenseWarning": "License limit approaching",
          "ecr.dashboard.licenseCritical": "License limit reached",
          "ecr.dashboard.licenseTrend": "License Trend",
          "ecr.dashboard.last12Months": "Last 12 months",
          "ecr.dashboard.licenseBreakdown": "License Breakdown",
          "ecr.dashboard.byMerchant": "By merchant",
          "ecr.dashboard.licenses": "licenses",
          "ecr.dashboard.merchantList": "Merchant List",
          "ecr.dashboard.errorLoadingSummary": "Failed to load dashboard summary. Please try again.",
          "ecr.dashboard.errorLoadingMerchants": "Failed to load merchants. Please try again.",
          "ecr.dashboard.errorLoadingCharts": "Failed to load chart data",
          "ecr.dashboard.errorLoadingMerchantDetails": "Failed to load merchant details. Please try again.",
          loading: "Loading...",
          merchantName: "Merchant Name",
          merchantId: "Merchant ID",
          merchantDetails: "Merchant Details",
          onboardingDate: "Onboarding Date",
          viewDetails: "View Details",
          clearFilters: "Clear Filters",
          activeFilters: "Active Filters",
          
          // ECR Onboarding
          "ecr.onboarding.title": "ECR Provider Registration",
          "ecr.onboarding.subtitle": "Register your ECR provider account to integrate with NeoPaas",
          "ecr.onboarding.fullNamePlaceholder": "Enter your full name",
          "ecr.onboarding.emailPlaceholder": "Enter your email",
          "ecr.onboarding.passwordPlaceholder": "Enter your password",
          "ecr.onboarding.confirmPasswordPlaceholder": "Confirm your password",
          "ecr.onboarding.fullNameMinLength": "Full name must be at least 3 characters",
          "ecr.onboarding.confirmPasswordReq": "Confirm password is required",
          "ecr.onboarding.register": "Register",
          "ecr.onboarding.successTitle": "Done",
          "ecr.onboarding.successMessage": "Your ECR provider account has been submitted for approval. You will be able to log in once your account is approved",
          "ecr.onboarding.goToLogin": "Go to Login",
          "ecr.onboarding.registrationFailed": "Registration failed",
          "ecr.onboarding.registrationError": "An error occurred during registration",

          // MSP Onboarding
          "msp.onboarding.title": "MSP Provider Registration",
          "msp.onboarding.subtitle": "Register your MSP provider portal account",
          "msp.onboarding.providerNameLabel": "Provider Name (English)",
          "msp.onboarding.providerNamePlaceholder": "Enter provider name in English",
          "msp.onboarding.providerNameReq": "Provider English name is required",
          "msp.onboarding.providerNameArLabel": "Provider Name (Arabic)",
          "msp.onboarding.providerNameArPlaceholder": "أدخل اسم المزود بالعربية",
          "msp.onboarding.providerNameArReq": "Provider Arabic name is required",
          "msp.onboarding.fullNamePlaceholder": "Enter your full name",
          "msp.onboarding.fullNameMinLength": "Full name must be at least 3 characters",
          "msp.onboarding.emailPlaceholder": "Enter your email address",
          "msp.onboarding.passwordPlaceholder": "Enter a strong password",
          "msp.onboarding.confirmPasswordPlaceholder": "Confirm your password",
          "msp.onboarding.confirmPasswordReq": "Please confirm your password",
          "msp.onboarding.register": "Register",
          "msp.onboarding.successTitle": "Registration Submitted",
          "msp.onboarding.successMessage": "Your MSP provider account has been submitted for review. You will be notified once your account is activated.",
          "msp.onboarding.goToLogin": "Go to Login",
          "msp.onboarding.registrationFailed": "Registration failed. Please try again.",
          "msp.onboarding.registrationError": "An error occurred during registration. Please try again.",
          "msp.onboarding.totalLicensesLabel": "Number of Licenses",
          "msp.onboarding.totalLicensesPlaceholder": "Enter the number of licenses",
          "msp.onboarding.totalLicensesReq": "Number of licenses is required",
          "msp.onboarding.totalLicensesMin": "Number of licenses must be at least 1",
          providerUserInfo: "Provider User Info",
          noMspUserLinked: "No MSP portal user is linked to this provider.",
          enrollMspUser: "Enroll MSP User",
          enrollMspUserTitle: "Create & Link MSP User",
          mspUserEnrolledSuccess: "MSP user enrolled and linked successfully.",
          
          // ECR Provider Management
          "ecr.admin.title": "ECR Providers Management",
          "ecr.admin.subtitle": "Manage ECR provider accounts, licenses, and access permissions",
          "ecr.admin.totalProviders": "Total Providers",
          "ecr.admin.activeProviders": "Active Providers",
          "ecr.admin.pendingApproval": "Pending Approval",
          "ecr.admin.totalLicenses": "Total Licenses",
          "ecr.admin.providerInfo": "Provider Information",
          "ecr.admin.usageStats": "Usage Statistics",
          "ecr.admin.licenseInfo": "License Information",
          "ecr.admin.fullName": "Full Name",
          "ecr.admin.emailAddress": "Email Address",
          "ecr.admin.companyName": "Company Name",
          "ecr.admin.phoneNumber": "Phone Number",
          "ecr.admin.registrationDate": "Registration Date",
          "ecr.admin.totalMerchants": "Total Merchants",
          "ecr.admin.activeTerminals": "Active Terminals",
          "ecr.admin.consumedLicenses": "Consumed Licenses",
          "ecr.admin.totalLicensesLabel": "Total Licenses",
          "ecr.admin.activationDate": "Activation Date",
          "ecr.admin.expiryDate": "Expiry Date",
          "ecr.admin.updateLicense": "Update License",
          "ecr.admin.licenseUsage": "License Usage",
          "ecr.admin.licensesUsed": "licenses used",
          "ecr.admin.currentConsumed": "Current consumed",
          "ecr.admin.selectActivationDate": "Select activation date",
          "ecr.admin.selectExpiryDate": "Select expiry date",
          "ecr.admin.enterTotalLicenses": "Enter total number of licenses",
          "ecr.admin.approveProvider": "Approve Provider",
          "ecr.admin.rejectProvider": "Reject Provider",
          "ecr.admin.deactivateProvider": "Deactivate Provider",
          "ecr.admin.activateProvider": "Activate Provider",
          "ecr.admin.approveConfirm": "Approve Provider Registration?",
          "ecr.admin.approveDesc": "Approving will grant this provider access to the system. They will be able to onboard merchants and manage terminals.",
          "ecr.admin.rejectConfirm": "Reject Provider Registration?",
          "ecr.admin.rejectDesc": "Rejecting will deny access to this provider. This action can be reversed later if needed.",
          "ecr.admin.deactivateConfirm": "Deactivate Provider?",
          "ecr.admin.deactivateDesc": "Deactivating will prevent this provider from accessing the system. All associated merchants and terminals will be affected.",
          "ecr.admin.activateConfirm": "Activate Provider?",
          "ecr.admin.activateDesc": "Activating will enable this provider to access the system and manage their merchants.",
          "ecr.admin.currentStatus": "Current Status",
          "ecr.admin.providerId": "Provider ID",
          "ecr.admin.actions": "Actions",
          "ecr.admin.notSet": "Not set",
          "ecr.admin.licensesOf": "of",
          "ecr.admin.licensesUsedTooltip": "licenses used",
          
          // License Management
          licenses: "Licenses",
          licenseInformation: "License Information",
          licenseUsage: "License Usage",
          assignLicenses: "Assign Licenses",
          licensesAssignedSuccess: "Licenses assigned successfully",
          currentUsage: "Current Usage",
          currentTotal: "Current Total",
          used: "Used",
          available: "Available",
          newTotalLicenses: "New Total Licenses",
          minimumLicenseNote: "Minimum: {{min}} (currently in use)",
          optional: "Optional",
          licenseNotesPlaceholder: "Reason for license allocation...",
          licensesCannotBeNegative: "License count cannot be negative",
          licensesCannotBeBelowUsed: "Cannot set licenses below current usage ({{used}})",
          licenseAtLimit: "License limit reached. No more subscriptions can be created.",
          licenseNearLimit: "License usage is above 80%. Consider increasing license allocation.",
          licenseNormal: "License usage is within normal range.",
          manageLicenses: "Manage Licenses",
          licenseAllocation: "License Allocation",
          licenseHistory: "License History",
          noLicensesAllocated: "No licenses allocated",
          totalLicenses: "Total Licenses",
          usedLicenses: "Used Licenses",
          availableLicenses: "Available Licenses",
          
          // ECR Subscription Approval
          "ecr.subscription.pendingRequests": "Pending Requests",
          "ecr.subscription.activeMerchants": "Active Merchants",
          "ecr.subscription.rejectedTab": "Rejected",
          "ecr.subscription.noPendingRequests": "No pending subscription requests",
          "ecr.subscription.noRejectedRequests": "No rejected subscription requests",
          "ecr.subscription.requestDate": "Request Date",
          "ecr.subscription.approve": "Approve",
          "ecr.subscription.reject": "Reject",
          "ecr.subscription.rejected": "Rejected",
          "ecr.subscription.approveTitle": "Approve Subscription Request",
          "ecr.subscription.rejectTitle": "Reject Subscription Request",
          "ecr.subscription.approveConfirmMessage": "Are you sure you want to approve this subscription request?",
          "ecr.subscription.rejectConfirmMessage": "Are you sure you want to reject this subscription request?",
          "ecr.subscription.rejectionReason": "Rejection Reason",
          "ecr.subscription.rejectionReasonPlaceholder": "Enter reason for rejection...",
          "ecr.subscription.approveSuccess": "Subscription approved successfully",
          "ecr.subscription.rejectSuccess": "Subscription rejected successfully",
          "ecr.subscription.approveError": "Failed to approve subscription",
          "ecr.subscription.rejectError": "Failed to reject subscription",
          "ecr.subscription.errorLoadingPending": "Failed to load pending subscriptions",
          "ecr.subscription.errorLoadingRejected": "Failed to load rejected subscriptions",
          "ecr.subscription.statusFilter": "Status Filter",
          "ecr.subscription.allStatuses": "All Statuses",
          
          // ECR Merchants Page
          "ecr.merchants.title": "Merchant Management",
          "ecr.merchants.numberOfBranches": "No. of branches",
          "ecr.merchants.merchants": "Merchants",
          "ecr.merchants.usersReport": "Users Report",
          "ecr.merchants.branchesReport": "Branches report",
          "ecr.merchants.close": "Close",
          "ecr.merchants.merchantDetails": "Merchant Details",
          "ecr.merchants.activate": "Activate",
          "ecr.merchants.deactivate": "Deactivate",
          "ecr.merchants.approveUser": "Approve User?",
          "ecr.merchants.rejectUser": "Reject User?",
          "ecr.merchants.activateUser": "Activate User?",
          "ecr.merchants.deactivateUserWarning": "Deactivating the user will disable their access to the system",
          "ecr.merchants.activateUserMessage": "Activating the user will enable them to access the system",
          "ecr.merchants.approveUserMessage": "Approving the user will enable them to access the system",
          "ecr.merchants.rejectUserMessage": "This will move this request to rejected tab",
          "ecr.merchants.yes": "Yes",
          "ecr.merchants.no": "No",
          
          // ECR Settings Page
          "ecr.settings.title": "Push Service Settings",
          "ecr.settings.save": "Save",
          "ecr.settings.updateSuccess": "Push service updated successfully",
          "ecr.settings.updateError": "Failed to update push service",
          "ecr.settings.networkError": "Network error",
          
          // Merchant Subscription Status
          "merchant.subscription.errorLoading": "Failed to load subscription status",
          "merchant.subscription.pendingTitle": "ECR Subscription Pending",
          "merchant.subscription.pendingMessage": "Your subscription request to {{provider}} is awaiting approval.",
          "merchant.subscription.rejectedTitle": "ECR Subscription Rejected",
          "merchant.subscription.rejectedMessage": "Your subscription request to {{provider}} was declined.",
          "merchant.subscription.rejectedMessageWithReason": "Your subscription request to {{provider}} was declined. Reason: {{reason}}",
          
          // Branch Card
          remove: "Remove",
          branchInformation: "Branch Information",
          enterBranchName: "Enter branch name",
          enterBranchAddress: "Enter branch address",
          noCashiersAdded: "No cashiers added yet",
          clickAddCashierToStart: "Click 'Add Cashier' to get started",
          confirmBranchRemoval: "Confirm Branch Removal",
          branchRemovalWarning: "Are you sure you want to remove {{branchName}}? This action cannot be undone.",
          branchHasCashiersWarning_one: "This branch has {{count}} cashier. Removing the branch will also remove the associated cashier.",
          branchHasCashiersWarning_other: "This branch has {{count}} cashiers. Removing the branch will also remove all associated cashiers.",
          
          // Cashier Card
          enterCashierName: "Enter cashier name",
          enterCashierUsername: "Enter cashier username",
          enterCashierPassword: "Enter cashier password",
          enterTerminalId: "Enter terminal ID",
          minimumCharacters_one: "Minimum {{count}} character",
          minimumCharacters_other: "Minimum {{count}} characters",
          confirmCashierRemoval: "Confirm Cashier Removal",
          cashierRemovalWarning: "Are you sure you want to remove {{cashierName}}? This action cannot be undone.",
          
          // Plural forms for common entities
          terminal_one: "{{count}} terminal",
          terminal_other: "{{count}} terminals",
          transaction_one: "{{count}} transaction",
          transaction_other: "{{count}} transactions",
          merchant_one: "{{count}} merchant",
          merchant_other: "{{count}} merchants",
          branch_one: "{{count}} branch",
          branch_other: "{{count}} branches",
          cashier_one: "{{count}} cashier",
          cashier_other: "{{count}} cashiers",
          license_one: "{{count}} license",
          license_other: "{{count}} licenses",
          device_one: "{{count}} device",
          device_other: "{{count}} devices",
          user_one: "{{count}} user",
          user_other: "{{count}} users",
          error_one: "{{count}} error",
          error_other: "{{count}} errors",
          result_one: "{{count}} result",
          result_other: "{{count}} results",
          item_one: "{{count}} item",
          item_other: "{{count}} items",
          day_one: "{{count}} day",
          day_other: "{{count}} days",
          hour_one: "{{count}} hour",
          hour_other: "{{count}} hours",
          minute_one: "{{count}} minute",
          minute_other: "{{count}} minutes",
          
          // Date and number formatting examples
          "format.currency": "{{value, currency}}",
          "format.number": "{{value, number}}",
          "format.decimal": "{{value, decimal}}",
          "format.percent": "{{value, percent}}",
          "format.date": "{{value, date}}",
          "format.datetime": "{{value, datetime}}",
          "format.time": "{{value, time}}",
          "format.shortDate": "{{value, shortDate}}",
          "format.longDate": "{{value, longDate}}",
          "format.relativeTime": "{{value, relativeTime}}",
          
          // Common formatted messages
          "messages.lastUpdatedAt": "Last updated: {{date, datetime}}",
          "messages.createdAt": "Created: {{date, shortDate}}",
          "messages.expiresIn": "Expires: {{date, relativeTime}}",
          "messages.totalAmount": "Total: {{amount, currency}}",
          "messages.successRate": "Success rate: {{rate, percent}}",
          "messages.itemCount": "{{count, number}} items",
          
          // Conditional text translations
          "conditional.status.active": "Active",
          "conditional.status.inactive": "Inactive",
          "conditional.status.pending": "Pending",
          "conditional.status.approved": "Approved",
          "conditional.status.rejected": "Rejected",
          "conditional.status.online": "Online",
          "conditional.status.offline": "Offline",
          "conditional.status.connected": "Connected",
          "conditional.status.disconnected": "Disconnected",
          "conditional.status.enabled": "Enabled",
          "conditional.status.disabled": "Disabled",
          
          "conditional.yesNo.yes": "Yes",
          "conditional.yesNo.no": "No",
          
          "conditional.availability.available": "Available",
          "conditional.availability.unavailable": "Unavailable",
          "conditional.availability.inStock": "In Stock",
          "conditional.availability.outOfStock": "Out of Stock",
                    userLoggedIn:"User status",
allCashiers:"All Cashiers",
allCashiersInBranch:"All cashiers in branch",
noCashiersInBranch:"No cashiers in this branch",
          "conditional.visibility.visible": "Visible",
          "conditional.visibility.hidden": "Hidden",
          "conditional.visibility.show": "Show",
          "conditional.visibility.hide": "Hide",
          
          "conditional.action.activate": "Activate",
          "conditional.action.deactivate": "Deactivate",
          "conditional.action.enable": "Enable",
          "conditional.action.disable": "Disable",
          "conditional.action.approve": "Approve",
          "conditional.action.reject": "Reject",
          
          "conditional.state.open": "Open",
          "conditional.state.closed": "Closed",
          "conditional.state.locked": "Locked",
          "conditional.state.unlocked": "Unlocked",
          "conditional.state.verified": "Verified",
          "conditional.state.unverified": "Unverified",
          
          // HTML content translations (use with Trans component)
          "html.securedDownload": "🔒 This download is secured by <strong>NeoPaas</strong>",
          "html.termsAndConditions": "I agree to the <a href='/terms'>Terms and Conditions</a>",
          "html.privacyPolicy": "By continuing, you agree to our <a href='/privacy'>Privacy Policy</a>",
          "html.contactSupport": "Need help? <a href='/support'>Contact Support</a>",
          "html.learnMore": "Learn more about <strong>{{feature}}</strong> in our <a href='/docs'>documentation</a>",
          "html.warningMessage": "<strong>Warning:</strong> This action cannot be undone",
          "html.successMessage": "<strong>Success!</strong> Your changes have been saved",
          "html.errorMessage": "<strong>Error:</strong> {{message}}",
          "html.infoMessage": "<em>Note:</em> {{message}}",
          
          // Empty states
          "emptyState.noData": "No data available",
          "emptyState.noResults": "No results found",
          "emptyState.noTransactions": "No transactions yet",
          "emptyState.noTerminals": "No terminals found",
          "emptyState.noMerchants": "No merchants found",
          "emptyState.noBranches": "No branches found",
          "emptyState.noUsers": "No users found",
          "emptyState.noLicenses": "No licenses allocated",
          "emptyState.noNotifications": "No notifications",
          "emptyState.noHistory": "No history available",
          "emptyState.noReports": "No reports generated",
          "emptyState.noReconciliations": "No reconciliations found",
          "emptyState.noRefunds": "No refunds found",
          "emptyState.noSettlements": "No settlements found",
          "emptyState.noProviders": "No providers found",
          "emptyState.noSubscriptions": "No subscriptions",
          "emptyState.noPendingRequests": "No pending requests",
          "emptyState.noRejectedItems": "No rejected items",
          "emptyState.noActiveItems": "No active items",
          "emptyState.emptyList": "This list is empty",
          "emptyState.emptyTable": "This table is empty",
          "emptyState.noItemsToDisplay": "No items to display",
          "emptyState.startByAdding": "Start by adding your first {{item}}",
          "emptyState.tryAdjustingFilters": "Try adjusting your filters",
          "emptyState.clearFiltersToSeeAll": "Clear filters to see all items",
          
          // Success messages
          "success.operationCompleted": "Operation completed successfully",
          "success.changesSaved": "Changes saved successfully",
          "success.itemCreated": "{{item}} created successfully",
          "success.itemUpdated": "{{item}} updated successfully",
          "success.itemDeleted": "{{item}} deleted successfully",
          "success.itemActivated": "{{item}} activated successfully",
          "success.itemDeactivated": "{{item}} deactivated successfully",
          "success.itemApproved": "{{item}} approved successfully",
          "success.itemRejected": "{{item}} rejected successfully",
          "success.fileUploaded": "File uploaded successfully",
          "success.fileDownloaded": "File downloaded successfully",
          "success.dataExported": "Data exported successfully",
          "success.dataImported": "Data imported successfully",
          "success.emailSent": "Email sent successfully",
          "success.passwordReset": "Password reset successfully",
          "success.accountVerified": "Account verified successfully",
          "success.settingsUpdated": "Settings updated successfully",
          "success.licenseAssigned": "License assigned successfully",
          "success.subscriptionCreated": "Subscription created successfully",
          
          // Error messages
          "error.operationFailed": "Operation failed",
          "error.somethingWentWrong": "Something went wrong",
          "error.tryAgainLater": "Please try again later",
          "error.loadingFailed": "Failed to load {{item}}",
          "error.savingFailed": "Failed to save {{item}}",
          "error.creatingFailed": "Failed to create {{item}}",
          "error.updatingFailed": "Failed to update {{item}}",
          "error.deletingFailed": "Failed to delete {{item}}",
          "error.uploadFailed": "File upload failed",
          "error.downloadFailed": "File download failed",
          "error.exportFailed": "Data export failed",
          "error.importFailed": "Data import failed",
          "error.networkError": "Network error occurred",
          "error.serverError": "Server error occurred",
          "error.unauthorized": "You are not authorized",
          "error.sessionExpired": "Your session has expired",
          "error.notFound": "{{item}} not found",
          "error.alreadyExists": "{{item}} already exists",
          "error.invalidData": "Invalid data provided",
          "error.requiredField": "This field is required",
          "error.invalidFormat": "Invalid format",
          "error.fileTooLarge": "File size is too large",
          "error.invalidFileType": "Invalid file type",
          "error.connectionLost": "Connection lost",
          "error.timeoutError": "Request timed out",
          
          // Warning messages
          "warning.unsavedChanges": "You have unsaved changes",
          "warning.confirmDelete": "Are you sure you want to delete this?",
          "warning.confirmDeactivate": "Are you sure you want to deactivate this?",
          "warning.cannotUndo": "This action cannot be undone",
          "warning.dataWillBeLost": "All data will be lost",
          "warning.lowBalance": "Low balance warning",
          "warning.expiringLicense": "License expiring soon",
          "warning.limitReached": "Limit reached",
          "warning.quotaExceeded": "Quota exceeded",
          "warning.maintenanceMode": "System is in maintenance mode",
          "warning.deprecatedFeature": "This feature is deprecated",
          
          // Info messages
          "info.loading": "Loading...",
          "info.processing": "Processing...",
          "info.pleaseWait": "Please wait...",
          "info.saving": "Saving...",
          "info.uploading": "Uploading...",
          "info.downloading": "Downloading...",
          "info.searching": "Searching...",
          "info.filtering": "Filtering...",
          "info.refreshing": "Refreshing...",
          "info.syncing": "Syncing...",
          "info.connecting": "Connecting...",
          "info.disconnecting": "Disconnecting...",
          "info.initializing": "Initializing...",
          "info.preparingData": "Preparing data...",
          "info.generatingReport": "Generating report...",
          "info.sendingEmail": "Sending email...",
          "info.verifying": "Verifying...",
          "info.almostDone": "Almost done...",
          "info.selectTerminal": "Please select a Terminal",

          
          weak: "Weak",

          medium: "Medium",
          strong: "Strong",
          hidePassword: "Hide password",
          showPassword: "Show password",
          passwordStrengthHint: "Use at least 8 characters with uppercase, lowercase, numbers, and special characters",
          passwordsMatch: "Passwords match",
          passwordsDoNotMatch: "Passwords do not match",
          required: "Required",
          submitting: "Submitting...",
          submit: "Submit",
          
          // Location Selector
          selectRegion: "Select region",
          selectCity: "Select city",
          selectDistrict: "Select district",
          addNewDistrict: "Add New District",
          enterDistrictName: "Enter district name",
          add: "Add",
          selectExistingDistrict: "Select existing district",
          pleaseEnterDistrictName: "Please enter a district name",
          pleaseSelectRegionAndCity: "Please select region and city first",
          
          // Error messages
          onboardingError: "An error occurred during onboarding. Please try again.",
          networkError: "Network error. Please check your connection and try again.",
          validationError: "Please fix the errors in the form before continuing.",
          
          // Sync Configuration
          "Terminal Sync Configuration": "Terminal Sync Configuration",
          "Configure how frequently terminals sync with the server": "Configure how frequently terminals sync with the server",
          "Current Sync Interval": "Current Sync Interval",
          "View History": "View History",
          "Last updated": "Last updated",
          "Updated by": "Updated by",
          "Select Preset Interval": "Select Preset Interval",
          "5 minutes": "5 minutes",
          "15 minutes": "15 minutes",
          "30 minutes": "30 minutes",
          "1 hour": "1 hour",
          "2 hours": "2 hours",
          "6 hours": "6 hours",
          "12 hours": "12 hours",
          "Custom": "Custom",
          "Custom Interval (minutes)": "Custom Interval (minutes)",
          "Enter minutes (1-1440)": "Enter minutes (1-1440)",
          "Minimum: 1 minute, Maximum: 24 hours (1440 minutes)": "Minimum: 1 minute, Maximum: 24 hours (1440 minutes)",
          "Important": "Important",
          "Changes will take effect immediately for all terminals on their next heartbeat. No server restart required.": "Changes will take effect immediately for all terminals on their next heartbeat. No server restart required.",
          "Save Configuration": "Save Configuration",
          "Change History": "Change History",
          "No history available": "No history available",
          "Changed by": "Changed by",
          "Failed to load sync configuration": "Failed to load sync configuration",
          "Failed to load audit logs": "Failed to load audit logs",
          "Sync interval must be between 1 minute and 24 hours": "Sync interval must be between 1 minute and 24 hours",
          "Sync interval must be a whole number": "Sync interval must be a whole number",
          "Sync interval updated successfully": "Sync interval updated successfully",
          "Failed to update sync interval": "Failed to update sync interval",
          "minutes": "minutes",
          "hour": "hour",
          "Sync Configuration": "Sync Configuration",
          
          // Features Slider
          "features.securePayment.title": "Secure Payment Processing",
          "features.securePayment.description": "Process card transactions with multiple payment schemes including Visa, Mastercard, and Mada",
          "features.realtimeDashboard.title": "Real-time Dashboard",
          "features.realtimeDashboard.description": "Monitor transactions, terminals, and business metrics in real-time with live updates",
          "features.advancedSecurity.title": "Advanced Security",
          "features.advancedSecurity.description": "Bank-grade security with JWT authentication and encrypted data transmission",
          "features.lightningFast.title": "Lightning Fast",
          "features.lightningFast.description": "Optimized performance for instant transaction processing and reporting",
          "features.multiLanguage.title": "Multi-language Support",
          "features.multiLanguage.description": "Seamlessly switch between English and Arabic with full RTL support",
          "features.easyIntegration.title": "Easy Integration",
          "features.easyIntegration.description": "Quick setup with ECR providers and terminal management made simple",
          
          // Quick Tips
          quickTips: "Quick Tips",
          "tips.useRegisteredEmail": "Use your registered email and password to login",
          "tips.enable2FA": "Enable 2FA for enhanced security",
          "tips.contactSupport": "Contact support if you need assistance",
          
          // Placeholders
          emailPlaceholder: "your@email.com",
          passwordPlaceholder: "••••••••",
          
          // Footer
          "footer.copyright": "© {{year}} NeoPaas. All rights reserved.",
          
          // Bulk Upload
          "bulkUpload.title": "Bulk User Upload",
          "bulkUpload.subtitle": "Upload multiple users at once using CSV or XLSX format. Download the template to get started.",
          "bulkUpload.uploadFile": "Upload File",
          "bulkUpload.uploadHint": "Supports CSV and XLSX formats. Ensure the file contains valid data matching the template structure.",
          "bulkUpload.fileSelected": "File selected: {{fileName}}",
          "bulkUpload.noFileSelected": "No file selected",
          "bulkUpload.downloadTemplate": "Download Template",
          "bulkUpload.uploadUsers": "Upload Users",
          "bulkUpload.duplicatedUserName": "Duplicated user name",
          "bulkUpload.duplicatedTerminalIds": "Duplicated Terminal IDs",
          "bulkUpload.invalidRole": "Invalid role",
          "bulkUpload.invalidPassword": "Invalid password",
          "bulkUpload.invalidTerminalId": "Terminal ID must be at least 8 digits and contain numbers only",
          "bulkUpload.totalRows": "Total Rows",
          "bulkUpload.validRows": "Valid Rows",
          "bulkUpload.errorsFound": "Errors Found",
          "bulkUpload.rowsContainErrors": "{{count}} row(s) contain errors",
          "bulkUpload.hoverForErrorDetails": "Hover over highlighted rows below to see error details",
          "bulkUpload.allRowsValidated": "All rows validated successfully",
          "bulkUpload.fileReadyToUpload": "Your file is ready to upload",
          "bulkUpload.dataPreview": "Data Preview",
          "bulkUpload.errorCount": "{{count}} Error",
          "bulkUpload.errorCount_plural": "{{count}} Errors",
          "bulkUpload.noDataToPreview": "No Data to Preview",
          "bulkUpload.uploadFileToSeePreview": "Upload a file to see the preview",
          "bulkUpload.bulkUploadReport": "Bulk Upload Report",
          "bulkUpload.reviewResults": "Review the results of your bulk upload operation",
          "bulkUpload.validationErrors": "Validation Errors",
          "bulkUpload.rowsAffected": "row(s) affected",
          "bulkUpload.successfulRows": "Successful",
          "bulkUpload.failedRows": "Failed",
          "bulkUpload.allRowsUploaded": "All users were uploaded successfully.",
          "bulkUpload.allRowsFailed": "All rows failed to upload. Please review the errors below.",
          "bulkUpload.partialUpload": "{{success}} row(s) uploaded successfully, {{failed}} row(s) failed.",
          "bulkUpload.failedRowsNote": "Rows highlighted in red failed to upload. Correct the issues and re-upload those entries.",
          "bulkUpload.statusColumn": "Status",
          "bulkUpload.downloadFailedRows": "Download Failed Rows ({{count}})",

          // Terminal Bulk Upload
          "terminalBulkUpload.title": "Bulk Terminal Upload",
          "terminalBulkUpload.subtitle": "Upload multiple terminals at once using CSV or XLSX format. Download the template to get started.",
          "terminalBulkUpload.uploadFile": "Upload File",
          "terminalBulkUpload.uploadHint": "Supports CSV and XLSX formats. Each row must include terminalId and terminalModelId.",
          "terminalBulkUpload.uploadTerminals": "Upload Terminals",
          "terminalBulkUpload.bulkUpload": "Bulk Upload",
          "terminalBulkUpload.duplicatedTerminalIds": "Duplicated Terminal ID",
          "terminalBulkUpload.terminalIdRequired": "Terminal ID is required",
          "terminalBulkUpload.terminalIdMustBeNumeric": "Terminal ID must contain only numbers (no letters or special characters)",
          "terminalBulkUpload.invalidTerminalId": "Terminal ID must be exactly 8 or 16 digits",
          "terminalBulkUpload.terminalModelIdRequired": "Terminal Model ID is required",
          "terminalBulkUpload.terminalModelIdMustBeNumeric": "Terminal Model ID must contain only numbers (no letters or special characters)",
          
          // Common - Buttons (additional)
          "common.buttons.saveChanges": "Save Changes",
          "common.buttons.viewAll": "View All",
          "common.buttons.refresh": "Refresh",
          "common.buttons.import": "Import",
          
          // Common - Labels (additional)
          "common.labels.lastUpdated": "Last Updated",
          "common.labels.updatedBy": "Updated By",
          "common.labels.createdBy": "Created By",
          "common.labels.createdAt": "Created At",
          
          // Navigation - Sidebar (additional)
          "navigation.sidebar.syncConfiguration": "Sync Configuration",
          "navigation.sidebar.providerMappings": "Provider Mappings",
          "navigation.sidebar.ecrProviders": "ECR Providers",
          
          // Admin Pages
          "admin.msp.title": "MSP Management",
          "admin.msp.subtitle": "Manage Merchant Service Providers, packages, and terminal models",
          "admin.msp.searchPlaceholder": "Search MSPs, packages, or models...",
          "admin.msp.vendorName": "Vendor Name",
          "admin.msp.packageName": "Package Name",
          "admin.msp.terminalModel": "Terminal Model",
          "admin.msp.terminalBrand": "Terminal Brand",
          "admin.msp.addMsp": "Add MSP",
          "admin.msp.editMsp": "Edit MSP",
          "admin.msp.addPackage": "Add Package",
          "admin.msp.editPackage": "Edit Package",
          "admin.msp.addTerminalModel": "Add Terminal Model",
          "admin.msp.editTerminalModel": "Edit Terminal Model",
          "admin.msp.noMspsFound": "No MSPs found",
          "admin.msp.noPackagesFound": "No packages found",
          "admin.msp.noModelsFound": "No terminal models found",
          
          "admin.brands.title": "Brand Management",
          "admin.brands.searchPlaceholder": "Search brands...",
          "admin.brands.addBrand": "Add Brand",
          "admin.brands.brandName": "Brand Name",
          "admin.brands.terminalsModels": "Terminals Models",
          "admin.brands.terminalModelsList": "Terminal Models List",
          "admin.brands.editBrand": "Edit Brand",
          "admin.brands.enterBrandName": "Enter the brand name",
          "admin.brands.enterTerminalModelName": "Enter the terminal model name",
          "admin.brands.addTerminalModel": "Add Terminal Model",
          "admin.brands.editTerminalModel": "Edit",
          "admin.brands.update": "Update",
          "admin.brands.add": "Add",
          
          "admin.districts.title": "District Management",
          "admin.districts.searchPlaceholder": "Search districts...",
          "admin.districts.districtsManagement": "Districts Management",
          "admin.districts.approve": "Approve",
          "admin.districts.deactivate": "Deactivate",
          "admin.districts.approveTitle": "Approve",
          "admin.districts.approveDesc": "Approving district will make it selectable for all merchants",
          "admin.districts.deactivateTitle": "Deactivate",
          "admin.districts.deactivateDesc": "Deactivating district will make it unselectable for all merchants",
          "admin.districts.yes": "Yes",
          "admin.districts.no": "No",
          "admin.districts.distritcs": "Distritcs",
          
          "admin.merchants.title": "Merchant Management",
          "admin.merchants.searchPlaceholder": "Search merchants...",
          "admin.merchants.merchants": "Merchants",
          "admin.merchants.usersReport": "Users Report",
          "admin.merchants.branchesReport": "Branches report",
          "admin.merchants.noOfBranches": "No. of branches",
          "admin.merchants.reject": "Reject",
          "admin.merchants.approve": "Approve",
          "admin.merchants.rejectUser": "Reject User?",
          "admin.merchants.rejectUserDesc": "This will move this request to rejected tab",
          "admin.merchants.approveUser": "Approve User?",
          "admin.merchants.approveUserDesc": "Approving the user will enable them to access the system",
          "admin.merchants.approveMerchant": "Approve Merchant?",
          "admin.merchants.approveMerchantDesc": "Approving this rejected merchant will enable them to access the system",
          "admin.merchants.merchantDetails": "Merchant Details",
          "admin.merchants.rejected": "Rejected",
          "admin.merchants.onboarded": "Onboarded",
          "admin.merchants.phone": "Phone",
          "admin.merchants.email": "Email",
          
          "admin.providers.searchPlaceholder": "Search providers...",
          "admin.providers.providerDetails": "Provider Details",
          "admin.providers.licenseManagement": "License Management",
          "admin.providers.approveProvider": "Approve Provider",
          "admin.providers.rejectProvider": "Reject Provider",
          "admin.providers.updateLicense": "Update License",
          "admin.providers.ecrProvidersManagement": "ECR Providers Management",
          "admin.providers.manageEcrProviders": "Manage ECR provider accounts, licenses, and access permissions",
          "admin.providers.totalProviders": "Total Providers",
          "admin.providers.activeProviders": "Active Providers",
          "admin.providers.pendingApproval": "Pending Approval",
          "admin.providers.totalLicenses": "Total Licenses",
          "admin.providers.ecrProviderDetails": "ECR Provider Details",
          "admin.providers.currentStatus": "Current Status",
          "admin.providers.providerId": "Provider ID",
          "admin.providers.providerInformation": "Provider Information",
          "admin.providers.fullName": "Full Name",
          "admin.providers.emailAddress": "Email Address",
          "admin.providers.subscriptions": "Subscriptions",
          "admin.providers.noSubscriptions": "No subscriptions",
          "admin.providers.merchant": "Merchant",
          "admin.providers.terminals": "Terminals",
          "admin.providers.status": "Status",
          "admin.providers.planType": "Plan Type",
          "admin.providers.billingCycle": "Billing Cycle",
          "admin.providers.subscriptionEndDate": "Subscription End Date",
          "admin.providers.autoRenewal": "Auto Renewal",
          "admin.providers.yes": "Yes",
          "admin.providers.no": "No",
          "admin.providers.na": "N/A",
          "admin.providers.numberOfSubscriptions": "Number of Subscriptions",
          "admin.providers.loading": "Loading...",
          
          "admin.settings.title": "Admin Settings",
          "admin.settings.pushServiceSettings": "Push Service Settings",
          "admin.settings.websocket": "Websocket",
          "admin.settings.mqtt": "MQTT",
          "admin.settings.pushy": "Pushy",
          "admin.settings.save": "Save",
          "admin.settings.otpSettings": "OTP Verification Settings",
          "admin.settings.otpDescription": "Control whether merchants must verify with OTP when logging in from new devices",
          "admin.settings.otpUpdated": "OTP verification setting updated successfully",
          "admin.settings.otpUpdateFailed": "Failed to update OTP verification setting",
          "admin.settings.enabled": "Enabled",
          "admin.settings.disabled": "Disabled",
          "admin.settings.trxStatusRetrievalDelayTitle": "Status Retrieval Delay",
          "admin.settings.trxStatusRetrievalDelayDescription": "Minimum time an INITIALIZED transaction must age before merchants can manually retrieve its status from the terminal.",
          "admin.settings.trxStatusRetrievalDelayLabel": "Delay",
          "admin.settings.trxStatusRetrievalDelayHint": "Time in minutes before the \"Retrieve Transaction Status\" action becomes available.",
          "admin.settings.trxStatusRetrievalDelayUpdated": "Status retrieval delay updated successfully",
          "admin.settings.trxStatusRetrievalDelayUpdateFailed": "Failed to update status retrieval delay",
          "admin.settings.inactivityPeriodTitle": "Default Inactivity Period",
          "admin.settings.inactivityPeriodDescription": "Default period used to mark a terminal as Inactive for merchants that have not set their own. A terminal with no approved purchase for this long is Inactive.",
          "admin.settings.inactivityPeriodLabel": "Period",
          "admin.settings.inactivityPeriodUpdated": "Default inactivity period updated successfully",
          "admin.settings.inactivityPeriodUpdateFailed": "Failed to update default inactivity period",

          "admin.layout.portalTitle": "Admin Portal",
          
          "admin.syncConfig.title": "Sync Configuration",
          "admin.syncConfig.subtitle": "Configure terminal sync settings",
          "admin.syncConfig.syncInterval": "Sync Interval",
          "admin.syncConfig.minutes": "Minutes",
          "admin.syncConfig.terminalSyncConfiguration": "Terminal Sync Configuration",
          "admin.syncConfig.configureSync": "Configure the synchronization interval for terminal data updates",
          "admin.syncConfig.currentConfiguration": "Current Configuration",
          "admin.syncConfig.updateSyncInterval": "Update Sync Interval",
          "admin.syncConfig.selectPresetInterval": "Select Preset Interval",
          "admin.syncConfig.choosePresetInterval": "Choose a preset interval",
          "admin.syncConfig.or": "OR",
          "admin.syncConfig.enterCustomInterval": "Enter Custom Interval (minutes)",
          "admin.syncConfig.enterCustomIntervalPlaceholder": "Enter custom interval",
          "admin.syncConfig.validRange": "Valid range: 1 - 1440 minutes (1 minute to 24 hours)",
          "admin.syncConfig.changeReason": "Change Reason (Optional)",
          "admin.syncConfig.changeReasonPlaceholder": "Enter reason for this configuration change",
          "admin.syncConfig.saveConfiguration": "Save Configuration",
          "admin.syncConfig.intervalMustBeBetween": "Interval must be at least 1 minute",
          "admin.syncConfig.intervalCannotExceed": "Interval cannot exceed 1440 minutes (24 hours)",
          "admin.syncConfig.intervalMustBeWholeNumber": "Interval must be a whole number",
          "admin.syncConfig.selectOrEnterInterval": "Please select or enter a sync interval",
          "admin.syncConfig.intervalBetweenError": "Sync interval must be between 1 and 1440 minutes",
          "admin.syncConfig.wholeNumberError": "Sync interval must be a whole number",
          "admin.syncConfig.updateSuccess": "Sync configuration updated successfully",
          "admin.syncConfig.updateFailed": "Failed to update sync configuration",
          "admin.syncConfig.invalidValues": "Invalid configuration values",
          "admin.syncConfig.serviceUnavailable": "Service temporarily unavailable. Please try again later.",
          "admin.syncConfig.loadingConfiguration": "Loading configuration...",
          
          "admin.providerMapping.noParametersDefined": "No parameters defined",
          "admin.providerMapping.intentActions": "Intent Actions",
          "admin.providerMapping.addAction": "Add Action",
          "admin.providerMapping.editAction": "Edit Action",
          "admin.providerMapping.deleteAction": "Delete Action",
          "admin.providerMapping.noActionsDefined": "No actions defined",
          
          // ECR Pages
          "ecr.msp.title": "MSP Management",
          "ecr.msp.subtitle": "Manage Merchant Service Providers, packages, and terminal models",
          "ecr.msp.searchPlaceholder": "Search MSPs, packages, or models...",
          "ecr.msp.vendorName": "Vendor Name",
          "ecr.msp.packageName": "Package Name",
          "ecr.msp.terminalModel": "Terminal Model",
          "ecr.msp.terminalBrand": "Terminal Brand",
          "ecr.msp.viewMsps": "View MSPs",
          "ecr.msp.viewPackages": "View Packages",
          "ecr.msp.viewTerminalModels": "View Terminal Models",
          "ecr.msp.mspDetails": "MSP Details",
          "ecr.msp.packageDetails": "Package Details",
          "ecr.msp.modelDetails": "Model Details",
          "ecr.msp.noMspsAvailable": "No MSPs available",
          "ecr.msp.noPackagesAvailable": "No packages available",
          "ecr.msp.noModelsAvailable": "No models available",
          
          "ecr.brands.title": "Brand Management",
          "ecr.brands.searchPlaceholder": "Search brands...",
          "ecr.brands.viewBrands": "View Brands",
          "ecr.brands.brandDetails": "Brand Details",
          
          "ecr.districts.title": "District Management",
          "ecr.districts.searchPlaceholder": "Search districts...",
          
          "ecr.merchants.searchPlaceholder": "Search merchants...",
          
          "ecr.layout.portalTitle": "ECR Portal",

          // MSP Dashboard Pages
          "msp.dashboard.title": "MSP Dashboard",
          "msp.dashboard.subtitle": "Monitor your license pool and merchant portfolio",
          "msp.dashboard.kpi.totalLicenses": "Total Licenses",
          "msp.dashboard.kpi.totalLicensesSub": "Licensed capacity",
          "msp.dashboard.kpi.usedLicenses": "Used Licenses",
          "msp.dashboard.kpi.usedLicensesSub": "Terminals activated",
          "msp.dashboard.kpi.available": "Available",
          "msp.dashboard.kpi.availableSub": "Remaining licenses",
          "msp.dashboard.kpi.activeMerchants": "Active Merchants",
          "msp.dashboard.kpi.activeMerchantsSub": "Merchants with active terminals",
          "msp.dashboard.utilization.title": "License Pool Utilization",
          "msp.dashboard.utilization.activeFrom": "Active from",
          "msp.dashboard.utilization.expires": "Expires",
          "msp.dashboard.utilization.activeTerminals": "Active terminals",
          "msp.dashboard.utilization.suspendedTerminals": "Suspended terminals",
          "msp.dashboard.utilization.availableLicenses": "Available licenses",
          "msp.dashboard.expiry.warning": "Your license pool expires in {{days}} days. Contact your Admin to renew.",
          "msp.dashboard.expiry.expired": "Your license pool has expired. Contact your Admin to renew.",
          "msp.dashboard.terminal.active": "Active Terminals",
          "msp.dashboard.terminal.suspended": "Suspended Terminals",
          "msp.dashboard.terminal.emptySparkline": "No trend data",
          "msp.dashboard.terminal.topSuspended": "Most recently suspended",
          "msp.dashboard.empty.title": "No terminals registered",
          "msp.dashboard.empty.description": "No terminals registered under your license pool yet.",
          "msp.dashboard.actions.viewAllMerchants": "View all merchants →",
          "msp.dashboard.error.noProvider": "No MSP provider linked to your account. Contact your Admin.",
          "msp.billing.title": "Billing",
          "msp.billing.subtitle": "License utilization, billing events, and monthly usage exports",
          "msp.billing.licenseInfo": "MSP License Information",
          "msp.billing.purchasedLicenses": "Purchased Licenses",
          "msp.billing.activeLicenses": "Active Licenses",
          "msp.billing.availableLicenses": "Available Licenses",
          "msp.billing.contract": "Contract",
          "msp.billing.perTerminal": "terminal",
          "msp.billing.eventLog": "Billing Event Log",
          "msp.billing.eventType": "Event",
          "msp.billing.terminal": "Terminal",
          "msp.billing.merchant": "Merchant",
          "msp.billing.billable": "Billable",
          "msp.billing.billableOnly": "Billable only",
          "msp.billing.timestamp": "Timestamp",
          "msp.billing.syncStatus": "Zoho Sync",
          "msp.billing.searchPlaceholder": "Search terminal or merchant…",
          "msp.billing.noEvents": "No billing events",
          "msp.billing.usageSummaries": "Monthly Usage Summaries",
          "msp.billing.period": "Period",
          "msp.billing.billableUnits": "Billable Units",
          "msp.billing.contractType": "Contract",
          "msp.billing.generatedAt": "Generated",
          "msp.billing.export": "Export",
          "msp.billing.merchantCsv": "Merchant CSV",
          "msp.billing.terminalCsv": "Terminal CSV",
          "msp.billing.selectMonth": "Select month",
          "msp.billing.generate": "Generate",
          "msp.billing.generateSuccess": "Usage summary generated",
          "msp.billing.noSummaries": "No usage summaries yet — they are generated automatically on the 28th of each month",
          "msp.billing.shield.warningTitle": "Licenses Running Low",
          "msp.billing.shield.warningBody": "Your available licenses have dropped below {{threshold}}% of your purchased pool. New terminal activations will continue but may incur overage charges.",
          "msp.billing.shield.blockedTitle": "License Limit Reached",
          "msp.billing.shield.blockedBody": "This action requires an available license, but your license pool is exhausted. Purchase additional licenses or suspend another terminal to free one.",
          "msp.billing.shield.warningBanner": "Available licenses are below the warning threshold. Consider purchasing additional licenses.",
          "msp.billing.shield.blockedBanner": "License pool exhausted — reactivations are blocked and new activations incur overage.",
          "msp.billing.shield.acknowledge": "Understood",
          "msp.merchants.title": "Merchants",
          "msp.merchants.count.suffix": "merchants",
          "msp.merchants.search.placeholder": "Search by name or terminal ID…",
          "msp.merchants.filter.status": "Filter by status",
          "msp.merchants.filter.all": "All",
          "msp.merchants.col.merchant": "Merchant",
          "msp.merchants.col.licensed": "Licensed",
          "msp.merchants.col.active": "Active",
          "msp.merchants.col.suspended": "Suspended",
          "msp.merchants.empty.default": "No merchants assigned to your organization yet.",
          "msp.merchants.empty.search": "No merchants match \"{{query}}\"",
          "msp.merchants.tooltip.suspended": "{{count}} terminal(s) suspended",
          "msp.merchants.expand.title": "Terminals (top 5)",
          "msp.merchants.expand.mada": "Mada",
          "msp.merchants.expand.noTerminals": "No terminals in scope.",
          "msp.merchants.expand.viewAll": "View all →",
          "msp.merchants.expand.col.terminalId": "Terminal ID",
          "msp.merchants.expand.col.status": "Status",
          "msp.merchants.expand.col.package": "Package",
          "msp.merchants.drawer.terminalEndpointNote": "Full terminal list will be available once the per-merchant terminal endpoint is integrated.",

          "ecr.providerMapping.intentActions": "Intent Actions",
          "ecr.providerMapping.viewActions": "View Actions",
          "ecr.providerMapping.actionDetails": "Action Details",
          "ecr.providerMapping.parameters": "Parameters",
          "ecr.providerMapping.noActionsAvailable": "No actions available",
          
          // Merchant Pages
          "merchant.dashboard.welcomeBack": "Welcome back",
          "merchant.dashboard.overview": "Overview",
          "merchant.dashboard.welcomeMessage": "Welcome back! Here's your business overview.",
          "merchant.dashboard.live": "Live",
          "merchant.dashboard.todaysHighlights": "Today's Highlights",
          "merchant.dashboard.todayTransactions": "Today's Transactions",
          "merchant.dashboard.todayRevenue": "Today's Revenue",
          "merchant.dashboard.overallStatistics": "Overall Statistics",
          "merchant.dashboard.allTime": "All time",
          "merchant.dashboard.inProgress": "In progress",
          "merchant.dashboard.quickActions": "Quick Actions",
          "merchant.dashboard.viewTransactions": "View Transactions",
          "merchant.dashboard.manageAllTransactions": "Manage all transactions",
          "merchant.dashboard.manageTerminals": "Manage Terminals",
          "merchant.dashboard.viewTerminalStatus": "View terminal status",
          "merchant.dashboard.reconcileTransactions": "Reconcile transactions",
          "merchant.dashboard.recentTransactions": "Recent Transactions",
          "merchant.dashboard.viewAll": "View All",
          "merchant.dashboard.loadingDashboard": "Loading dashboard...",
          "merchant.dashboard.selectBranch": "Select Branch",
          "merchant.dashboard.transactionsReport": "Transactions Report",
          "merchant.dashboard.dateRangeLabel": "Date Range:",
          "merchant.dashboard.to": "To",
          
          "merchant.management.users.title": "User Management",
          "merchant.management.branches.title": "Branch Management",
          "merchant.management.users.addUser": "Add User",
          "merchant.management.users.editUser": "Edit User",
          "merchant.management.branches.addBranch": "Add Branch",
          "merchant.management.branches.editBranch": "Edit Branch",
          "merchant.management.users.selectRole": "Select Role",
          
          "merchant.terminals.title": "Terminal Management",
          "merchant.terminals.searchPlaceholder": "Search terminals...",
          "merchant.terminals.terminalDetails": "Terminal Details",
          "merchant.terminals.connectionStatus": "Connection Status",
          "merchant.terminals.lastSync": "Last Sync",
          
          "merchant.transactions.title": "Transaction History",
          "merchant.transactions.exportTransactions": "Export Transactions",
          
          "merchant.refunds.title": "Refund Management",
          
          "merchant.download.title": "Download Reports",
          
          "merchant.layout.portalTitle": "Merchant Portal",
          
          "merchant.settings.discountRates.title": "Discount Configuration",
          "merchant.settings.discountRates.applyToAll": "Apply to All Terminals",
          
          // Onboarding Pages
          "onboarding.merchant.personal.placeholders.fullName": "Enter your full name",
          "onboarding.merchant.personal.placeholders.username": "Enter your username",
          "onboarding.merchant.personal.placeholders.password": "Enter your password",
          "onboarding.merchant.personal.placeholders.confirmPassword": "Confirm your password",
          
          "onboarding.merchant.business.placeholders.businessName": "Enter business name",
          "onboarding.merchant.business.placeholders.cr": "Enter CR number",
          "onboarding.merchant.business.placeholders.email": "Enter email address",
          "onboarding.merchant.business.placeholders.mobile": "Enter mobile number",
          "onboarding.merchant.business.placeholders.selectBank": "Select your bank",
          
          "onboarding.merchant.branches.placeholders.branchName": "Enter branch name",
          "onboarding.merchant.branches.placeholders.branchAddress": "Enter branch address",
          "onboarding.merchant.branches.placeholders.cashierName": "Enter cashier name",
          "onboarding.merchant.branches.placeholders.cashierUsername": "Enter cashier username",
          "onboarding.merchant.branches.placeholders.terminalId": "Enter terminal ID",
          
          "onboarding.merchant.getStarted": "Get Started",
          "onboarding.merchant.completeProfile": "Complete your profile",
          "onboarding.merchant.emailSent": "Verification email sent",
          
          "onboarding.ecr.title": "ECR Provider Registration",
          "onboarding.ecr.placeholders.companyName": "Enter company name",
          "onboarding.ecr.placeholders.contactPerson": "Enter contact person",
          "onboarding.ecr.placeholders.selectProvider": "Select ECR provider",
          
          // Components
          "components.filter.selectColumns": "Select columns to display",
          "components.filter.searchColumns": "Search columns...",
          
          "components.mobileMenu.menu": "Menu",
          
          "accessibility.closeMenu": "Close menu",
          "accessibility.goBack": "Go back",
          
          "components.reconciliation.createNew": "Create New Reconciliation",
          
          "components.terminal.selectModel": "Select terminal model",
          "clientAppVersion":"NeoPaas client app version",
          "components.layout.pageTitle": "Page Title",
          
          "components.checkout.title": "Checkout",
          
          "components.license.information": "License Information",
          
          "components.merchant.information": "Merchant Information",

ERROR:"Error",
          FAILED:"Failed",
         TIMEOUT:"Timeout",
          
          "components.receipt.details": "Receipt Details",
          "components.receipt.print": "Print Receipt",
          "components.receipt.download": "Download Receipt",
          
          "components.reconciliation.transactions": "Reconciliation Transactions",
          "components.reconciliation.viewDetails": "View Details",
          
          "components.transaction.information": "Transaction Information",
          "components.transaction.paymentDetails": "Payment Details",
          "components.transaction.customerDetails": "Customer Details",
          
          // Auth Pages
          "auth.demo.title": "RSA Encryption Demo",
          "auth.demo.publicKey": "Public Key",
          "auth.demo.privateKey": "Private Key",
          "auth.demo.encrypt": "Encrypt",
          "auth.demo.decrypt": "Decrypt",
          "auth.demo.testMessage": "Test Message",
          
          // Reset Password Page
          "auth.reset.title": "Reset your password",
          "auth.reset.newPassword": "New password",
          "auth.reset.confirmNewPassword": "Confirm new password",
          "auth.reset.resetButton": "Reset password",
          "auth.reset.invalidToken": "Invalid or expired token",
          "auth.reset.success": "Password reset successfully, you can login now.",
          "auth.reset.passwordEmpty": "Password cannot be empty.",
          "auth.reset.passwordsNotMatch": "Passwords do not match.",
          "auth.reset.passwordWeak": "Password is weak.",
          "auth.reset.invalidLink": "Invalid password reset link",
          unknown:"Unknown",
          // Verify Email Page
          "auth.verify.title": "Verify Email",
          "auth.verify.verifying": "Verifying your Email",
          "auth.verify.verified": "Email Verified",
          "auth.verify.success": "Email Verified, you can login now.",
          "auth.verify.invalidToken": "Invalid or expired token",
          "auth.verify.invalidLink": "Invalid password reset link",
          
          // Messages - Success
          "messages.success.saved": "{{entity}} saved successfully",
          "messages.success.created": "{{entity}} created successfully",
          "messages.success.updated": "{{entity}} updated successfully",
          "messages.success.deleted": "{{entity}} deleted successfully",
          "messages.success.activated": "{{entity}} activated successfully",
          "messages.success.deactivated": "{{entity}} deactivated successfully",
          "messages.success.approved": "{{entity}} approved successfully",
          "messages.success.rejected": "{{entity}} rejected successfully",
          "messages.success.uploaded": "File uploaded successfully",
          "messages.success.downloaded": "File downloaded successfully",
          "messages.success.exported": "Data exported successfully",
          "messages.success.imported": "Data imported successfully",
          
          // Messages - Error
          "messages.error.loadFailed": "Failed to load {{entity}}",
          "messages.error.saveFailed": "Failed to save {{entity}}",
          "messages.error.createFailed": "Failed to create {{entity}}",
          "messages.error.updateFailed": "Failed to update {{entity}}",
          "messages.error.deleteFailed": "Failed to delete {{entity}}",
          "messages.error.uploadFailed": "Failed to upload file",
          "messages.error.downloadFailed": "Failed to download file",
          "messages.error.exportFailed": "Failed to export data",
          "messages.error.importFailed": "Failed to import data",
          "messages.error.networkError": "Network error. Please check your connection",
          "messages.error.serverError": "Server error. Please try again later",
          "messages.error.unauthorized": "You are not authorized to perform this action",
          "messages.error.sessionExpired": "Session expired. Please login again",
          "messages.error.notFound": "{{entity}} not found",
          "messages.error.alreadyExists": "{{entity}} already exists",
          "messages.error.invalidData": "Invalid data provided",
          "messages.error.requiredField": "This field is required",
          searchByTIDOrcashier:"Search by Terminal id or cashier name",
          terminalSearchTooltip: "Numbers: search by Terminal ID (TID) · Text: search by cashier username or branch name",
          searchByNameOrId: "Search by name ",
          // Messages - Warning
          "messages.warning.unsavedChanges": "You have unsaved changes. Are you sure you want to leave?",
          "messages.warning.deleteConfirm": "Are you sure you want to delete {{entity}}?",
          "messages.warning.deactivateConfirm": "Are you sure you want to deactivate {{entity}}?",
          "messages.warning.irreversible": "This action cannot be undone",
          "messages.warning.dataLoss": "This action may result in data loss",
          "messages.warning.lowBalance": "Low balance warning",
          "messages.warning.expiringLicense": "License expiring soon",
          searchByUsernameOrBranch:"Search by username or branch name",
          usersSearchTooltip: "Search by username,user id, or branch name",
          branchesSearchTooltip: "Search by branch name or id",
          // Messages - Info
          "messages.info.loading": "Loading...",
          "messages.info.processing": "Processing...",
          "messages.info.pleaseWait": "Please wait...",
          "messages.info.noData": "No data available",
          "messages.info.noResults": "No results found",
          "messages.info.emptyState": "No {{entity}} yet",
          "messages.info.selectItem": "Please select an item",
          "messages.info.uploadInProgress": "Upload in progress...",
          "messages.info.downloadInProgress": "Download in progress...",
          
          // Validation Messages
          "validation.required": "{{field}} is required",
          "validation.invalid": "Invalid {{field}}",
          "validation.tooShort": "{{field}} must be at least {{min}} characters",
          "validation.tooLong": "{{field}} must not exceed {{max}} characters",
          "validation.mustMatch": "{{field1}} and {{field2}} must match",
          "validation.invalidFormat": "Invalid {{field}} format",
          "validation.minValue": "{{field}} must be at least {{min}}",
          "validation.maxValue": "{{field}} must not exceed {{max}}",
          "validation.email.required": "Email is required",
          "validation.email.invalid": "Invalid email address",
          "validation.password.required": "Password is required",
          "validation.password.tooWeak": "Password is too weak",
          "validation.password.mustMatch": "Passwords do not match",
          "validation.phone.required": "Phone number is required",
          "validation.phone.invalid": "Invalid phone number",
          "validation.number.required": "Number is required",
          "validation.number.invalid": "Invalid number",
          "validation.date.required": "Date is required",
          "validation.date.invalid": "Invalid date",
          "validation.url.invalid": "Invalid URL",
          "validation.file.tooLarge": "File size exceeds maximum limit",
          "validation.file.invalidType": "Invalid file type",
          
          // Reconciliation Modal & History
          selectTerminalPlaceholder: "Select Terminal",
          online: "Online",
          offline: "Offline",
          requestStatus: "Request Status",
          success: "Success",

          // Admin Daily Report
          "admin.dailyReport.title": "Daily Transaction Report",
          "admin.dailyReport.subtitle": "View aggregated transaction data for any selected date",
          "admin.dailyReport.branch": "Branch",
          "admin.dailyReport.merchant": "Merchant",
          "admin.dailyReport.cashier": "Cashier",
          "admin.dailyReport.transactions": "Transactions",
          "admin.dailyReport.approved": "Approved",
          "admin.dailyReport.declined": "Declined",
          "admin.dailyReport.refunds": "Refunds",
          "admin.dailyReport.net": "Net",
          "admin.dailyReport.totalTransactions": "Total Transactions",
          "admin.dailyReport.approvedAmount": "Approved Amount",
          "admin.dailyReport.refundAmount": "Refund Amount",
          "admin.dailyReport.declinedCount": "Declined",
          "admin.dailyReport.netAmount": "Net Amount",
          "admin.dailyReport.copySummary": "Copy Summary",
          "admin.dailyReport.downloadPdf": "Download PDF",
          "admin.dailyReport.noData": "No transactions found for this date",
          "admin.dailyReport.loading": "Loading report...",
          "admin.dailyReport.fetchError": "Failed to load daily report",
          "admin.dailyReport.copiedToClipboard": "Copied to clipboard",
          "admin.dailyReport.copyError": "Failed to copy summary",
          "admin.dailyReport.pdfError": "Failed to download PDF",
          "admin.dailyReport.noDataForPdf": "No transactions found for this date",

          // Package Management
          packages: "Packages",
          packagesDescription: "Manage packages for this provider",
          addPackage: "Add Package",
          editPackage: "Edit Package",
          packageName: "Package Name",
          packageNameRequired: "Package name is required",
          packageNameMaxLength: "Package name must be less than 255 characters",
          enterPackageName: "Enter package name",
          packageCreated: "Package created successfully",
          packageUpdated: "Package updated successfully",
          packageDeleted: "Package deleted successfully",
          deletePackageConfirm: "Are you sure you want to delete this package?",
          deletePackageWarning: "This will also delete all associated intent actions and parameters.",
          intentActions: "Intent Actions",
          priority: "Priority",
          priorityRequired: "Priority is required",
          amountInSAR: "Amount in SAR",

          // Role Management
          rolesAndPermissions: "Roles & Permissions",
          roles: "Roles",
          addRole: "Add Role",
          searchByName: "Search by name",
          createRole: "Create Role",
          editRole: "Edit Role",
          deleteRole: "Delete Role",
          assignRole: "Assign Role",
          removeRole: "Remove Role",
          roleName: "Role Name",
          roleDescription: "Description",
          noRolesYet: "No custom roles created yet",
          noCustomRole: "No custom role",
          confirmDeleteRole: "Are you sure you want to delete the role \"{{roleName}}\"? This action cannot be undone.",
          roleCreated: "Role created successfully",
          roleUpdated: "Role updated successfully",
          roleSaved: "Role saved",
          roleDeleted: "Role deleted successfully",
          roleAssigned: "Role assigned successfully",
          roleRemoved: "Role assignment removed",
          roleNameRequired: "Role name is required",
          roleNameTooLong: "Role name must be at most 100 characters",
          roleDescTooLong: "Description must be at most 255 characters",
          roleHasAssignedStaff: "{{count}} staff member(s) are currently assigned this role. Deleting it will not reassign them automatically.",
          roleAssignedCountUnknown: "Couldn't verify how many staff members currently use this role.",
          assignRoleFailed: "Couldn't reassign role, please refresh and try again.",
          pleaseSelectAtLeastOnePermission: "Please select at least one permission",
          customRoles: "Custom Roles",
          standardRoles: "Standard",
          selectRole: "Select Role",
          otherStaff: "Other Staff",
          permissions: "Permissions",
          noPermissionCashierCreate: "You don't have permission to create cashiers.",

          "admin.permissionOwnerType.title": "Permission Owner Types",
          "admin.permissionOwnerType.subtitle": "Assign which account type can be granted each permission",
          "admin.permissionOwnerType.id": "ID",
          "admin.permissionOwnerType.name": "Name",
          "admin.permissionOwnerType.displayLabel": "Display Label",
          "admin.permissionOwnerType.resource": "Resource",
          "admin.permissionOwnerType.ownerType": "Owner Type",
          "admin.permissionOwnerType.search": "Search by name, label, or resource",
          "admin.permissionOwnerType.loadFailed": "Failed to load permissions",
          "admin.permissionOwnerType.updateSuccess": "Permission updated",
          "admin.permissionOwnerType.updateFailed": "Failed to update permission",
          "admin.permissionOwnerType.description": "Description",
          "admin.permissionOwnerType.reset": "Reset to default",
        },
      },
      ar: {
        translation: {
          dashboard: "لوحة التحكم",
          allBranches: "جميع الفروع",
          providedate:"الرجاء إدخال تاريخ",
          successRate: "نسبة نجاح العمليات",
          schema: "شبكة البطاقات",
          totalPurchaseAmount: "إجمالي مبلغ عمليات الشراء",
          totalRefundAmount: "إجمالي مبلغ المعاملات المستردة",
          successfulTransactionsPercentage: "نسبة العمليات الناجحة",
          weeklySales: "المبيعات الأسبوعية",
          weeklyReports: "التقارير الأسبوعية حسب اليوم",
          terminalHealth: "حالة الجهاز",
          inactiveTerminals: "الأجهزة غير المتصلة",
          activeTerminals: "الأجهزة المتصلة",
          totalTerminals: "إجمالي الأجهزة",
          clickToFilter: "انقر للتصفية",
          viewTerminals: "عرض الأجهزة",
          error: "خطأ",
          notifications: "الإشعارات",
          seeAll: "عرض الكل",
          nobusiness: "لا يوجد نشاط تجاري",
          downloadReport: "تحميل التقرير",
        
          dateRange: "نطاق التاريخ",
          reportType: "نوع التقرير",
          resetToDefault: "إعادة التعيين الافتراضي",
          download: "تحميل",
          downloadAll: "تحميل الكل",
          previewingFirst: "معاينة أول",
          downloadForFullList: "قم بتنزيل القائمة الكاملة لعرض جميع المعاملات.",
          of: "من",
          cancel: "إلغاء",
          ok: "موافق",
          merchant: "التاجر",
          MDR:"خصم التاجر",
          VAT: "ضريبة القيمة المضافة",
          fee: "الرسوم",
          selectTerminalPlaceholder:"اختر الجهاز",
          downloadSelectedReceipts: "تحميل الإيصالات المحددة",
          acquirerCode: "رمز البنك",
          transactions: "العمليات",
          showing: "عرض",
          manageColumns: "إدارة الأعمدة",
          selectedColumn: "العمود المحدد",
          grid: "شبكة",
          table: "جدول",
          viewOnMap: "عرض على الخريطة",
          noTerminalsFound: "لم يتم العثور على أجهزة",
          reportEmailQueued: "جارٍ إنشاء التقرير. سيتم إرسال رابط التحميل إلى بريدك الإلكتروني.",
          reportDownloaded: "تم تحميل التقرير",
          reportGenerationFailed: "فشل في إنشاء التقرير",
          reportPdfNotSupportedLarge: "تصدير PDF غير متاح عندما يكون لديك أكثر من {{count}} جهاز. الرجاء اختيار CSV أو XLSX — سيتم إرسال التقرير إلى بريدك الإلكتروني.",
          unassigned: "غير مخصص",
          id: "المعرف",
          uuid: "الرقم المرجعي",
          "card type": "نوع البطاقة",
          amount: "المبلغ",
          card:"بطاقة",
          update: "تحديث",
          percentage: "نسبة مئوية",
          flat: "ثابت",
          processingFeeType: "نوع رسوم المعالجة",
          processingFeePercentage: "رسوم المعالجة (%)",
          processingFeeFlat: "رسوم المعالجة (ثابت)",
          editDiscountRateConfiguration: "تعديل تكوين معدل الخصم",
          createNewDiscountRateConfiguration: "إنشاء تكوين معدل خصم جديد",
                    searchByTIDOrcashier:"إبحث برقم الجهاز او اسم الكاشير",
          terminalSearchTooltip: "أرقام: البحث برقم الجهاز (TID) · نص: البحث باسم مستخدم الكاشير أو اسم الفرع",
          searchByNameOrId: "البحث بالاسم أو الرقم",
          // Validation messages for discount rates
          cardNameIsRequired: "اسم البطاقة مطلوب",
          mdrMustBeBetween0And10: "يجب أن يكون معدل الخصم بين 0 و 10",
          vatMustBeBetween0And20: "يجب أن تكون ضريبة القيمة المضافة بين 0 و 20",
          capLimitMustBeGreaterThanOrEqualTo0: "يجب أن يكون الحد الأقصى أكبر من أو يساوي 0",
          processingFeePercentageMustBeBetween0And100: "يجب أن تكون رسوم المعالجة (%) بين 0 و 100",
          processingFeeFlatMustBeGreaterThanOrEqualTo0: "يجب أن تكون رسوم المعالجة (ثابت) أكبر من أو تساوي 0",
          atLeastOneTerminalMustBeSelected: "يجب تحديد جهاز واحد على الأقل إذا لم يتم تحديد 'تطبيق على جميع الأجهزة'",
          
          // Success/Error messages for settings
          discountRateCreated: "تم إنشاء معدل الخصم",
          discountRateUpdated: "تم تحديث معدل الخصم",
          discountRateDeleted: "تم حذف معدل الخصم",
          deviceDeleted: "تم حذف الجهاز",
          notAllowedToModifyThisDevice: "غير مسموح بتعديل هذا الجهاز",
          pleaseSelectValidTime: "يرجى تحديد وقت صالح",
          updatedSuccessfully: "تم التحديث بنجاح",
          mdrPercentageCannotBeGreaterThan10: "لا يمكن أن تكون نسبة معدل الخصم أكبر من 10%",
          vatPercentageCannotBeGreaterThan15: "لا يمكن أن تكون نسبة ضريبة القيمة المضافة أكبر من 15%",
          processingFeePercentageCannotBeGreaterThan30: "لا يمكن أن تكون نسبة رسوم المعالجة أكبر من 30%",
          filterByCardScheme:"تصفية حسب اسم البطاقة",
          net:"الصافي",
          "terminal id": "رقم الجهاز",
"info.selectTerminal": "يرجى اختيار جهاز",
          "acquirer code": "رمز البنك",

          status: "الحالة",
          cardType: "نوع البطاقة",
          date: "التاريخ",
                    indate: "تاريخ البدء",
          rrn: "الرقم المرجعي للنظام",
          refNumber: "الرقم المرجعي",
          receipt: "الإيصال",
          transactionId: "رقم العملية",
          transactionTimeline: "الجدول الزمني للعملية",
          totalProcessingTime: "إجمالي وقت المعالجة",
          notAvailable: "غير متوفر",
          timelineUnavailable: "الجدول الزمني غير متوفر",
          timelineDataNotAvailable: "بيانات الجدول الزمني غير متوفرة لهذه العملية",
          detailedTimelineNotAvailable: "التفاصيل الزمنية غير متوفرة لهذه العملية",
          action: "إجراء",
          done: "تم",
          settings: "الإعدادات",
          account: "الحساب",
          reconciliation: "الموازنة",
          discountRates: "معدلات الخصم",
          trustedDevices: "الأجهزة الموثوقة",
          confirmationEmailSent: "تم إرسال بريد إلكتروني للتأكيد",
          "Your filters did not return any results.": "لم تُرجع الفلاتر الخاصة بك أي نتائج.",
          "ecrProviderReq": "مزود ECR مطلوب",
          create: "إنشاء",
          // Report validation messages
pleaseSelectAtLeastOneColumn: "يرجى تحديد عمود واحد على الأقل للتقرير",
pleaseSelectAtLeastOneTransactionStatus: "يرجى تحديد حالة عملية واحدة على الأقل",
pleaseSelectValidDateRange: "يرجى تحديد نطاق تاريخ صالح",
pleaseSelectRoleForUser: "يرجى تحديد دور لهذا المستخدم",
pleaseSelectAtLeastOneTransaction: "يرجى تحديد عملية واحدة على الأقل",
"mada app": "تطبيق مدى",
          "cashier name": "اسم الكاشير",
          "branch name": "اسم الفرع",
           "clientAppVersion":"إصدار تطبيق نيوباس",
          edit: "تعديل",
          delete: "حذف",
          searchByUsernameOrBranch:"إبحث بإسم المستخدم او اسم الفرع",
          usersSearchTooltip: "البحث باسم المستخدم أو رقم المستخدم أو اسم الفرع",
          branchesSearchTooltip: "البحث باسم الفرع أو رقم الفرع",
          active: "نشط",
          ownerName:"إسم التاجر",
            businessName:"إسم العمل ",
          inactive: "غير نشط",
          options: "خيارات",
          discountRateConfiguration: "تكوين معدل الخصم",
          cardName: "اسم البطاقة",
          mdr: "معدل الخصم",
          removecashier: "إزالة الكاشير",
          vat: "ضريبة القيمة المضافة",
          capLimit: "الحد الأقصى",
          processingFee: "رسوم المعالجة",
          bank: "البنك",
          reassignCashier: "إعادة تعيين الكاشير",
          cancle: "إلغاء",
          terminals: "الأجهزة",
          applyToAll: "تطبيق على الكل",
          "Select ecr provider: ": "اختر مزود ECR: ",
          save: "حفظ",
                    refunds: "المبالغ المستردة",
          operationSystem: " النظام",
          "Are you licensed with an ECR provider?":"هل لديك ترخيص من مزود ECR؟",
          browser: "المتصفح",
          token:"الرمز",
          addedOn: "أضيف في ",
          cashier:"الكاشير",
          "Only CSV, XLSX, and Excel spreadsheet formats are supported": "تنسيقات CSV و XLSX وجداول بيانات Excel مدعومة فقط",
          uploading: "جاري التحميل",
          startSettlement: "بدء التسوية",
          parsingFile: "جاري تحليل الملف",
          processingSettlement: "جاري معالجة التسوية",
          pleaseWait: "يرجى الانتظار...",
          noDataAvailable: "لا توجد بيانات متاحة",
          pleaseEnterValidEmail:"الرجاء إدخال بريد إلكتروني صالح",

          // Duplicate detection
          duplicateTransactionsDetected: "تم اكتشاف معاملات مكررة",
          duplicateTransactionsDescription: "تم العثور على {{count}} معاملة مكررة في الملف المرفوع",
          duplicateSummary: "ملخص التكرارات",
          totalDuplicates: "إجمالي التكرارات",
          duplicatesByRRN: "التكرارات حسب RRN",
          duplicatesByTransaction: "التكرارات حسب تطابق المعاملة",
          duplicateRRN: "RRN مكرر",
          duplicateTransaction: "معاملة مكررة",
          duplicate: "مكرر",
          originalTransaction: "المعاملة الأصلية",
          removeDuplicatesAndContinue: "إزالة التكرارات والمتابعة",
          duplicatesRemovedSuccessfully: "تم إزالة {{count}} تكرار بنجاح",
          uploadBankStatementHint: "قم بتحميل كشف حساب البنك الخاص بك بتنسيق CSV. تأكد من أن الملف يحتوي على بيانات صالحة.",
          uploadFailed: "فشل التحميل.",
          pleaseSelectDateRange: "يرجى تحديد نطاق تاريخ",
          settlementReport: "تقرير التسوية",
          filePreview: "معاينة الملف",
          no: "رقم",
          from: "من",
          to: "إلى",
          reportRange: "نطاق التقرير",
          bankSettlementTotal: "إجمالي تسوية البنك",
          totalAmountInNeoPaaSPortal: "إجمالي المبلغ في بوابة نيوباس",
          difference: "الفرق",
          noOfTransactionsInTheBankSettlementFile: "عدد العمليات في ملف تسوية البنك",
          existsInFileOnly: "موجود في الملف فقط",
          existsInSystemOnly: "موجود في النظام فقط",
          noOfTransactionsInNeoPaasPortal: "عدد العمليات في بوابة نيوباس",
          matched: "متطابق",
          mismatched: "غير متطابق",
          transactionSummary: "ملخص العمليات",
          financialBreakdown: "التفصيل المالي",
          bankSettlement: "تسوية البنك",
          neoPaaSPortal: "بوابة نيوباس",
          detailedTransactions: "العمليات التفصيلية",
          totalMDRInBankSettlement: "إجمالي خصم التاجر في تسوية البنك",
          totalVATInBankSettlement: "إجمالي ضريبة القيمة المضافة في تسوية البنك",
          totalNetInBankSettlement: "إجمالي الصافي في تسوية البنك",
          totalMDRInNeoPaasPortal: "إجمالي خصم التاجر في بوابة نيوباس",
          totalVATInNeoPaasPortal: "إجمالي ضريبة القيمة المضافة في بوابة نيوباس",
          totalNetInNeoPaasPortal: "إجمالي الصافي في بوابة نيوباس",
          matchedTransactions: "العمليات المتطابقة",
          missingTransactions: "العمليات المفقودة",
          extraTransactions: "العمليات الإضافية",
          missingRRN: "الرقم المرجعي مفقود",
          amountMissmatch: "عدم تطابق المبلغ",
          acquiererCodeMissmatch: "عدم تطابق رمز البنك",
          cardMissmatch: "عدم تطابق البطاقة",
          incompleteTransactions: "عمليات غير مكتملة",
          mdrMissmatch: "عدم تطابق خصم التاجر",
          vatMissmatch: "عدم تطابق ضريبة القيمة المضافة",
          feeMissmatch: "عدم تطابق الرسوم",
          netAmountMissmatch: "عدم تطابق المبلغ الصافي",
          typeMissmatch: "عدم تطابق النوع",
          transactionsMissingFromFile: "عمليات مفقودة من الملف",
          transactionsMissingFromSystem: "عمليات مفقودة من النظام",
          exportCsv: "تصدير CSV",
          print: "طباعة",
          close: "إغلاق",
          noFileUploaded: "لم يتم تحميل ملف بعد",
          transactionStatus: "حالة العملية",
          initialized: "مهيأ",
          pending: "قيد الانتظار",
          approved: "مكتمل",
          canceled: "ملغى",
          DECLINED: "مرفوضة",
          terminalNotConnected: "الجهاز غير متصل",
          "no terminal": "لا يوجد جهاز",
          "missconfiguration": "خطأ في الإعداد",
          "Missconfiguration": "Missconfiguration",

          "timeout": "انتهى الوقت",

          transactionSchema: "نوع شبكة بطاقة العملية",
          mada: "مدى",
          visa: "فيزا",
          
          enterTheCode:"التحقق من الرمز",
          codeSent:"تم إرسال رمز تحقق في الايميل الخاص بك",
          code:"الرمز",
          mastercard: "ماستركارد",
          jcb: "جي سي بي",
          apply: "تطبيق",
          fileFormat: "تنسيق الملف",
          startDate: "تاريخ البداية",
          endDate: "تاريخ النهاية",
          selectedRange: "النطاق المحدد",
          columnsToInclude: "الأعمدة المطلوبة",
          schemes: "شبكات البطاقات",
          scheme: "شبكة البطاقة",
          checkAll: "تحديد الكل",
          exportSettings: "إعدادات التصدير",
          branchDetails: "تفاصيل الفرع",
          branchName: "الفرع",
          branchAddress: "عنوان الفرع",
          paymentInfo: "معلومات الدفع",
          customerInfo: "معلومات العميل",
          downloadReceipt: "تحميل الإيصال",
          madaApp: "تطبيق مدى",
          madaId: "معرف مدى",
          location: "الموقع",
          terminalDetails: "تفاصيل الجهاز",
          terminalReset: "إعادة تعيين الجهاز",
          terminalResetDescription: "استخدم هذه الميزة لإلغاء المعاملات الجارية أو إعادة تعيين اتصال API الخاص بالجهاز قبل انتهاء فترة المهلة الزمنية.",
          terminalResetWarning: "⚠️ سيؤدي هذا إلى مقاطعة أي معالجة معاملة نشطة على الجهاز.",
          resetTerminalApi: "إعادة تعيين API الجهاز",
          cashierName: "الكاشير",
          cashierUsername: "اسم مستخدم الكاشير",
          financeUsername: "إسم مستخدم المالية ",
          terminalManagerUsername: "اسم مستخدم مدير الأجهزة",
          financeEmail: "البريد الإلكتروني للمالية",
          terminalManagerEmail: "البريد الإلكتروني لمدير الأجهزة",
          cashierId: " معرف الكاشير ",
          financeId: " معرف المالية ",
          terminalManagerId: "معرف مدير الأجهزة",
          model: "الموديل",
          terminalNo: "رقم الجهاز",
          "OTP must be 6 digits":"يجب أن يكون رمز التحقق مكونًا من 6 أرقام",
          version: "الإصدار",
          ipAddress: "عنوان IP",

          serialNo: "الرقم التسلسلي",
          brand: "العلامة التجارية",
          deviceInfo: "معلومات الجهاز",
          batteryLevel: "مستوى البطارية",
          bluetooth: "البلوتوث",
          bluetoothConnection: "اتصال البلوتوث",
          wifi: "الشبكة اللاسلكية",
          wifiConnection: "اتصال الشبكة اللاسلكية",
          reportenttoyouremailSuccessfully: "يتم حالياً توليد تقرير المعاملات الخاص بك. سيتم إرسال رابط تحميل آمن إلى بريدك الإلكتروني فور جاهزية التقرير",
          manufacturer: "الشركة المصنعة",
          madaAppInstalled: "تطبيق مدى مثبت",
          updatedOn: "تم التحديث في",
          totalRequests: "إجمالي الطلبات",
          versionCode: "رمز الإصدار",
          providers:"المزودين",
          declined: "مرفوضة",
          management: "الإدارة",
bulkUpload: "رفع ملف",
          cashiers: "الكاشيرات",
          financ: "المالية",
          terminalManagers: "مديرو الأجهزة",
          reconStatus: "حالة الموازنة",
          users: "المستخدمين",
          branches: "الفروع",
          username: "اسم المستخدم",
          reconciliationHistory: "تاريخ الموازنة",
          role: "نوع المستخدم",
          userStatus: "حالة المستخدم",
          manageUser: "إدارة الحالة ونوع المستخدم الحالي لهذا المستخدم.",
          activate: "تفعيل",
          address: "العنوان",
          noOfTerminals: "عدد الأجهزة المعينة",
          branchStatus: "حالة الفرع",
          manageBranch: "إدارة الحالة الحالية لهذا الفرع.",
          branchCode: "رمز الفرع",
          deactivateBranchWarning: "هل تريد إلغاء تفعيل هذا الفرع؟ سيؤدي الإلغاء إلى إيقاف جميع المعاملات والأنشطة لهذا الفرع.",
          deactivateBranch: "إلغاء تفعيل الفرع",
          activateBranch: "تفعيل الفرع",
          deactivateuserWarning: "هل تريد إلغاء تفعيل هذا المستخدم؟ سيؤدي إلى منع وصوله للنظام",
          deactivateUser: "إلغاء تفعيل المستخدم",
          activateUser: "تفعيل المستخدم",
          editName: "تعديل الاسم",
          usernameAlreadyExists: "اسم المستخدم موجود مسبقاً",
          invalidRequestData: "بيانات الطلب غير صالحة",
          pleaseEnterName: "يرجى إدخال الاسم",
          nameUpdated: "تم تحديث الاسم بنجاح",
          errorUpdatingName: "خطأ في تحديث الاسم",
          logout: "تسجيل الخروج",
          password: "كلمة المرور",
       
          conpassword: "تأكيد كلمة المرور",
          login: "تسجيل دخول",
          loginToYourAccount: "تسجيل الدخول",
          unknown:"غير معروف",
          menu: "القائمة",
          search: "بحث",
          TerminalConnectionUpdates: "ستظهر تحديثات اتصال الجهاز هنا",
          madeWith: "عملية",
          filters: "تخصيص",
          type: "النوع",
          cardScheme: "شبكة البطاقة",
          filterTransactions: "فلاتر العمليات",
          Page: "صفحة",
          results: "النتائج",
          selectListColumns: "اختر الأعمدة التي ستظهر في القائمة",
          applyFilters: "حدد الفلاتر لإظهار النتائج المطلوبة",
          addTerminal: "إضافة جهاز",
          terminalModel: "موديل الجهاز",
          madaPackage: "حزمة مدى",
          selectTerminalModel: "اختر موديل الجهاز",
          selectMadaPackage: "اختر حزمة مدى",
          provider: "مزود الخدمة",
          selectTerminalProvider: "اختر مزود الخدمة",
          INITIALIZED: "مهيأ",
          APPROVED: "مقبولة",
          TERMINAL_NOT_CONNECTED: "غير متصل",
          CANCELED: "ملغى",
          PENDING: "معلق",
          details: "التفاصيل",
          newRecon: "تسوية جديدة",
          terminal: "الجهاز",
         
          makeNewRecon: "عمل تسوية جديدة",
          balanced: "متعادل",
          reconciliations: "الموازنات",
          reconDetails: "تفاصيل الموازنة",
          adduser: "إضافة مستخدم",
          addbranch: "إضافة فرع",
          fullname: "الإسم الكامل",
          selectabranch: "إختر فرع",
          selectarole: "إختر نوع المستخدم",
          selectaterminal: "إختر جهاز",
          createnewuser: "إضافة مستخدم جديد",
          createnewusersub: "إضافة مستخدم جديد إلى النظام الخاص بك",
          createnewbranch: "إضافة فرع جديد",
          createnewbranchsub: "إضافة فرع جديد إلى النظام الخاص بك",
          purchase: "شراء",
          refund: "إسترداد",
          terminalId: "رقم الجهاز",
          failed: "فشل",
          merchantOnBoarding: "تسجيل التاجر",
          addCashier: "إضافة تاجر جديد وتفاصيله إلى النظام",
          personalInformation: "المعلومات الشخصية",
          businessInformation: "المعلومات التجارية",
          brachMsp: "الفروع، مزود الخدمة ...",
          step1: "الخطوة 1",
          confirmPassword: "تأكيد كلمة المرور",
          next: "التالي",
          back: "السابق",
          passwordtooweak: "كلمة المرور ضعيفة جدًا. يرجى اختيار كلمة مرور أقوى تحتوي على 8 أحرف على الأقل، وحرف كبير، وحرف صغير، ورقم، وحرف خاص.",
          step2: "الخطوة 2",
          buisinessName: "اسم النشاط التجاري",
          cr: "السجل التجاري",
          email: "البريد الإلكتروني",
          mobileNumber: "رقم الجوال",
          withNetOf: "مع صافي",
          fromTotalOf: "من إجمالي",
          selectCardScheme: "اختر شبكة البطاقة",
          "Incorrect OTP": "رمز التحقق غير صحيح",
          selectTerminals: "اختر الأجهزة",
          total:"إجمالي",
          SAR:"ر.س",
          USD:"دولار",
          EUR:"يورو",
          GBP:"جنيه إسترليني",
          selectBank: "اختر البنك",
          step3: "الخطوة 3",
          branchesMspCashier: "الفروع، مزود الخدمة والكاشير",
          addBranch: "إضافة فرع",
          branch: "فرع",
       
          addCashiera: "إضافة كاشير",
          removeCashier: "إزالة كاشير",
          removeBranch: "إزالة فرع",
          name: "الاسم",
          cashierUserName: "اسم مستخدم الكاشير",
          cashierPassword: "كلمة مرور الكاشير (يجب تغييرها عند أول تسجيل دخول)",
          msp: "مزود الخدمة",
          selectMsp: "اختر مزود الخدمة",
          fullNameReq: "الاسم الكامل مطلوب",
          invalidFullName: "الاسم الكامل غير صالح",
          usernameReq: "اسم المستخدم مطلوب",
          invalidUserNameReq: "اسم المستخدم غير صالح",
          passwordReq: "كلمة المرور مطلوبة",
          unbalanced: "غير متوازن",
          "Session Ended, please login again": "انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى",
          passwordNotMatch: "كلمات المرور غير متطابقة",
          businessNameReq: "اسم النشاط التجاري مطلوب",
          invalidBusinessName: "اسم النشاط التجاري غير صالح",
          crReq: "السجل التجاري مطلوب",
          invalidCr: "السجل التجاري غير صالح",
          emailReq: "البريد الإلكتروني مطلوب",
          invalidEmail: "البريد الإلكتروني غير صالح",
          mobileNumberReq: "رقم الجوال مطلوب",
          invalidMobileNumber: "رقم الجوال غير صالح",
          bankSelectionReq: "اختيار البنك مطلوب",
          addOneBranch: "أضف فرعًا واحدًا على الأقل",
          branchNameReq: "اسم الفرع مطلوب",
          invalidBranchNAme: "اسم الفرع غير صالح",
          branchAddressReq: "عنوان الفرع مطلوب",
          invalidBranchAddress: "عنوان الفرع غير صالح",
          addOnecashier: "أضف كاشيرًا واحدًا على الأقل",

          cashierNameReq: "اسم الكاشير مطلوب",
          invalidCashierName: "اسم الكاشير غير صالح",
          cashierPasswordReq: "كلمة مرور الكاشير مطلوبة",
          invalidCashierPassword: "كلمة مرور الكاشير غير صالحة",
          mspReq: "مزود الخدمة مطلوب",
          terminalModelReq: "طراز الجهاز مطلوب",
          terminalIdReq: "معرف الجهاز مطلوب",
          onboardingSuccess: "تم التسجيل بنجاح",
          creditCount: "عدد الائتمان",
          creditTotal: "إجمالي الائتمان",
          debitCount: "عدد الخصم",
          debitTotal: "إجمالي الخصم",
          madaHost: "مضيف مدى",
          discrepency: "التفاوت",
          ballanced: "متوازن",
          posTerminal: "جهاز نقاط البيع",
          reconciliationReport: "تقرير الموازنة",
          fullName: "الإسم الكامل",
          settlement: "التسوية",
          terminalStatus: "حالة الجهاز",
          region: "المنطقة",
          city: "المدينة",
          district: "الحي",
terminalIdLength: "يجب أن يكون رقم الجهاز بين 8 و 16 رقماً",
terminalIdNumbersOnly: "يجب أن يحتوي رقم الجهاز على أرقام فقط",
          reset: "إعادة تعيين كلمة المرور",
          resetyour: "إعادة تعيين كلمة المرور الخاصة بك",
          emailv: "تأكيد البريد الإلكتروني",
          validEmail: "يرجى إدخال عنوان بريد إلكتروني صالح.",
          discounts: "الخصومات",
             discount: "الخصم",
          netAmount: "صافي المبلغ",
         
         
          reportFile: "اسم ملف التقرير",
          totalAmountInNeoPaasPortal: "إجمالي المبلغ في بوابة NeoPaas",
          noOfTransactionsInBankSettlementFile: "عدد العمليات في ملف التسوية البنكية",
          totalMdrInBankSettlement: "إجمالي MDR في التسوية البنكية",
          totalVatInBankSettlement: "إجمالي ضريبة القيمة المضافة في التسوية البنكية",
          totalMdrInNeoPaasPortal: "إجمالي MDR في بوابة NeoPaas",
          totalVatInNeoPaasPortal: "إجمالي ضريبة القيمة المضافة في بوابة NeoPaas",
          missingRrn: "الرقم المرجعي المفقود",
          amountMismatch: "عدم تطابق المبلغ",
          acquirerCodeMismatch: "عدم تطابق رمز البنك",
          cardMismatch: "عدم تطابق البطاقة",
          mdrIssues: "مشاكل MDR",
          vatIssues: "مشاكل ضريبة القيمة المضافة",
          feeIssues: "مشاكل الرسوم",
          netIssues: "مشاكل الصافي",
          transactionComparison: "مقارنة العمليات",
          totalTransactions: "إجمالي العمليات",
          financialSummary: "الملخص المالي",
          transactionDetails: "تفاصيل العمليات",
          summary: "الملخص",
          totalMDR: "إجمالي MDR",
          totalVAT: "إجمالي ضريبة القيمة المضافة",
          totalNet: "إجمالي الصافي",
          clickOrDragToUpload: "انقر أو اسحب الملف إلى هذه المنطقة لتحميله",
          onlyCsvXlsxExcelSupported: "فقط تنسيقات CSV وXLSX وExcel مدعومة",
          userInformationSettings: "إعدادات معلومات المستخدم",
          emailVerificationRequired: "مطلوب التحقق من البريد الإلكتروني",
          emailVerificationDescription: "يرجى التحقق من بريدك الإلكتروني للمتابعة.",
          actionCanceled: "تم إلغاء الإجراء.",
          changePassword: "تغيير كلمة المرور",
          passwordResetDescription: "سيتم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.",
          sendPasswordResetLink: "إرسال رابط إعادة تعيين كلمة المرور",
          removeTrustedDevice: "إزالة الجهاز الموثوق",
          removeTrustedDeviceDescription: "هل أنت متأكد أنك تريد إزالة هذا الجهاز الموثوق؟",
          removeDevice: "إزالة الجهاز",
          autoReconciliation: "الموازنة التلقائية",
          autoReconciliationTime: "وقت الموازنة التلقائية",
          receiveReconciliationStatusViaEmail: "تلقي حالة التسوية عبر البريد الإلكتروني",
          reconciliationSettings: "إعدادات الموازنة",
branchScope: "نطاق الفرع",
          singleBranch: "فرع واحد",
         singleBranchDesc: "تقييد وصول حساب المالية على فرع محدد فقط",
          allBranchesDesc: "السماح لحساب المالية بالوصول إلى جميع الفروع",
          // Response Timeout Settings
          responseTimeout: "مهلة الاستجابة",
          responseTimeoutSettings: "إعدادات مهلة الاستجابة",
          timeoutInformation: "معلومات المهلة",
          timeoutDescription: "قم بتكوين الحد الأقصى للوقت (بالثواني) للانتظار للحصول على استجابة من أجهزة الدفع. هذا يؤثر على وقت معالجة المعاملات.",
          currentTimeout: "المهلة الحالية",
          newTimeoutValue: "قيمة المهلة الجديدة",
          seconds: "ثانية",
          timeoutRange: "النطاق المسموح",
          timeoutMustBeBetween5And300: "يجب أن تكون المهلة بين 5 و 300 ثانية",
          timeoutUpdatedSuccessfully: "تم تحديث المهلة بنجاح",
          failedToLoadTimeout: "فشل تحميل إعدادات المهلة",
          failedToUpdateTimeout: "فشل تحديث المهلة",
          viewOnly: "عرض فقط",
          merchantCanEditInSettings: "يمكن للتاجر تعديل هذا في إعداداته",
          companyInfo: "معلومات الشركة",
          companyName: "اسم الشركة",
          companyAddress: "عنوان الشركة",
          adjustTimeout: "ضبط المهلة",
          quickPresets: "إعدادات سريعة",
          fineTune: "ضبط دقيق",
          allStatuses:"كل الحالات",
          connectionStatus: "حالة الاتصال",
          terminalStatusHint: "يتم التحديث ليلاً. قد يبقى الجهاز الذي أجرى عملية للتو غير نشط حتى التحديث التالي.",
          noResultsOnThisPage: "لا توجد أجهزة في هذه الصفحة تطابق فلتر الاتصال. جرّب صفحة أخرى.",
          lastQualifyingTransaction: "آخر عملية مؤهلة",
          daysSinceLastTransaction: "الأيام منذ آخر عملية مؤهلة",
          neverTransacted: "لا توجد عملية مؤهلة بعد",
          newlyActivated: "مفعّل حديثاً",
          lastConnection: "آخر اتصال",
          neverConnected: "لم يتصل مطلقاً",
          monthlyTransactionValue: "قيمة العمليات الشهرية",
          monthlyValueFlag: "الحد الشهري",
          metThreshold: "تم بلوغ الحد",
          belowThreshold: "أقل من الحد",
          lowTransactionFee: "رسوم انخفاض العمليات",
          activity: "النشاط",
          today: "اليوم",
          never: "أبداً",
          daysCount_zero: "{{count}} يوم",
          daysCount_one: "{{count}} يوم",
          daysCount_two: "{{count}} يوم",
          daysCount_few: "{{count}} أيام",
          daysCount_many: "{{count}} يوماً",
          daysCount_other: "{{count}} يوم",
          inactivitySettings: "إعدادات عدم النشاط",
          valueMustBeBetween: "يجب أن تكون القيمة بين {{min}} و {{max}}",
          inactivityPeriod: "فترة عدم النشاط",
          inactivityPeriodHelp: "يظهر الجهاز غير نشط إذا لم تتم عليه عملية شراء ناجحة خلال هذه الفترة. تُعد الأجهزة المفعّلة حديثاً نشطة لمدة فترة واحدة.",
          minMonthlyThreshold: "الحد الأدنى الشهري للعمليات (ريال)",
          minMonthlyThresholdHelp: "تُعلَّم الأجهزة التي يقل إجماليها منذ بداية الشهر عن هذا الحد.",
          lowTransactionFeeHelp: "للعرض فقط. لا يتم تحصيل أي رسوم من النظام.",
          inactivitySettingsSaved: "تم حفظ إعدادات عدم النشاط",
          terminalsChangedStatus: "تغيّرت حالة {{count}} جهاز",
          terminalsChangedMonthlyFlag: "تغيّر مؤشر الحد الشهري لـ {{count}} جهاز",
          inactivityChangeSummaryIncomplete: "قد يكون ملخص التغييرات غير مكتمل.",
          failedToLoadInactivityConfig: "تعذر تحميل إعدادات عدم النشاط",
          failedToUpdateInactivityConfig: "تعذر حفظ إعدادات عدم النشاط",
          retry: "إعادة المحاولة",
          userLoggedIn:"حالة المستخدم",
          merchantToken: "رمز التاجر",
          merchantTokenDescription: "قم بتكوين رمز تكامل Neoleap الخاص بك لمعالجة المعاملات",
          neoleapToken: "رمز Neoleap",
          enterNeoleapToken: "أدخل رمز Neoleap الخاص بك",
          neoleapTokenOptional: "اختياري: يمكنك إضافة هذا الرمز لاحقًا في الإعدادات",
          tokenCannotBeEmpty: "لا يمكن أن يكون الرمز فارغًا",
          tokenTooShort: "يجب أن يكون الرمز 10 أحرف على الأقل",
          tokenUpdatedSuccessfully: "تم تحديث الرمز بنجاح",
          failedToFetchToken: "فشل جلب الرمز",
          failedToUpdateToken: "فشل تحديث الرمز",
          saveChanges: "حفظ التغييرات",
          veryFast: "سريع جداً",
          fast: "سريع",
          moderate: "معتدل",
          slow: "بطيء",
          verySlow: "بطيء جداً",
          
          discountFeesByCardScheme: "رسوم الخصم حسب شبكة البطاقة",
          discountFeesByTerminal: "رسوم الخصم حسب الجهاز",
          totalDiscount: "إجمالي الخصم",
          terminalDiscountBreakdown: " (كل الفترات)تفصيل الخصم حسب الجهاز",
          terminalDiscountDetails: "تفاصيل خصم الجهاز",
          searchByTerminalNo: "البحث برقم الجهاز",
          ascending: "تصاعدي",
          descending: "تنازلي",
          noData: "لا توجد بيانات",
          sortBy: "ترتيب حسب",
          verify:"التحقق" ,
          schemeDiscountBreakdown: "تفصيل الخصم حسب الشبكة",
          contributionByScheme: "المساهمة حسب الشبكة",
          allTimeDiscountFeesByTerminal: "إجمالي رسوم الخصم حسب الجهاز",
          allTimeTerminalDiscountBreakdown: "تفصيل إجمالي الخصم حسب الجهاز",
          "Sorry, the page you visited does not exist": "عذراً، الصفحة التي تحاول الوصول إليها غير موجودة",
          "Go to Home": "الذهاب إلى الصفحة الرئيسية",
          404: "404",
          500: "500",
          "Sorry, something went wrong": "عذراً، حدث خطأ ما",
          403: "403",
          "Sorry, you are not authorized to access this page": "عذراً، أنت غير مخول للوصول إلى هذه الصفحة",
          401: "401",
          "Session Expired": "انتهت الجلسة",
          "Please login again": "يرجى تسجيل الدخول مرة أخرى",
          400: "400",
          "Bad Request": "طلب غير صالح",
          503: "503",
          "Service Unavailable": "الخدمة غير متوفرة",
          504: "504",
          "Gateway Timeout": "انتهت مهلة البوابة",
          502: "502",
          "Bad Gateway": "بوابة غير صالحة", 
          "Email is not verified": "البريد الإلكتروني غير مفعل",
          "Account deactivated": "الحساب معطل",
          "Account is pending for activation, please wait for activation or contact support for more assistance.": "الحساب قيد التفعيل، يرجى الانتظار أو الاتصال بالدعم للحصول على مزيد من المساعدة.",
          "Your registration has been rejected, please contact support for more assistance.": "تم رفض تسجيلك، يرجى الاتصال بالدعم للحصول على مزيد من المساعدة.",
          "Account branch deactivated": "فرع الحساب معطل",
          "Incorrect username or password": "اسم المستخدم أو كلمة المرور غير صحيحة",
          
          // ECR Dashboard
          "ecr.dashboard.title": "لوحة تحكم مزود ECR",
          "ecr.dashboard.subtitle": "راقب التجار والأجهزة واستخدام التراخيص",
          "ecr.dashboard.associatedMerchants": "التجار المرتبطين",
          "ecr.dashboard.activeMerchants": "التجار النشطون",
          "ecr.dashboard.totalTerminals": "إجمالي الأجهزة",
          "ecr.dashboard.acrossAllMerchants": "عبر جميع التجار",
          "ecr.dashboard.totalLicenses": "إجمالي التراخيص",
          "ecr.dashboard.purchasedLicenses": "التراخيص المشتراة",
          "ecr.dashboard.remainingLicenses": "التراخيص المتبقية",
          "ecr.dashboard.licensesAvailable": "تراخيص متاحة",
          "ecr.dashboard.lowLicensesWarning": "توفر تراخيص منخفض",
          "ecr.dashboard.noLicensesRemaining": "لا توجد تراخيص متاحة",
          "ecr.dashboard.pendingLicenseAssignment": "في انتظار تعيين المسؤول",
          "ecr.dashboard.awaitingAdminAssignment": "في انتظار تعيين المسؤول",
          "ecr.dashboard.licenseAssignmentRequired": "مطلوب تعيين الترخيص",
          "ecr.dashboard.licenseAssignmentDescription": "حسابك في انتظار تعيين الترخيص من المسؤول. يرجى الاتصال بالدعم لتخصيص التراخيص لحسابك.",
          "ecr.dashboard.totalMerchants": "إجمالي التجار",
          "ecr.dashboard.merchantsSubtitle": "التجار المرتبطين",
          "ecr.dashboard.activeTerminals": "الأجهزة النشطة",
          "ecr.dashboard.terminalsSubtitle": "الأجهزة قيد الاستخدام",
          "ecr.dashboard.licensesSubtitle": "التراخيص المشتراة",
          "ecr.dashboard.consumedLicenses": "التراخيص المستهلكة",
          "ecr.dashboard.consumed": "مستهلك",
          "ecr.dashboard.daysUntilExpiry": "الأيام حتى الانتهاء",
          "ecr.dashboard.daysRemaining": "يوم متبقي",
          "ecr.dashboard.expiringWarning": "ينتهي قريباً!",
          "ecr.dashboard.licenseConsumption": "استهلاك التراخيص",
          "ecr.dashboard.licenseWarning": "اقتراب حد التراخيص",
          "ecr.dashboard.licenseCritical": "تم الوصول إلى حد التراخيص",
          "ecr.dashboard.licenseTrend": "اتجاه التراخيص",
          "ecr.dashboard.last12Months": "آخر 12 شهرًا",
          "ecr.dashboard.licenseBreakdown": "تفصيل التراخيص",
          "ecr.dashboard.byMerchant": "حسب التاجر",
          "ecr.dashboard.licenses": "تراخيص",
          "ecr.dashboard.merchantList": "قائمة التجار",
          "ecr.dashboard.errorLoadingSummary": "فشل تحميل ملخص لوحة التحكم. يرجى المحاولة مرة أخرى.",
          "ecr.dashboard.errorLoadingMerchants": "فشل تحميل التجار. يرجى المحاولة مرة أخرى.",
          "ecr.dashboard.errorLoadingCharts": "فشل تحميل بيانات الرسوم البيانية",
          "ecr.dashboard.errorLoadingMerchantDetails": "فشل تحميل تفاصيل التاجر. يرجى المحاولة مرة أخرى.",
          loading: "جاري التحميل...",
          merchantName: "اسم التاجر",
          merchantId: "معرف التاجر",
          merchantDetails: "تفاصيل التاجر",
          onboardingDate: "تاريخ التسجيل",
          viewDetails: "عرض التفاصيل",
          clearFilters: "مسح الفلاتر",
          activeFilters: "الفلاتر النشطة",
          
          // ECR Provider Management
          "ecr.admin.title": "إدارة مزودي ECR",
          "ecr.admin.subtitle": "إدارة حسابات مزودي ECR والتراخيص وصلاحيات الوصول",
          "ecr.admin.totalProviders": "إجمالي المزودين",
          "ecr.admin.activeProviders": "المزودون النشطون",
          "ecr.admin.pendingApproval": "في انتظار الموافقة",
          "ecr.admin.totalLicenses": "إجمالي التراخيص",
          "ecr.admin.providerInfo": "معلومات المزود",
          "ecr.admin.usageStats": "إحصائيات الاستخدام",
          "ecr.admin.licenseInfo": "معلومات الترخيص",
          "ecr.admin.fullName": "الاسم الكامل",
          "ecr.admin.emailAddress": "عنوان البريد الإلكتروني",
          "ecr.admin.companyName": "اسم الشركة",
          "ecr.admin.phoneNumber": "رقم الهاتف",
          "ecr.admin.registrationDate": "تاريخ التسجيل",
          "ecr.admin.totalMerchants": "إجمالي التجار",
          "ecr.admin.activeTerminals": "الأجهزة النشطة",
          "ecr.admin.consumedLicenses": "التراخيص المستهلكة",
          "ecr.admin.totalLicensesLabel": "إجمالي التراخيص",
          "ecr.admin.activationDate": "تاريخ التفعيل",
          "ecr.admin.expiryDate": "تاريخ الانتهاء",
          "ecr.admin.updateLicense": "تحديث الترخيص",
          "ecr.admin.licenseUsage": "استخدام الترخيص",
          "ecr.admin.licensesUsed": "تراخيص مستخدمة",
          "ecr.admin.currentConsumed": "المستهلك حالياً",
          "ecr.admin.selectActivationDate": "اختر تاريخ التفعيل",
          TERMINAL_MISCONF:"خطأ في الاعداد",
          ERROR:"خطأ",
          FAILED:"فشل",
         TIMEOUT:"انتهى الوقت",

          "ecr.admin.selectExpiryDate": "اختر تاريخ الانتهاء",
          "ecr.admin.enterTotalLicenses": "أدخل إجمالي عدد التراخيص",
          "ecr.admin.approveProvider": "الموافقة على المزود",
          "ecr.admin.rejectProvider": "رفض المزود",
          "ecr.admin.deactivateProvider": "إلغاء تفعيل المزود",
          "ecr.admin.activateProvider": "تفعيل المزود",
          "ecr.admin.approveConfirm": "الموافقة على تسجيل المزود؟",
          "ecr.admin.approveDesc": "الموافقة ستمنح هذا المزود الوصول إلى النظام. سيتمكن من تسجيل التجار وإدارة الأجهزة.",
          "ecr.admin.rejectConfirm": "رفض تسجيل المزود؟",
          "ecr.admin.rejectDesc": "الرفض سيمنع الوصول لهذا المزود. يمكن التراجع عن هذا الإجراء لاحقاً إذا لزم الأمر.",
          "ecr.admin.deactivateConfirm": "إلغاء تفعيل المزود؟",
          "ecr.admin.deactivateDesc": "إلغاء التفعيل سيمنع هذا المزود من الوصول إلى النظام. سيتأثر جميع التجار والأجهزة المرتبطة.",
          "ecr.admin.activateConfirm": "تفعيل المزود؟",
          "ecr.admin.activateDesc": "التفعيل سيمكن هذا المزود من الوصول إلى النظام وإدارة تجاره.",
          "ecr.admin.currentStatus": "الحالة الحالية",
          "ecr.admin.providerId": "معرف المزود",
          "ecr.admin.actions": "الإجراءات",
          "ecr.admin.notSet": "غير محدد",
          "ecr.admin.licensesOf": "من",
          "ecr.admin.licensesUsedTooltip": "تراخيص مستخدمة",
          
          // License Management
          licenses: "التراخيص",
          licenseInformation: "معلومات الترخيص",
          licenseUsage: "استخدام الترخيص",
          assignLicenses: "تعيين التراخيص",
          licensesAssignedSuccess: "تم تعيين التراخيص بنجاح",
          currentUsage: "الاستخدام الحالي",
          currentTotal: "الإجمالي الحالي",
          used: "مستخدم",
          available: "متاح",
          newTotalLicenses: "إجمالي التراخيص الجديد",
          minimumLicenseNote: "الحد الأدنى: {{min}} (قيد الاستخدام حالياً)",
          optional: "اختياري",
          licenseNotesPlaceholder: "سبب تخصيص الترخيص...",
          licensesCannotBeNegative: "لا يمكن أن يكون عدد التراخيص سالباً",
          licensesCannotBeBelowUsed: "لا يمكن تعيين التراخيص أقل من الاستخدام الحالي ({{used}})",
          licenseAtLimit: "تم الوصول إلى حد الترخيص. لا يمكن إنشاء المزيد من الاشتراكات.",
          licenseNearLimit: "استخدام الترخيص أعلى من 80%. يُنصح بزيادة تخصيص التراخيص.",
          licenseNormal: "استخدام الترخيص ضمن النطاق الطبيعي.",
          manageLicenses: "إدارة التراخيص",
          licenseAllocation: "تخصيص الترخيص",
          licenseHistory: "سجل التراخيص",
          noLicensesAllocated: "لم يتم تخصيص تراخيص",
          totalLicenses: "إجمالي التراخيص",
          usedLicenses: "التراخيص المستخدمة",
          availableLicenses: "التراخيص المتاحة",
          
          // ECR Subscription Approval
          "ecr.subscription.pendingRequests": "الطلبات المعلقة",
          "ecr.subscription.activeMerchants": "التجار النشطون",
          "ecr.subscription.rejectedTab": "المرفوضة",
          "ecr.subscription.noPendingRequests": "لا توجد طلبات اشتراك معلقة",
          "ecr.subscription.noRejectedRequests": "لا توجد طلبات اشتراك مرفوضة",
          "ecr.subscription.requestDate": "تاريخ الطلب",
          "ecr.subscription.approve": "موافقة",
          "ecr.subscription.reject": "رفض",
          "ecr.subscription.rejected": "مرفوض",
          "ecr.subscription.approveTitle": "الموافقة على طلب الاشتراك",
          "ecr.subscription.rejectTitle": "رفض طلب الاشتراك",
          "ecr.subscription.approveConfirmMessage": "هل أنت متأكد من الموافقة على طلب الاشتراك هذا؟",
          "ecr.subscription.rejectConfirmMessage": "هل أنت متأكد من رفض طلب الاشتراك هذا؟",
          "ecr.subscription.rejectionReason": "سبب الرفض",
          "ecr.subscription.rejectionReasonPlaceholder": "أدخل سبب الرفض...",
          "ecr.subscription.approveSuccess": "تمت الموافقة على الاشتراك بنجاح",
          "ecr.subscription.rejectSuccess": "تم رفض الاشتراك بنجاح",
          "ecr.subscription.approveError": "فشل في الموافقة على الاشتراك",
          "ecr.subscription.rejectError": "فشل في رفض الاشتراك",
          "ecr.subscription.errorLoadingPending": "فشل في تحميل الاشتراكات المعلقة",
          "ecr.subscription.errorLoadingRejected": "فشل في تحميل الاشتراكات المرفوضة",
          "ecr.subscription.statusFilter": "فلتر الحالة",
          "ecr.subscription.allStatuses": "جميع الحالات",
          
          // ECR Merchants Page
          "ecr.merchants.title": "إدارة التجار",
          "ecr.merchants.numberOfBranches": "عدد الفروع",
          "ecr.merchants.merchants": "التجار",
          "ecr.merchants.usersReport": "تقرير المستخدمين",
          "ecr.merchants.branchesReport": "تقرير الفروع",
          "ecr.merchants.close": "إغلاق",
          "ecr.merchants.merchantDetails": "تفاصيل التاجر",
          "ecr.merchants.activate": "تفعيل",
          "ecr.merchants.deactivate": "إلغاء التفعيل",
          "ecr.merchants.approveUser": "الموافقة على المستخدم؟",
          "ecr.merchants.rejectUser": "رفض المستخدم؟",
          "ecr.merchants.activateUser": "تفعيل المستخدم؟",
          "ecr.merchants.deactivateUserWarning": "إلغاء تفعيل المستخدم سيمنعه من الوصول إلى النظام",
          "ecr.merchants.activateUserMessage": "تفعيل المستخدم سيمكنه من الوصول إلى النظام",
          "ecr.merchants.approveUserMessage": "الموافقة على المستخدم ستمكنه من الوصول إلى النظام",
          "ecr.merchants.rejectUserMessage": "سيؤدي هذا إلى نقل هذا الطلب إلى علامة التبويب المرفوضة",
          "ecr.merchants.yes": "نعم",
          "ecr.merchants.no": "لا",
          
          // ECR Settings Page
          "ecr.settings.title": "إعدادات خدمة الدفع",
          "ecr.settings.save": "حفظ",
          "ecr.settings.updateSuccess": "تم تحديث خدمة الدفع بنجاح",
          "ecr.settings.updateError": "فشل في تحديث خدمة الدفع",
          "ecr.settings.networkError": "خطأ في الشبكة",
          
          // Merchant Subscription Status
          "merchant.subscription.errorLoading": "فشل في تحميل حالة الاشتراك",
          "merchant.subscription.pendingTitle": "اشتراك ECR قيد الانتظار",
          "merchant.subscription.pendingMessage": "طلب اشتراكك لدى {{provider}} في انتظار الموافقة.",
          "merchant.subscription.rejectedTitle": "تم رفض اشتراك ECR",
          "merchant.subscription.rejectedMessage": "تم رفض طلب اشتراكك لدى {{provider}}.",
          "merchant.subscription.rejectedMessageWithReason": "تم رفض طلب اشتراكك لدى {{provider}}. السبب: {{reason}}",
          
          // Branch Card
          remove: "إزالة",
          branchInformation: "معلومات الفرع",
          enterBranchName: "أدخل اسم الفرع",
          enterBranchAddress: "أدخل عنوان الفرع",
          noCashiersAdded: "لم تتم إضافة كاشيرات بعد",
          clickAddCashierToStart: "انقر على 'إضافة كاشير' للبدء",
          confirmBranchRemoval: "تأكيد إزالة الفرع",
          branchRemovalWarning: "هل أنت متأكد من إزالة {{branchName}}؟ لا يمكن التراجع عن هذا الإجراء.",
          branchHasCashiersWarning_zero: "هذا الفرع لا يحتوي على كاشيرات.",
          branchHasCashiersWarning_one: "يحتوي هذا الفرع على كاشير واحد. ستؤدي إزالة الفرع إلى إزالة الكاشير المرتبط.",
          branchHasCashiersWarning_two: "يحتوي هذا الفرع على كاشيرين. ستؤدي إزالة الفرع إلى إزالة الكاشيرين المرتبطين.",
          branchHasCashiersWarning_few: "يحتوي هذا الفرع على {{count}} كاشيرات. ستؤدي إزالة الفرع إلى إزالة جميع الكاشيرات المرتبطة.",
          branchHasCashiersWarning_many: "يحتوي هذا الفرع على {{count}} كاشيراً. ستؤدي إزالة الفرع إلى إزالة جميع الكاشيرات المرتبطة.",
          branchHasCashiersWarning_other: "يحتوي هذا الفرع على {{count}} كاشير. ستؤدي إزالة الفرع إلى إزالة جميع الكاشيرات المرتبطة.",
          
          // Cashier Card
          enterCashierName: "أدخل اسم الكاشير",
          enterCashierUsername: "أدخل اسم مستخدم الكاشير",
          enterCashierPassword: "أدخل كلمة مرور الكاشير",
          enterTerminalId: "أدخل رقم الجهاز",
          minimumCharacters_one: "الحد الأدنى حرف واحد",
          minimumCharacters_two: "الحد الأدنى حرفان",
          minimumCharacters_few: "الحد الأدنى {{count}} أحرف",
          minimumCharacters_many: "الحد الأدنى {{count}} حرفاً",
          minimumCharacters_other: "الحد الأدنى {{count}} حرف",
          confirmCashierRemoval: "تأكيد إزالة الكاشير",
          cashierRemovalWarning: "هل أنت متأكد من إزالة {{cashierName}}؟ لا يمكن التراجع عن هذا الإجراء.",
          
          // Plural forms for common entities (Arabic has 6 plural forms)
          terminal_zero: "لا توجد أجهزة",
          terminal_one: "جهاز واحد",
          terminal_two: "جهازان",
          terminal_few: "{{count}} أجهزة",
          terminal_many: "{{count}} جهازاً",
          terminal_other: "{{count}} جهاز",
          
          transaction_zero: "لا توجد عمليات",
          transaction_one: "عملية واحدة",
          transaction_two: "عمليتان",
          transaction_few: "{{count}} عمليات",
          transaction_many: "{{count}} عملية",
          transaction_other: "{{count}} عملية",
          
          merchant_zero: "لا يوجد تجار",
          merchant_one: "تاجر واحد",
          merchant_two: "تاجران",
          merchant_few: "{{count}} تجار",
          merchant_many: "{{count}} تاجراً",
          merchant_other: "{{count}} تاجر",
          
          branch_zero: "لا توجد فروع",
          branch_one: "فرع واحد",
          branch_two: "فرعان",
          branch_few: "{{count}} فروع",
          branch_many: "{{count}} فرعاً",
          branch_other: "{{count}} فرع",
          
          cashier_zero: "لا يوجد كاشيرات",
          cashier_one: "كاشير واحد",
          cashier_two: "كاشيران",
          cashier_few: "{{count}} كاشيرات",
          cashier_many: "{{count}} كاشيراً",
          cashier_other: "{{count}} كاشير",
          
          license_zero: "لا توجد تراخيص",
          license_one: "ترخيص واحد",
          license_two: "ترخيصان",
          license_few: "{{count}} تراخيص",
          license_many: "{{count}} ترخيصاً",
          license_other: "{{count}} ترخيص",
          
          device_zero: "لا توجد أجهزة",
          device_one: "جهاز واحد",
          device_two: "جهازان",
          device_few: "{{count}} أجهزة",
          device_many: "{{count}} جهازاً",
          device_other: "{{count}} جهاز",
          
          user_zero: "لا يوجد مستخدمين",
          user_one: "مستخدم واحد",
          user_two: "مستخدمان",
          user_few: "{{count}} مستخدمين",
          user_many: "{{count}} مستخدماً",
          user_other: "{{count}} مستخدم",
          
          error_zero: "لا توجد أخطاء",
          error_one: "خطأ واحد",
          error_two: "خطأان",
          error_few: "{{count}} أخطاء",
          error_many: "{{count}} خطأً",
          error_other: "{{count}} خطأ",
          
          result_zero: "لا توجد نتائج",
          result_one: "نتيجة واحدة",
          result_two: "نتيجتان",
          result_few: "{{count}} نتائج",
          result_many: "{{count}} نتيجة",
          result_other: "{{count}} نتيجة",
          
          item_zero: "لا توجد عناصر",
          item_one: "عنصر واحد",
          item_two: "عنصران",
          item_few: "{{count}} عناصر",
          item_many: "{{count}} عنصراً",
          item_other: "{{count}} عنصر",
          
          day_zero: "لا توجد أيام",
          day_one: "يوم واحد",
          day_two: "يومان",
          day_few: "{{count}} أيام",
          day_many: "{{count}} يوماً",
          day_other: "{{count}} يوم",
          
          hour_zero: "لا توجد ساعات",
          hour_one: "ساعة واحدة",
          hour_two: "ساعتان",
          hour_few: "{{count}} ساعات",
          hour_many: "{{count}} ساعة",
          hour_other: "{{count}} ساعة",
          
          minute_zero: "لا توجد دقائق",
          minute_one: "دقيقة واحدة",
          minute_two: "دقيقتان",
          minute_few: "{{count}} دقائق",
          minute_many: "{{count}} دقيقة",
          minute_other: "{{count}} دقيقة",
          
          // Date and number formatting examples
          "format.currency": "{{value, currency}}",
          "format.number": "{{value, number}}",
          "format.decimal": "{{value, decimal}}",
          "format.percent": "{{value, percent}}",
          "format.date": "{{value, date}}",
          "format.datetime": "{{value, datetime}}",
          "format.time": "{{value, time}}",
          "format.shortDate": "{{value, shortDate}}",
          "format.longDate": "{{value, longDate}}",
          "format.relativeTime": "{{value, relativeTime}}",
          
          // Common formatted messages
          "messages.lastUpdatedAt": "آخر تحديث: {{date, datetime}}",
          "messages.createdAt": "تاريخ الإنشاء: {{date, shortDate}}",
          "messages.expiresIn": "ينتهي: {{date, relativeTime}}",
          "messages.totalAmount": "الإجمالي: {{amount, currency}}",
          "messages.successRate": "معدل النجاح: {{rate, percent}}",
          "messages.itemCount": "{{count, number}} عنصر",
          
          // Conditional text translations
          "conditional.status.active": "نشط",
          "conditional.status.inactive": "غير نشط",
          "conditional.status.pending": "قيد الانتظار",
          "conditional.status.approved": "موافق عليه",
          "conditional.status.rejected": "مرفوض",
          "conditional.status.online": "متصل",
          "conditional.status.offline": "غير متصل",
          "conditional.status.connected": "متصل",
          "conditional.status.disconnected": "غير متصل",
          "conditional.status.enabled": "مفعّل",
          "conditional.status.disabled": "معطّل",
          
          "conditional.yesNo.yes": "نعم",
          "conditional.yesNo.no": "لا",
          
          "conditional.availability.available": "متاح",
          "conditional.availability.unavailable": "غير متاح",
          "conditional.availability.inStock": "متوفر",
          "conditional.availability.outOfStock": "غير متوفر",
          
          "conditional.visibility.visible": "مرئي",
          "conditional.visibility.hidden": "مخفي",
          "conditional.visibility.show": "إظهار",
          "conditional.visibility.hide": "إخفاء",
          
          "conditional.action.activate": "تفعيل",
          "conditional.action.deactivate": "إلغاء التفعيل",
          "conditional.action.enable": "تمكين",
          "conditional.action.disable": "تعطيل",
          "conditional.action.approve": "موافقة",
          "conditional.action.reject": "رفض",
          
          "conditional.state.open": "مفتوح",
          "conditional.state.closed": "مغلق",
          "conditional.state.locked": "مقفل",
          "conditional.state.unlocked": "غير مقفل",
          "conditional.state.verified": "موثّق",
          "conditional.state.unverified": "غير موثّق",
          
          // HTML content translations (use with Trans component)
          "html.securedDownload": "🔒 هذا التنزيل محمي بواسطة <strong>نيوباس</strong>",
          "html.termsAndConditions": "أوافق على <a href='/terms'>الشروط والأحكام</a>",
          "html.privacyPolicy": "بالمتابعة، فإنك توافق على <a href='/privacy'>سياسة الخصوصية</a>",
          "html.contactSupport": "تحتاج مساعدة؟ <a href='/support'>اتصل بالدعم</a>",
          "html.learnMore": "تعرف على المزيد حول <strong>{{feature}}</strong> في <a href='/docs'>الوثائق</a>",
          "html.warningMessage": "<strong>تحذير:</strong> لا يمكن التراجع عن هذا الإجراء",
          "html.successMessage": "<strong>نجح!</strong> تم حفظ تغييراتك",
          "html.errorMessage": "<strong>خطأ:</strong> {{message}}",
          "html.infoMessage": "<em>ملاحظة:</em> {{message}}",
          
          // Empty states
          "emptyState.noData": "لا توجد بيانات متاحة",
          "emptyState.noResults": "لم يتم العثور على نتائج",
          "emptyState.noTransactions": "لا توجد عمليات بعد",
          "emptyState.noTerminals": "لم يتم العثور على أجهزة",
          "emptyState.noMerchants": "لم يتم العثور على تجار",
          "emptyState.noBranches": "لم يتم العثور على فروع",
          "emptyState.noUsers": "لم يتم العثور على مستخدمين",
          "emptyState.noLicenses": "لم يتم تخصيص تراخيص",
          "emptyState.noNotifications": "لا توجد إشعارات",
          "emptyState.noHistory": "لا يوجد سجل متاح",
          "emptyState.noReports": "لم يتم إنشاء تقارير",
          "emptyState.noReconciliations": "لم يتم العثور على موازنات",
          "emptyState.noRefunds": "لم يتم العثور على مبالغ مستردة",
          "emptyState.noSettlements": "لم يتم العثور على تسويات",
          "emptyState.noProviders": "لم يتم العثور على مزودين",
          "emptyState.noSubscriptions": "لا توجد اشتراكات",
          "emptyState.noPendingRequests": "لا توجد طلبات معلقة",
          "emptyState.noRejectedItems": "لا توجد عناصر مرفوضة",
          "emptyState.noActiveItems": "لا توجد عناصر نشطة",
          "emptyState.emptyList": "هذه القائمة فارغة",
          "emptyState.emptyTable": "هذا الجدول فارغ",
          "emptyState.noItemsToDisplay": "لا توجد عناصر للعرض",
          "emptyState.startByAdding": "ابدأ بإضافة أول {{item}}",
          "emptyState.tryAdjustingFilters": "حاول تعديل الفلاتر",
          "emptyState.clearFiltersToSeeAll": "امسح الفلاتر لرؤية جميع العناصر",
          
          // Success messages
          "success.operationCompleted": "تمت العملية بنجاح",
          "success.changesSaved": "تم حفظ التغييرات بنجاح",
          "success.itemCreated": "تم إنشاء {{item}} بنجاح",
          "success.itemUpdated": "تم تحديث {{item}} بنجاح",
          "success.itemDeleted": "تم حذف {{item}} بنجاح",
          "success.itemActivated": "تم تفعيل {{item}} بنجاح",
          "success.itemDeactivated": "تم إلغاء تفعيل {{item}} بنجاح",
          "success.itemApproved": "تمت الموافقة على {{item}} بنجاح",
          "success.itemRejected": "تم رفض {{item}} بنجاح",
          "success.fileUploaded": "تم تحميل الملف بنجاح",
          "success.fileDownloaded": "تم تنزيل الملف بنجاح",
          "success.dataExported": "تم تصدير البيانات بنجاح",
          "success.dataImported": "تم استيراد البيانات بنجاح",
          "success.emailSent": "تم إرسال البريد الإلكتروني بنجاح",
          "success.passwordReset": "تم إعادة تعيين كلمة المرور بنجاح",
          "success.accountVerified": "تم التحقق من الحساب بنجاح",
          "success.settingsUpdated": "تم تحديث الإعدادات بنجاح",
          "success.licenseAssigned": "تم تعيين الترخيص بنجاح",
          "success.subscriptionCreated": "تم إنشاء الاشتراك بنجاح",
          
          // Error messages
          "error.operationFailed": "فشلت العملية",
          "error.somethingWentWrong": "حدث خطأ ما",
          "error.tryAgainLater": "يرجى المحاولة مرة أخرى لاحقاً",
          "error.loadingFailed": "فشل تحميل {{item}}",
          "error.savingFailed": "فشل حفظ {{item}}",
          "error.creatingFailed": "فشل إنشاء {{item}}",
          "error.updatingFailed": "فشل تحديث {{item}}",
          "error.deletingFailed": "فشل حذف {{item}}",
          "error.uploadFailed": "فشل تحميل الملف",
          "error.downloadFailed": "فشل تنزيل الملف",
          "error.exportFailed": "فشل تصدير البيانات",
          "error.importFailed": "فشل استيراد البيانات",
          "error.networkError": "حدث خطأ في الشبكة",
          "error.serverError": "حدث خطأ في الخادم",
          "error.unauthorized": "أنت غير مخول",
          "error.sessionExpired": "انتهت جلستك",
          "error.notFound": "لم يتم العثور على {{item}}",
          "error.alreadyExists": "{{item}} موجود بالفعل",
          "error.invalidData": "البيانات المقدمة غير صالحة",
          "error.requiredField": "هذا الحقل مطلوب",
          "error.invalidFormat": "تنسيق غير صالح",
          "error.fileTooLarge": "حجم الملف كبير جداً",
          "error.invalidFileType": "نوع الملف غير صالح",
          "error.connectionLost": "فقد الاتصال",
          "error.timeoutError": "انتهت مهلة الطلب",
          
          // Warning messages
          "warning.unsavedChanges": "لديك تغييرات غير محفوظة",
          "warning.confirmDelete": "هل أنت متأكد من الحذف؟",
          "warning.confirmDeactivate": "هل أنت متأكد من إلغاء التفعيل؟",
          "warning.cannotUndo": "لا يمكن التراجع عن هذا الإجراء",
          "warning.dataWillBeLost": "سيتم فقدان جميع البيانات",
          "warning.lowBalance": "تحذير رصيد منخفض",
          "warning.expiringLicense": "الترخيص ينتهي قريباً",
          "warning.limitReached": "تم الوصول إلى الحد",
          "warning.quotaExceeded": "تم تجاوز الحصة",
          "warning.maintenanceMode": "النظام في وضع الصيانة",
          "warning.deprecatedFeature": "هذه الميزة قديمة",
          
          // Info messages
          "info.loading": "جاري التحميل...",
          "info.processing": "جاري المعالجة...",
          "info.pleaseWait": "يرجى الانتظار...",
          "info.saving": "جاري الحفظ...",
          "info.uploading": "جاري التحميل...",
          "info.downloading": "جاري التنزيل...",
          "info.searching": "جاري البحث...",
          "info.filtering": "جاري التصفية...",
          "info.refreshing": "جاري التحديث...",
          "info.syncing": "جاري المزامنة...",
          "info.connecting": "جاري الاتصال...",
          "info.disconnecting": "جاري قطع الاتصال...",
          "info.initializing": "جاري التهيئة...",
          "info.preparingData": "جاري تحضير البيانات...",
          "info.generatingReport": "جاري إنشاء التقرير...",
          "info.sendingEmail": "جاري إرسال البريد الإلكتروني...",
          "info.verifying": "جاري التحقق...",
          "info.almostDone": "على وشك الانتهاء...",
          weak: "ضعيف",
          medium: "متوسط",
          strong: "قوي",
          hidePassword: "إخفاء كلمة المرور",
          showPassword: "إظهار كلمة المرور",
          passwordStrengthHint: "استخدم 8 أحرف على الأقل مع أحرف كبيرة وصغيرة وأرقام وأحرف خاصة",
          passwordsMatch: "كلمات المرور متطابقة",
          passwordsDoNotMatch: "كلمات المرور غير متطابقة",
          required: "مطلوب",
          submitting: "جاري الإرسال...",
          submit: "إرسال",
          
          // Location Selector
          selectRegion: "اختر المنطقة",
          selectCity: "اختر المدينة",
          selectDistrict: "اختر الحي",
          addNewDistrict: "إضافة حي جديد",
          enterDistrictName: "أدخل اسم الحي",
          add: "إضافة",
          selectExistingDistrict: "اختر حي موجود",
          pleaseEnterDistrictName: "يرجى إدخال اسم الحي",
          pleaseSelectRegionAndCity: "يرجى اختيار المنطقة والمدينة أولاً",
          
          // Error messages
          onboardingError: "حدث خطأ أثناء التسجيل. يرجى المحاولة مرة أخرى.",
          networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
          validationError: "يرجى إصلاح الأخطاء في النموذج قبل المتابعة.",
          
          // Sync Configuration
          "Terminal Sync Configuration": "إعدادات مزامنة الجهاز",
          "Configure how frequently terminals sync with the server": "تكوين تكرار مزامنة الأجهزة مع الخادم",
          "Current Sync Interval": "فترة المزامنة الحالية",
          "View History": "عرض السجل",
          "Last updated": "آخر تحديث",
          "Updated by": "تم التحديث بواسطة",
          "Select Preset Interval": "اختر فترة محددة مسبقاً",
          "5 minutes": "5 دقائق",
          "15 minutes": "15 دقيقة",
          "30 minutes": "30 دقيقة",
          "1 hour": "ساعة واحدة",
          "2 hours": "ساعتان",
          "6 hours": "6 ساعات",
          "12 hours": "12 ساعة",
          "Custom": "مخصص",
          "Custom Interval (minutes)": "فترة مخصصة (بالدقائق)",
          "Enter minutes (1-1440)": "أدخل الدقائق (1-1440)",
          "Minimum: 1 minute, Maximum: 24 hours (1440 minutes)": "الحد الأدنى: دقيقة واحدة، الحد الأقصى: 24 ساعة (1440 دقيقة)",
          "Important": "مهم",
          "Changes will take effect immediately for all terminals on their next heartbeat. No server restart required.": "ستدخل التغييرات حيز التنفيذ فوراً لجميع الأجهزة في النبضة التالية. لا حاجة لإعادة تشغيل الخادم.",
          "Save Configuration": "حفظ الإعدادات",
          "Change History": "سجل التغييرات",
          "No history available": "لا يوجد سجل متاح",
          "Changed by": "تم التغيير بواسطة",
          "Failed to load sync configuration": "فشل تحميل إعدادات المزامنة",
          "Failed to load audit logs": "فشل تحميل سجلات التدقيق",
          "Sync interval must be between 1 minute and 24 hours": "يجب أن تكون فترة المزامنة بين دقيقة واحدة و24 ساعة",
          "Sync interval must be a whole number": "يجب أن تكون فترة المزامنة رقماً صحيحاً",
          "Sync interval updated successfully": "تم تحديث فترة المزامنة بنجاح",
          "Failed to update sync interval": "فشل تحديث فترة المزامنة",
          "minutes": "دقائق",
          "hour": "ساعة",
          "Sync Configuration": "إعدادات المزامنة",
          
          // Features Slider
          "features.securePayment.title": "معالجة دفع آمنة",
          "features.securePayment.description": "معالجة معاملات البطاقات مع شبكات دفع متعددة بما في ذلك فيزا وماستركارد ومدى",
          "features.realtimeDashboard.title": "لوحة تحكم فورية",
          "features.realtimeDashboard.description": "راقب المعاملات والأجهزة ومقاييس الأعمال في الوقت الفعلي مع التحديثات المباشرة",
          "features.advancedSecurity.title": "أمان متقدم",
          "features.advancedSecurity.description": "أمان بمستوى البنوك مع مصادقة JWT ونقل بيانات مشفر",
          "features.lightningFast.title": "سريع كالبرق",
          "features.lightningFast.description": "أداء محسّن لمعالجة المعاملات والتقارير الفورية",
          "features.multiLanguage.title": "دعم متعدد اللغات",
          "features.multiLanguage.description": "التبديل بسلاسة بين الإنجليزية والعربية مع دعم كامل للكتابة من اليمين إلى اليسار",
          "features.easyIntegration.title": "تكامل سهل",
          "features.easyIntegration.description": "إعداد سريع مع مزودي ECR وإدارة الأجهزة بشكل بسيط",
          
          // Quick Tips
          quickTips: "نصائح سريعة",
          "tips.useRegisteredEmail": "استخدم بريدك الإلكتروني وكلمة المرور المسجلة لتسجيل الدخول",
          "tips.enable2FA": "فعّل المصادقة الثنائية لأمان محسّن",
          "tips.contactSupport": "اتصل بالدعم إذا كنت بحاجة إلى مساعدة",
          
          // Placeholders
          emailPlaceholder: "بريدك@الإلكتروني.com",
          passwordPlaceholder: "••••••••",
          
          // Footer
          "footer.copyright": "© {{year}} نيوباس. جميع الحقوق محفوظة.",
          
          // Bulk Upload
          "bulkUpload.title": "رفع المستخدمين بشكل جماعي",
          "bulkUpload.subtitle": "قم برفع عدة مستخدمين دفعة واحدة باستخدام تنسيق CSV أو XLSX. قم بتنزيل القالب للبدء.",
          "bulkUpload.uploadFile": "رفع الملف",
          "bulkUpload.uploadHint": "يدعم تنسيقات CSV و XLSX. تأكد من أن الملف يحتوي على بيانات صالحة تطابق بنية القالب.",
          "bulkUpload.fileSelected": "تم اختيار الملف: {{fileName}}",
          "bulkUpload.noFileSelected": "لم يتم اختيار ملف",
          "bulkUpload.downloadTemplate": "تنزيل القالب",
          "bulkUpload.uploadUsers": "رفع المستخدمين",
          "bulkUpload.duplicatedUserName": "اسم مستخدم مكرر",
          "bulkUpload.duplicatedTerminalIds": "أرقام أجهزة مكررة",
          "bulkUpload.invalidRole": "دور غير صالح",
          "bulkUpload.invalidPassword": "كلمة مرور غير صالحة",
          "bulkUpload.invalidTerminalId": "يجب أن يحتوي معرف الجهاز على 8 أرقام على الأقل وأرقام فقط",
          "bulkUpload.totalRows": "إجمالي الصفوف",
          "bulkUpload.validRows": "الصفوف الصالحة",
          "bulkUpload.errorsFound": "الأخطاء المكتشفة",
          "bulkUpload.rowsContainErrors": "{{count}} صف يحتوي على أخطاء",
          "bulkUpload.hoverForErrorDetails": "مرر الماوس فوق الصفوف المميزة أدناه لرؤية تفاصيل الأخطاء",
          "bulkUpload.allRowsValidated": "تم التحقق من جميع الصفوف بنجاح",
          "bulkUpload.fileReadyToUpload": "ملفك جاهز للرفع",
          "bulkUpload.dataPreview": "معاينة البيانات",
          "bulkUpload.errorCount": "{{count}} خطأ",
          "bulkUpload.errorCount_plural": "{{count}} أخطاء",
          "bulkUpload.noDataToPreview": "لا توجد بيانات للمعاينة",
          "bulkUpload.uploadFileToSeePreview": "قم برفع ملف لرؤية المعاينة",
          "bulkUpload.bulkUploadReport": "تقرير الرفع الجماعي",
          "bulkUpload.reviewResults": "راجع نتائج عملية الرفع الجماعي",
          "bulkUpload.validationErrors": "أخطاء التحقق",
          "bulkUpload.rowsAffected": "صف متأثر",
          "bulkUpload.successfulRows": "ناجح",
          "bulkUpload.failedRows": "فاشل",
          "bulkUpload.allRowsUploaded": "تم رفع جميع المستخدمين بنجاح.",
          "bulkUpload.allRowsFailed": "فشل رفع جميع الصفوف. يرجى مراجعة الأخطاء أدناه.",
          "bulkUpload.partialUpload": "تم رفع {{success}} صف بنجاح، فشل {{failed}} صف.",
          "bulkUpload.failedRowsNote": "الصفوف المميزة باللون الأحمر فشل رفعها. قم بتصحيح المشكلات وأعد رفع تلك الإدخالات.",
          "bulkUpload.statusColumn": "الحالة",
          "bulkUpload.downloadFailedRows": "تنزيل الصفوف الفاشلة ({{count}})",

          // Terminal Bulk Upload
          "terminalBulkUpload.title": "رفع الأجهزة بشكل جماعي",
          "terminalBulkUpload.subtitle": "قم برفع عدة أجهزة دفعة واحدة باستخدام تنسيق CSV أو XLSX. قم بتنزيل القالب للبدء.",
          "terminalBulkUpload.uploadFile": "رفع الملف",
          "terminalBulkUpload.uploadHint": "يدعم تنسيقات CSV و XLSX. يجب أن يحتوي كل صف على معرف الجهاز ومعرف موديل الجهاز.",
          "terminalBulkUpload.uploadTerminals": "رفع الأجهزة",
          "terminalBulkUpload.bulkUpload": "رفع جماعي",
          "terminalBulkUpload.duplicatedTerminalIds": "معرف جهاز مكرر",
          "terminalBulkUpload.terminalIdRequired": "معرف الجهاز مطلوب",
          "terminalBulkUpload.terminalIdMustBeNumeric": "يجب أن يحتوي معرف الجهاز على أرقام فقط (بدون أحرف أو رموز خاصة)",
          "terminalBulkUpload.invalidTerminalId": "يجب أن يكون معرف الجهاز 8 أو 16 رقمًا بالضبط",
          "terminalBulkUpload.terminalModelIdRequired": "معرف موديل الجهاز مطلوب",
          "terminalBulkUpload.terminalModelIdMustBeNumeric": "يجب أن يحتوي معرف موديل الجهاز على أرقام فقط (بدون أحرف أو رموز خاصة)",
          
          // Common - Buttons (additional)
          "common.buttons.saveChanges": "حفظ التغييرات",
          "common.buttons.viewAll": "عرض الكل",
          "common.buttons.refresh": "تحديث",
          "common.buttons.import": "استيراد",
          
          // Common - Labels (additional)
          "common.labels.lastUpdated": "آخر تحديث",
          "common.labels.updatedBy": "تم التحديث بواسطة",
          "common.labels.createdBy": "تم الإنشاء بواسطة",
          "common.labels.createdAt": "تاريخ الإنشاء",
          
          // Navigation - Sidebar (additional)
          "navigation.sidebar.syncConfiguration": "إعدادات المزامنة",
          "navigation.sidebar.providerMappings": "تعيينات المزود",
          "navigation.sidebar.ecrProviders": "مزودو ECR",
          
          // Admin Pages
          "admin.msp.title": "إدارة مزودي الخدمة",
          "admin.msp.subtitle": "إدارة مزودي خدمات التجار والحزم ونماذج الأجهزة",
          "admin.msp.searchPlaceholder": "البحث عن مزودي الخدمة أو الحزم أو النماذج...",
          "admin.msp.vendorName": "اسم المزود",
          "admin.msp.packageName": "اسم الحزمة",
          "admin.msp.terminalModel": "موديل الجهاز",
          "admin.msp.terminalBrand": "علامة الجهاز التجارية",
          "admin.msp.addMsp": "إضافة مزود خدمة",
          "admin.msp.editMsp": "تعديل مزود الخدمة",
          "admin.msp.addPackage": "إضافة حزمة",
          "admin.msp.editPackage": "تعديل الحزمة",
          "admin.msp.addTerminalModel": "إضافة موديل جهاز",
          "admin.msp.editTerminalModel": "تعديل موديل الجهاز",
          "admin.msp.noMspsFound": "لم يتم العثور على مزودي خدمة",
          "admin.msp.noPackagesFound": "لم يتم العثور على حزم",
          "admin.msp.noModelsFound": "لم يتم العثور على موديلات أجهزة",
          
          "admin.brands.title": "إدارة العلامات التجارية",
          "admin.brands.searchPlaceholder": "البحث عن العلامات التجارية...",
          "admin.brands.addBrand": "إضافة علامة تجارية",
          "admin.brands.brandName": "اسم العلامة التجارية",
          "admin.brands.terminalsModels": "موديلات الأجهزة",
          "admin.brands.terminalModelsList": "قائمة موديلات الأجهزة",
          "admin.brands.editBrand": "تعديل العلامة التجارية",
          "admin.brands.enterBrandName": "أدخل اسم العلامة التجارية",
          "admin.brands.enterTerminalModelName": "أدخل اسم موديل الجهاز",
          "admin.brands.addTerminalModel": "إضافة موديل جهاز",
          "admin.brands.editTerminalModel": "تعديل",
          "admin.brands.update": "تحديث",
          "admin.brands.add": "إضافة",
          
          "admin.districts.title": "إدارة الأحياء",
          "admin.districts.searchPlaceholder": "البحث عن الأحياء...",
          "admin.districts.districtsManagement": "إدارة الأحياء",
          "admin.districts.approve": "موافقة",
          "admin.districts.deactivate": "إلغاء التفعيل",
          "admin.districts.approveTitle": "موافقة",
          "admin.districts.approveDesc": "الموافقة على الحي ستجعله قابلاً للاختيار لجميع التجار",
          "admin.districts.deactivateTitle": "إلغاء التفعيل",
          "admin.districts.deactivateDesc": "إلغاء تفعيل الحي سيجعله غير قابل للاختيار لجميع التجار",
          "admin.districts.yes": "نعم",
          "admin.districts.no": "لا",
          "admin.districts.distritcs": "الأحياء",
          
          "admin.merchants.title": "إدارة التجار",
          "admin.merchants.searchPlaceholder": "البحث عن التجار...",
          "admin.merchants.merchants": "التجار",
          "admin.merchants.usersReport": "تقرير المستخدمين",
          "admin.merchants.branchesReport": "تقرير الفروع",
          "admin.merchants.noOfBranches": "عدد الفروع",
          "admin.merchants.reject": "رفض",
          "admin.merchants.approve": "موافقة",
          "admin.merchants.rejectUser": "رفض المستخدم؟",
          "admin.merchants.rejectUserDesc": "سيؤدي هذا إلى نقل هذا الطلب إلى علامة التبويب المرفوضة",
          "admin.merchants.approveUser": "الموافقة على المستخدم؟",
          "admin.merchants.approveUserDesc": "الموافقة على المستخدم ستمكنه من الوصول إلى النظام",
          "admin.merchants.approveMerchant": "الموافقة على التاجر؟",
          "admin.merchants.approveMerchantDesc": "الموافقة على هذا التاجر المرفوض ستمكنه من الوصول إلى النظام",
          "admin.merchants.merchantDetails": "تفاصيل التاجر",
          "admin.merchants.rejected": "مرفوض",
          "admin.merchants.onboarded": "مسجل",
          "admin.merchants.phone": "الهاتف",
          "admin.merchants.email": "البريد الإلكتروني",
          
          "admin.providers.searchPlaceholder": "البحث عن المزودين...",
          "admin.providers.providerDetails": "تفاصيل المزود",
          "admin.providers.licenseManagement": "إدارة التراخيص",
          "admin.providers.approveProvider": "الموافقة على المزود",
          "admin.providers.rejectProvider": "رفض المزود",
          "admin.providers.updateLicense": "تحديث الترخيص",
          "admin.providers.ecrProvidersManagement": "إدارة مزودي ECR",
          "admin.providers.manageEcrProviders": "إدارة حسابات مزودي ECR والتراخيص وأذونات الوصول",
          "admin.providers.totalProviders": "إجمالي المزودين",
          "admin.providers.activeProviders": "المزودون النشطون",
          "admin.providers.pendingApproval": "في انتظار الموافقة",
          "admin.providers.totalLicenses": "إجمالي التراخيص",
          "admin.providers.ecrProviderDetails": "تفاصيل مزود ECR",
          "admin.providers.currentStatus": "الحالة الحالية",
          "admin.providers.providerId": "معرف المزود",
          "admin.providers.providerInformation": "معلومات المزود",
          "admin.providers.fullName": "الاسم الكامل",
          "admin.providers.emailAddress": "عنوان البريد الإلكتروني",
          "admin.providers.subscriptions": "الاشتراكات",
          "admin.providers.noSubscriptions": "لا توجد اشتراكات",
          "admin.providers.merchant": "التاجر",
          "admin.providers.terminals": "الأجهزة",
          "admin.providers.status": "الحالة",
          "admin.providers.planType": "نوع الخطة",
          "admin.providers.billingCycle": "دورة الفوترة",
          "admin.providers.subscriptionEndDate": "تاريخ انتهاء الاشتراك",
          "admin.providers.autoRenewal": "التجديد التلقائي",
          "admin.providers.yes": "نعم",
          "admin.providers.no": "لا",
          "admin.providers.na": "غير متاح",
          "admin.providers.numberOfSubscriptions": "عدد الاشتراكات",
          "admin.providers.loading": "جاري التحميل...",
          
          "admin.settings.title": "إعدادات المسؤول",
          "admin.settings.pushServiceSettings": "إعدادات خدمة الإشعارات",
          "admin.settings.websocket": "Websocket",
          "admin.settings.mqtt": "MQTT",
          "admin.settings.pushy": "Pushy",
          "admin.settings.save": "حفظ",
          "admin.settings.otpSettings": "إعدادات التحقق من OTP",
          "admin.settings.otpDescription": "التحكم في ما إذا كان يجب على التجار التحقق باستخدام OTP عند تسجيل الدخول من أجهزة جديدة",
          "admin.settings.otpUpdated": "تم تحديث إعداد التحقق من OTP بنجاح",
          "admin.settings.otpUpdateFailed": "فشل تحديث إعداد التحقق من OTP",
          "admin.settings.enabled": "مفعل",
          "admin.settings.disabled": "معطل",
          "admin.settings.trxStatusRetrievalDelayTitle": "مهلة استرجاع الحالة",
          "admin.settings.trxStatusRetrievalDelayDescription": "الحد الأدنى للوقت الذي يجب أن تبقى فيه المعاملة بحالة INITIALIZED قبل أن يتمكن التجار من استرجاع حالتها يدويًا من الجهاز.",
          "admin.settings.trxStatusRetrievalDelayLabel": "المهلة",
          "admin.settings.trxStatusRetrievalDelayHint": "الوقت بالدقائق قبل أن يصبح إجراء \"استرجاع حالة المعاملة\" متاحًا.",
          "admin.settings.inactivityPeriodTitle": "فترة عدم النشاط الافتراضية",
          "admin.settings.inactivityPeriodDescription": "الفترة الافتراضية لاعتبار الجهاز غير نشط للتجار الذين لم يحددوا فترة خاصة بهم. يكون الجهاز غير نشط إذا لم تتم عليه عملية شراء ناجحة خلال هذه الفترة.",
          "admin.settings.inactivityPeriodLabel": "الفترة",
          "admin.settings.inactivityPeriodUpdated": "تم تحديث فترة عدم النشاط الافتراضية بنجاح",
          "admin.settings.inactivityPeriodUpdateFailed": "تعذر تحديث فترة عدم النشاط الافتراضية",
          "admin.settings.trxStatusRetrievalDelayUpdated": "تم تحديث مهلة استرجاع الحالة بنجاح",
          "admin.settings.trxStatusRetrievalDelayUpdateFailed": "فشل تحديث مهلة استرجاع الحالة",
          
          "admin.layout.portalTitle": "بوابة المسؤول",
          
          "admin.syncConfig.title": "إعدادات المزامنة",
          "admin.syncConfig.subtitle": "تكوين إعدادات مزامنة الأجهزة",
          "admin.syncConfig.syncInterval": "فترة المزامنة",
          "admin.syncConfig.minutes": "دقائق",
          "admin.syncConfig.terminalSyncConfiguration": "إعدادات مزامنة الأجهزة",
          "admin.syncConfig.configureSync": "تكوين فترة المزامنة لتحديثات بيانات الأجهزة",
          "admin.syncConfig.currentConfiguration": "الإعدادات الحالية",
          "admin.syncConfig.updateSyncInterval": "تحديث فترة المزامنة",
          "admin.syncConfig.selectPresetInterval": "اختر فترة محددة مسبقاً",
          "admin.syncConfig.choosePresetInterval": "اختر فترة محددة مسبقاً",
          "admin.syncConfig.or": "أو",
          "admin.syncConfig.enterCustomInterval": "أدخل فترة مخصصة (بالدقائق)",
          "admin.syncConfig.enterCustomIntervalPlaceholder": "أدخل فترة مخصصة",
          "admin.syncConfig.validRange": "النطاق الصالح: 1 - 1440 دقيقة (دقيقة واحدة إلى 24 ساعة)",
          "admin.syncConfig.changeReason": "سبب التغيير (اختياري)",
          "admin.syncConfig.changeReasonPlaceholder": "أدخل سبب تغيير الإعدادات",
          "admin.syncConfig.saveConfiguration": "حفظ الإعدادات",
          "admin.syncConfig.intervalMustBeBetween": "يجب أن تكون الفترة دقيقة واحدة على الأقل",
          "admin.syncConfig.intervalCannotExceed": "لا يمكن أن تتجاوز الفترة 1440 دقيقة (24 ساعة)",
          "admin.syncConfig.intervalMustBeWholeNumber": "يجب أن تكون الفترة رقماً صحيحاً",
          "admin.syncConfig.selectOrEnterInterval": "يرجى اختيار أو إدخال فترة المزامنة",
          "admin.syncConfig.intervalBetweenError": "يجب أن تكون فترة المزامنة بين 1 و 1440 دقيقة",
          "admin.syncConfig.wholeNumberError": "يجب أن تكون فترة المزامنة رقماً صحيحاً",
          "admin.syncConfig.updateSuccess": "تم تحديث إعدادات المزامنة بنجاح",
          "admin.syncConfig.updateFailed": "فشل تحديث إعدادات المزامنة",
          "admin.syncConfig.invalidValues": "قيم الإعدادات غير صالحة",
          "admin.syncConfig.serviceUnavailable": "الخدمة غير متاحة مؤقتاً. يرجى المحاولة مرة أخرى لاحقاً.",
          "admin.syncConfig.loadingConfiguration": "جاري تحميل الإعدادات...",
          
          "admin.providerMapping.noParametersDefined": "لم يتم تحديد معاملات",
          "admin.providerMapping.intentActions": "إجراءات النية",
          "admin.providerMapping.addAction": "إضافة إجراء",
          "admin.providerMapping.editAction": "تعديل الإجراء",
          "admin.providerMapping.deleteAction": "حذف الإجراء",
          "admin.providerMapping.noActionsDefined": "لم يتم تحديد إجراءات",
          
          // ECR Pages
          "ecr.msp.title": "إدارة مزودي الخدمة",
          "ecr.msp.subtitle": "إدارة مزودي خدمات التجار والحزم ونماذج الأجهزة",
          "ecr.msp.searchPlaceholder": "البحث عن مزودي الخدمة أو الحزم أو النماذج...",
          "ecr.msp.vendorName": "اسم المزود",
          "ecr.msp.packageName": "اسم الحزمة",
          "ecr.msp.terminalModel": "موديل الجهاز",
          "ecr.msp.terminalBrand": "علامة الجهاز التجارية",
          "ecr.msp.viewMsps": "عرض مزودي الخدمة",
          "ecr.msp.viewPackages": "عرض الحزم",
          "ecr.msp.viewTerminalModels": "عرض موديلات الأجهزة",
          "ecr.msp.mspDetails": "تفاصيل مزود الخدمة",
          "ecr.msp.packageDetails": "تفاصيل الحزمة",
          "ecr.msp.modelDetails": "تفاصيل الموديل",
          "ecr.msp.noMspsAvailable": "لا توجد مزودي خدمة متاحة",
          "ecr.msp.noPackagesAvailable": "لا توجد حزم متاحة",
          "ecr.msp.noModelsAvailable": "لا توجد موديلات متاحة",
          
          "ecr.brands.title": "إدارة العلامات التجارية",
          "ecr.brands.searchPlaceholder": "البحث عن العلامات التجارية...",
          "ecr.brands.viewBrands": "عرض العلامات التجارية",
          "ecr.brands.brandDetails": "تفاصيل العلامة التجارية",
          
          "ecr.districts.title": "إدارة الأحياء",
          "ecr.districts.searchPlaceholder": "البحث عن الأحياء...",
          
          "ecr.merchants.searchPlaceholder": "البحث عن التجار...",
          
          "ecr.layout.portalTitle": "بوابة ECR",

          // MSP Dashboard Pages
          "msp.dashboard.title": "لوحة تحكم MSP",
          "msp.dashboard.subtitle": "مراقبة مجموعة التراخيص ومحفظة التجار",
          "msp.dashboard.kpi.totalLicenses": "إجمالي التراخيص",
          "msp.dashboard.kpi.totalLicensesSub": "الطاقة المرخصة",
          "msp.dashboard.kpi.usedLicenses": "التراخيص المستخدمة",
          "msp.dashboard.kpi.usedLicensesSub": "الأجهزة المُفعّلة",
          "msp.dashboard.kpi.available": "المتاح",
          "msp.dashboard.kpi.availableSub": "التراخيص المتبقية",
          "msp.dashboard.kpi.activeMerchants": "التجار النشطون",
          "msp.dashboard.kpi.activeMerchantsSub": "التجار الذين لديهم أجهزة نشطة",
          "msp.dashboard.utilization.title": "استخدام مجموعة التراخيص",
          "msp.dashboard.utilization.activeFrom": "نشط من",
          "msp.dashboard.utilization.expires": "ينتهي في",
          "msp.dashboard.utilization.activeTerminals": "الأجهزة النشطة",
          "msp.dashboard.utilization.suspendedTerminals": "الأجهزة الموقوفة",
          "msp.dashboard.utilization.availableLicenses": "التراخيص المتاحة",
          "msp.dashboard.expiry.warning": "تنتهي صلاحية مجموعة التراخيص خلال {{days}} يوم. تواصل مع المسؤول للتجديد.",
          "msp.dashboard.expiry.expired": "انتهت صلاحية مجموعة التراخيص. تواصل مع المسؤول للتجديد.",
          "msp.dashboard.terminal.active": "الأجهزة النشطة",
          "msp.dashboard.terminal.suspended": "الأجهزة الموقوفة",
          "msp.dashboard.terminal.emptySparkline": "لا توجد بيانات",
          "msp.dashboard.terminal.topSuspended": "الأجهزة الموقوفة مؤخراً",
          "msp.dashboard.empty.title": "لا توجد أجهزة مسجلة",
          "msp.dashboard.empty.description": "لا توجد أجهزة مسجلة في مجموعة التراخيص الخاصة بك بعد.",
          "msp.dashboard.actions.viewAllMerchants": "عرض جميع التجار ←",
          "msp.dashboard.error.noProvider": "لا يوجد مزود MSP مرتبط بحسابك. تواصل مع المسؤول.",
          "msp.billing.title": "الفوترة",
          "msp.billing.subtitle": "استخدام التراخيص وأحداث الفوترة وتقارير الاستخدام الشهرية",
          "msp.billing.licenseInfo": "معلومات تراخيص MSP",
          "msp.billing.purchasedLicenses": "التراخيص المشتراة",
          "msp.billing.activeLicenses": "التراخيص النشطة",
          "msp.billing.availableLicenses": "التراخيص المتاحة",
          "msp.billing.contract": "العقد",
          "msp.billing.perTerminal": "جهاز",
          "msp.billing.eventLog": "سجل أحداث الفوترة",
          "msp.billing.eventType": "الحدث",
          "msp.billing.terminal": "الجهاز",
          "msp.billing.merchant": "التاجر",
          "msp.billing.billable": "خاضع للفوترة",
          "msp.billing.billableOnly": "الخاضع للفوترة فقط",
          "msp.billing.timestamp": "التوقيت",
          "msp.billing.syncStatus": "مزامنة Zoho",
          "msp.billing.searchPlaceholder": "ابحث بالجهاز أو التاجر…",
          "msp.billing.noEvents": "لا توجد أحداث فوترة",
          "msp.billing.usageSummaries": "ملخصات الاستخدام الشهرية",
          "msp.billing.period": "الفترة",
          "msp.billing.billableUnits": "الوحدات الخاضعة للفوترة",
          "msp.billing.contractType": "العقد",
          "msp.billing.generatedAt": "تاريخ الإنشاء",
          "msp.billing.export": "تصدير",
          "msp.billing.merchantCsv": "ملف التجار CSV",
          "msp.billing.terminalCsv": "ملف الأجهزة CSV",
          "msp.billing.selectMonth": "اختر الشهر",
          "msp.billing.generate": "إنشاء",
          "msp.billing.generateSuccess": "تم إنشاء ملخص الاستخدام",
          "msp.billing.noSummaries": "لا توجد ملخصات استخدام بعد — يتم إنشاؤها تلقائياً في اليوم 28 من كل شهر",
          "msp.billing.shield.warningTitle": "التراخيص على وشك النفاد",
          "msp.billing.shield.warningBody": "انخفضت تراخيصك المتاحة إلى أقل من {{threshold}}% من إجمالي التراخيص المشتراة. ستستمر عمليات تفعيل الأجهزة الجديدة ولكن قد تترتب عليها رسوم إضافية.",
          "msp.billing.shield.blockedTitle": "تم بلوغ حد التراخيص",
          "msp.billing.shield.blockedBody": "يتطلب هذا الإجراء ترخيصاً متاحاً، لكن رصيد التراخيص قد نفد. قم بشراء تراخيص إضافية أو أوقف جهازاً آخر لتحرير ترخيص.",
          "msp.billing.shield.warningBanner": "التراخيص المتاحة أقل من حد التحذير. يُنصح بشراء تراخيص إضافية.",
          "msp.billing.shield.blockedBanner": "نفد رصيد التراخيص — إعادة التفعيل محظورة وعمليات التفعيل الجديدة تترتب عليها رسوم إضافية.",
          "msp.billing.shield.acknowledge": "فهمت",
          "msp.merchants.title": "التجار",
          "msp.merchants.count.suffix": "تاجر",
          "msp.merchants.search.placeholder": "ابحث بالاسم أو رقم الجهاز…",
          "msp.merchants.filter.status": "تصفية حسب الحالة",
          "msp.merchants.filter.all": "الكل",
          "msp.merchants.col.merchant": "التاجر",
          "msp.merchants.col.licensed": "المرخص",
          "msp.merchants.col.active": "النشط",
          "msp.merchants.col.suspended": "الموقوف",
          "msp.merchants.empty.default": "لا يوجد تجار مرتبطون بمؤسستك حتى الآن.",
          "msp.merchants.empty.search": "لا يوجد تجار يطابقون \"{{query}}\"",
          "msp.merchants.tooltip.suspended": "{{count}} جهاز موقوف",
          "msp.merchants.expand.title": "الأجهزة (أول 5)",
          "msp.merchants.expand.mada": "مدى",
          "msp.merchants.expand.noTerminals": "لا توجد أجهزة ضمن النطاق.",
          "msp.merchants.expand.viewAll": "عرض الكل ←",
          "msp.merchants.expand.col.terminalId": "رقم الجهاز",
          "msp.merchants.expand.col.status": "الحالة",
          "msp.merchants.expand.col.package": "الباقة",
          "msp.merchants.drawer.terminalEndpointNote": "ستتوفر قائمة الأجهزة الكاملة بمجرد دمج نقطة نهاية الأجهزة الخاصة بكل تاجر.",

          "ecr.providerMapping.intentActions": "إجراءات النية",
          "ecr.providerMapping.viewActions": "عرض الإجراءات",
          "ecr.providerMapping.actionDetails": "تفاصيل الإجراء",
          "ecr.providerMapping.parameters": "المعاملات",
          "ecr.providerMapping.noActionsAvailable": "لا توجد إجراءات متاحة",
          
          // Merchant Pages
          "merchant.dashboard.welcomeBack": "مرحباً بعودتك",
          "merchant.dashboard.overview": "نظرة عامة",
          "merchant.dashboard.welcomeMessage": "مرحباً بعودتك! إليك نظرة عامة على نشاطك التجاري.",
          "merchant.dashboard.live": "مباشر",
          "merchant.dashboard.todaysHighlights": "أبرز أحداث اليوم",
          "merchant.dashboard.todayTransactions": "عمليات اليوم",
          "merchant.dashboard.todayRevenue": "إيرادات اليوم",
          "merchant.dashboard.overallStatistics": "الإحصائيات الإجمالية",
          "merchant.dashboard.allTime": "كل الفترات",
          "merchant.dashboard.inProgress": "قيد التنفيذ",
          "merchant.dashboard.quickActions": "إجراءات سريعة",
          "merchant.dashboard.viewTransactions": "عرض العمليات",
          "merchant.dashboard.manageAllTransactions": "إدارة جميع العمليات",
          "merchant.dashboard.manageTerminals": "إدارة الأجهزة",
          "merchant.dashboard.viewTerminalStatus": "عرض حالة الأجهزة",
          "merchant.dashboard.reconcileTransactions": "موازنة العمليات",
          "merchant.dashboard.recentTransactions": "العمليات الأخيرة",
          "merchant.dashboard.viewAll": "عرض الكل",
          "merchant.dashboard.loadingDashboard": "جاري تحميل لوحة التحكم...",
          "merchant.dashboard.selectBranch": "اختر الفرع",
          "merchant.dashboard.transactionsReport": "تقرير العمليات",
          "merchant.dashboard.dateRangeLabel": "نطاق التاريخ:",
          "merchant.dashboard.to": "إلى",
          
          "merchant.management.users.title": "إدارة المستخدمين",
          "merchant.management.branches.title": "إدارة الفروع",
          "merchant.management.users.addUser": "إضافة مستخدم",
          "merchant.management.users.editUser": "تعديل المستخدم",
          "merchant.management.branches.addBranch": "إضافة فرع",
          "merchant.management.branches.editBranch": "تعديل الفرع",
          "merchant.management.users.selectRole": "اختر الدور",
          
          "merchant.terminals.title": "إدارة الأجهزة",
          "merchant.terminals.searchPlaceholder": "البحث عن الأجهزة...",
          "merchant.terminals.terminalDetails": "تفاصيل الجهاز",
          "merchant.terminals.connectionStatus": "حالة الاتصال",
          "merchant.terminals.lastSync": "آخر مزامنة",
          
          "merchant.transactions.title": "سجل العمليات",
          "merchant.transactions.exportTransactions": "تصدير العمليات",
          
          "merchant.refunds.title": "إدارة المبالغ المستردة",
          
          "merchant.download.title": "تحميل التقارير",
          
          "merchant.layout.portalTitle": "بوابة التاجر",
          
          "merchant.settings.discountRates.title": "تكوين الخصومات",
          "merchant.settings.discountRates.applyToAll": "تطبيق على جميع الأجهزة",
          
          // Onboarding Pages
          "onboarding.merchant.personal.placeholders.fullName": "أدخل اسمك الكامل",
          "onboarding.merchant.personal.placeholders.username": "أدخل اسم المستخدم",
          "onboarding.merchant.personal.placeholders.password": "أدخل كلمة المرور",
          "onboarding.merchant.personal.placeholders.confirmPassword": "أكد كلمة المرور",
          
          "onboarding.merchant.business.placeholders.businessName": "أدخل اسم النشاط التجاري",
          "onboarding.merchant.business.placeholders.cr": "أدخل رقم السجل التجاري",
          "onboarding.merchant.business.placeholders.email": "أدخل عنوان البريد الإلكتروني",
          "onboarding.merchant.business.placeholders.mobile": "أدخل رقم الجوال",
          "onboarding.merchant.business.placeholders.selectBank": "اختر البنك الخاص بك",
          
          "onboarding.merchant.branches.placeholders.branchName": "أدخل اسم الفرع",
          "onboarding.merchant.branches.placeholders.branchAddress": "أدخل عنوان الفرع",
          "onboarding.merchant.branches.placeholders.cashierName": "أدخل اسم الكاشير",
          "onboarding.merchant.branches.placeholders.cashierUsername": "أدخل اسم مستخدم الكاشير",
          "onboarding.merchant.branches.placeholders.terminalId": "أدخل رقم الجهاز",
          
          "onboarding.merchant.getStarted": "ابدأ الآن",
          "onboarding.merchant.completeProfile": "أكمل ملفك الشخصي",
          "onboarding.merchant.emailSent": "تم إرسال بريد التحقق",
          
          // ECR Onboarding
          "ecr.onboarding.title": "تسجيل مزود ECR",
          "ecr.onboarding.subtitle": "سجل حساب مزود ECR الخاص بك للتكامل مع نيوباس",
          "ecr.onboarding.fullNamePlaceholder": "أدخل اسمك الكامل",
          "ecr.onboarding.emailPlaceholder": "أدخل بريدك الإلكتروني",
          "ecr.onboarding.passwordPlaceholder": "أدخل كلمة المرور",
          "ecr.onboarding.confirmPasswordPlaceholder": "أكد كلمة المرور",
          "ecr.onboarding.fullNameMinLength": "يجب أن يكون الاسم الكامل 3 أحرف على الأقل",
          "ecr.onboarding.confirmPasswordReq": "تأكيد كلمة المرور مطلوب",
          "ecr.onboarding.register": "تسجيل",
          "ecr.onboarding.successTitle": "تم",
          "ecr.onboarding.successMessage": "تم إرسال حساب مزود ECR الخاص بك للموافقة. ستتمكن من تسجيل الدخول بمجرد الموافقة على حسابك",
          "ecr.onboarding.goToLogin": "الذهاب لتسجيل الدخول",
          "ecr.onboarding.registrationFailed": "فشل التسجيل",
          "ecr.onboarding.registrationError": "حدث خطأ أثناء التسجيل",
          
          // MSP Onboarding
          "msp.onboarding.title": "تسجيل مزود MSP",
          "msp.onboarding.subtitle": "سجل حساب مزود MSP الخاص بك في البوابة",
          "msp.onboarding.providerNameLabel": "اسم المزود (بالإنجليزية)",
          "msp.onboarding.providerNamePlaceholder": "Enter provider name in English",
          "msp.onboarding.providerNameReq": "اسم المزود بالإنجليزية مطلوب",
          "msp.onboarding.providerNameArLabel": "اسم المزود (بالعربية)",
          "msp.onboarding.providerNameArPlaceholder": "أدخل اسم المزود بالعربية",
          "msp.onboarding.providerNameArReq": "اسم المزود بالعربية مطلوب",
          "msp.onboarding.fullNamePlaceholder": "أدخل اسمك الكامل",
          "msp.onboarding.fullNameMinLength": "يجب أن يكون الاسم الكامل 3 أحرف على الأقل",
          "msp.onboarding.emailPlaceholder": "أدخل عنوان بريدك الإلكتروني",
          "msp.onboarding.passwordPlaceholder": "أدخل كلمة مرور قوية",
          "msp.onboarding.confirmPasswordPlaceholder": "أكد كلمة المرور",
          "msp.onboarding.confirmPasswordReq": "يرجى تأكيد كلمة المرور",
          "msp.onboarding.register": "تسجيل",
          "msp.onboarding.successTitle": "تم إرسال الطلب",
          "msp.onboarding.successMessage": "تم إرسال حساب مزود MSP الخاص بك للمراجعة. ستتلقى إشعاراً بمجرد تفعيل حسابك.",
          "msp.onboarding.goToLogin": "الذهاب لتسجيل الدخول",
          "msp.onboarding.registrationFailed": "فشل التسجيل. يرجى المحاولة مرة أخرى.",
          "msp.onboarding.registrationError": "حدث خطأ أثناء التسجيل. يرجى المحاولة مرة أخرى.",
          "msp.onboarding.totalLicensesLabel": "عدد الرخص",
          "msp.onboarding.totalLicensesPlaceholder": "أدخل عدد الرخص",
          "msp.onboarding.totalLicensesReq": "عدد الرخص مطلوب",
          "msp.onboarding.totalLicensesMin": "يجب أن يكون عدد الرخص على الأقل 1",
          providerUserInfo: "معلومات مستخدم المزود",
          noMspUserLinked: "لا يوجد مستخدم بوابة MSP مرتبط بهذا المزود.",
          enrollMspUser: "تسجيل مستخدم MSP",
          enrollMspUserTitle: "إنشاء وربط مستخدم MSP",
          mspUserEnrolledSuccess: "تم تسجيل مستخدم MSP وربطه بنجاح.",
          
          "onboarding.ecr.title": "تسجيل مزود ECR",
          "onboarding.ecr.placeholders.companyName": "أدخل اسم الشركة",
          "onboarding.ecr.placeholders.contactPerson": "أدخل اسم جهة الاتصال",
          "onboarding.ecr.placeholders.selectProvider": "اختر مزود ECR",
          
          // Components
          "components.filter.selectColumns": "اختر الأعمدة المراد عرضها",
          "components.filter.searchColumns": "البحث عن الأعمدة...",
          
          "components.mobileMenu.menu": "القائمة",
          
          "accessibility.closeMenu": "إغلاق القائمة",
          "accessibility.goBack": "العودة",
          
          "components.reconciliation.createNew": "إنشاء موازنة جديدة",
          
          "components.terminal.selectModel": "اختر موديل الجهاز",
          
          "components.layout.pageTitle": "عنوان الصفحة",
          
          "components.checkout.title": "الدفع",
          
          "components.license.information": "معلومات الترخيص",
          
          "components.merchant.information": "معلومات التاجر",
          
          "components.receipt.details": "تفاصيل الإيصال",
          "components.receipt.print": "طباعة الإيصال",
          "components.receipt.download": "تحميل الإيصال",
          
          "components.reconciliation.transactions": "عمليات الموازنة",
          "components.reconciliation.viewDetails": "عرض التفاصيل",
          
          "components.transaction.information": "معلومات العملية",
          "components.transaction.paymentDetails": "تفاصيل الدفع",
          "components.transaction.customerDetails": "تفاصيل العميل",
          
          // Auth Pages
          "auth.demo.title": "عرض تشفير RSA",
          "auth.demo.publicKey": "المفتاح العام",
          "auth.demo.privateKey": "المفتاح الخاص",
          "auth.demo.encrypt": "تشفير",
          "auth.demo.decrypt": "فك التشفير",
          "auth.demo.testMessage": "رسالة اختبار",
          
          // Messages - Success
          "messages.success.saved": "تم حفظ {{entity}} بنجاح",
          "messages.success.created": "تم إنشاء {{entity}} بنجاح",
          "messages.success.updated": "تم تحديث {{entity}} بنجاح",
          "messages.success.deleted": "تم حذف {{entity}} بنجاح",
          "messages.success.activated": "تم تفعيل {{entity}} بنجاح",
          "messages.success.deactivated": "تم إلغاء تفعيل {{entity}} بنجاح",
          "messages.success.approved": "تمت الموافقة على {{entity}} بنجاح",
          "messages.success.rejected": "تم رفض {{entity}} بنجاح",
          "messages.success.uploaded": "تم تحميل الملف بنجاح",
          "messages.success.downloaded": "تم تنزيل الملف بنجاح",
          "messages.success.exported": "تم تصدير البيانات بنجاح",
          "messages.success.imported": "تم استيراد البيانات بنجاح",
          
          // Messages - Error
          "messages.error.loadFailed": "فشل تحميل {{entity}}",
          "messages.error.saveFailed": "فشل حفظ {{entity}}",
          "messages.error.createFailed": "فشل إنشاء {{entity}}",
          "messages.error.updateFailed": "فشل تحديث {{entity}}",
          "messages.error.deleteFailed": "فشل حذف {{entity}}",
          "messages.error.uploadFailed": "فشل تحميل الملف",
          "messages.error.downloadFailed": "فشل تنزيل الملف",
          "messages.error.exportFailed": "فشل تصدير البيانات",
          "messages.error.importFailed": "فشل استيراد البيانات",
          "messages.error.networkError": "خطأ في الشبكة. يرجى التحقق من اتصالك",
          "messages.error.serverError": "خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً",
          "messages.error.unauthorized": "أنت غير مخول لتنفيذ هذا الإجراء",
          "messages.error.sessionExpired": "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى",
          "messages.error.notFound": "لم يتم العثور على {{entity}}",
          "messages.error.alreadyExists": "{{entity}} موجود بالفعل",
          "messages.error.invalidData": "البيانات المقدمة غير صالحة",
          "messages.error.requiredField": "هذا الحقل مطلوب",
          
          // Messages - Warning
          "messages.warning.unsavedChanges": "لديك تغييرات غير محفوظة. هل أنت متأكد من المغادرة؟",
          "messages.warning.deleteConfirm": "هل أنت متأكد من حذف {{entity}}؟",
          "messages.warning.deactivateConfirm": "هل أنت متأكد من إلغاء تفعيل {{entity}}؟",
          "messages.warning.irreversible": "لا يمكن التراجع عن هذا الإجراء",
          "messages.warning.dataLoss": "قد يؤدي هذا الإجراء إلى فقدان البيانات",
          "messages.warning.lowBalance": "تحذير رصيد منخفض",
          "messages.warning.expiringLicense": "الترخيص ينتهي قريباً",
          
          // Messages - Info
          "messages.info.loading": "جاري التحميل...",
          "messages.info.processing": "جاري المعالجة...",
          "messages.info.pleaseWait": "يرجى الانتظار...",
          "messages.info.noData": "لا توجد بيانات متاحة",
          "messages.info.noResults": "لم يتم العثور على نتائج",
          "messages.info.emptyState": "لا يوجد {{entity}} بعد",
          "messages.info.selectItem": "يرجى اختيار عنصر",
          "messages.info.uploadInProgress": "جاري التحميل...",
          "messages.info.downloadInProgress": "جاري التنزيل...",
          
          // Validation Messages
          "validation.required": "{{field}} مطلوب",
          "validation.invalid": "{{field}} غير صالح",
          "validation.tooShort": "يجب أن يكون {{field}} {{min}} أحرف على الأقل",
          "validation.tooLong": "يجب ألا يتجاوز {{field}} {{max}} حرفاً",
          "validation.mustMatch": "يجب أن يتطابق {{field1}} و {{field2}}",
          "validation.invalidFormat": "تنسيق {{field}} غير صالح",
          "validation.minValue": "يجب أن يكون {{field}} {{min}} على الأقل",
          "validation.maxValue": "يجب ألا يتجاوز {{field}} {{max}}",
          "validation.email.required": "البريد الإلكتروني مطلوب",
          "validation.email.invalid": "عنوان البريد الإلكتروني غير صالح",
          "validation.password.required": "كلمة المرور مطلوبة",
          "validation.password.tooWeak": "كلمة المرور ضعيفة جداً",
          "validation.password.mustMatch": "كلمات المرور غير متطابقة",
          "validation.phone.required": "رقم الهاتف مطلوب",
          "validation.phone.invalid": "رقم الهاتف غير صالح",
          "validation.number.required": "الرقم مطلوب",
          "validation.number.invalid": "الرقم غير صالح",
          "validation.date.required": "التاريخ مطلوب",
          "validation.date.invalid": "التاريخ غير صالح",
          "validation.url.invalid": "عنوان URL غير صالح",
          "validation.file.tooLarge": "حجم الملف يتجاوز الحد الأقصى",
          "validation.file.invalidType": "نوع الملف غير صالح",
          
          // Reset Password Page
          "auth.reset.title": "إعادة تعيين كلمة المرور",
          "auth.reset.newPassword": "كلمة المرور الجديدة",
          "auth.reset.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
          "auth.reset.resetButton": "إعادة تعيين كلمة المرور",
          "auth.reset.invalidToken": "رمز غير صالح أو منتهي الصلاحية",
          "auth.reset.success": "تم إعادة تعيين كلمة المرور بنجاح، يمكنك تسجيل الدخول الآن.",
          "auth.reset.passwordEmpty": "لا يمكن أن تكون كلمة المرور فارغة.",
          "auth.reset.passwordsNotMatch": "كلمات المرور غير متطابقة.",
          "auth.reset.passwordWeak": "كلمة المرور ضعيفة.",
          "auth.reset.invalidLink": "رابط إعادة تعيين كلمة المرور غير صالح",
          
          // Verify Email Page
          "auth.verify.title": "التحقق من البريد الإلكتروني",
          "auth.verify.verifying": "جاري التحقق من بريدك الإلكتروني",
          "auth.verify.verified": "تم التحقق من البريد الإلكتروني",
          "auth.verify.success": "تم التحقق من البريد الإلكتروني، يمكنك تسجيل الدخول الآن.",
          "auth.verify.invalidToken": "رمز غير صالح أو منتهي الصلاحية",
          "auth.verify.invalidLink": "رابط إعادة تعيين كلمة المرور غير صالح",
          
          // Reconciliation Modal & History
          allCashiers:"الجميع",
          allCashiersInBranch:"جميع الكاشيرات في الفرع",
          noCashiersInBranch:"لا يوجد كاشيرات في هذا الفرع",
          online: "متصل",
          offline: "غير متصل",
          requestStatus: "حالة الطلب",
          success: "نجح",

          // Admin Daily Report
          "admin.dailyReport.title": "تقرير المعاملات اليومي",
          "admin.dailyReport.subtitle": "عرض بيانات المعاملات المجمعة لأي تاريخ محدد",
          "admin.dailyReport.branch": "الفرع",
          "admin.dailyReport.merchant": "التاجر",
          "admin.dailyReport.cashier": "الكاشير",
          "admin.dailyReport.transactions": "المعاملات",
          "admin.dailyReport.approved": "المعتمدة",
          "admin.dailyReport.declined": "المرفوضة",
          "admin.dailyReport.refunds": "المستردات",
          "admin.dailyReport.net": "الصافي",
          "admin.dailyReport.totalTransactions": "إجمالي المعاملات",
          "admin.dailyReport.approvedAmount": "المبلغ المعتمد",
          "admin.dailyReport.refundAmount": "مبلغ الاسترداد",
          "admin.dailyReport.declinedCount": "المرفوضة",
          "admin.dailyReport.netAmount": "الصافي",
          "admin.dailyReport.copySummary": "نسخ الملخص",
          "admin.dailyReport.downloadPdf": "تحميل PDF",
          "admin.dailyReport.noData": "لا توجد معاملات لهذا التاريخ",
          "admin.dailyReport.loading": "جاري تحميل التقرير...",
          "admin.dailyReport.fetchError": "فشل تحميل التقرير اليومي",
          "admin.dailyReport.copiedToClipboard": "تم النسخ إلى الحافظة",
          "admin.dailyReport.copyError": "فشل نسخ الملخص",
          "admin.dailyReport.pdfError": "فشل تحميل PDF",
          "admin.dailyReport.noDataForPdf": "لا توجد معاملات لهذا التاريخ",

          // Package Management
          packages: "الحزم",
          packagesDescription: "إدارة حزم هذا المزود",
          addPackage: "إضافة حزمة",
          editPackage: "تعديل الحزمة",
          packageName: "اسم الحزمة",
          packageNameRequired: "اسم الحزمة مطلوب",
          packageNameMaxLength: "يجب أن يكون اسم الحزمة أقل من 255 حرفاً",
          enterPackageName: "أدخل اسم الحزمة",
          packageCreated: "تم إنشاء الحزمة بنجاح",
          packageUpdated: "تم تحديث الحزمة بنجاح",
          packageDeleted: "تم حذف الحزمة بنجاح",
          deletePackageConfirm: "هل أنت متأكد من حذف هذه الحزمة؟",
          deletePackageWarning: "سيؤدي ذلك إلى حذف جميع الإجراءات والمعاملات المرتبطة بها.",
          intentActions: "إجراءات النية",
          priority: "الأولوية",
          priorityRequired: "الأولوية مطلوبة",
          amountInSAR: "المبلغ بالريال السعودي",

          // Role Management
          rolesAndPermissions: "الأدوار والصلاحيات",
          roles: "الأدوار",
          addRole: "إضافة دور",
          searchByName: "بحث بالاسم",
          createRole: "إنشاء دور",
          editRole: "تعديل الدور",
          deleteRole: "حذف الدور",
          assignRole: "تعيين دور",
          removeRole: "إزالة الدور",
          roleName: "اسم الدور",
          roleDescription: "الوصف",
          noRolesYet: "لم يتم إنشاء أدوار مخصصة بعد",
          noCustomRole: "لا يوجد دور مخصص",
          confirmDeleteRole: "هل أنت متأكد من حذف الدور \"{{roleName}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
          roleCreated: "تم إنشاء الدور بنجاح",
          roleUpdated: "تم تحديث الدور بنجاح",
          roleSaved: "تم حفظ الدور",
          roleDeleted: "تم حذف الدور بنجاح",
          roleAssigned: "تم تعيين الدور بنجاح",
          roleRemoved: "تم إزالة تعيين الدور",
          roleNameRequired: "اسم الدور مطلوب",
          roleNameTooLong: "يجب ألا يتجاوز اسم الدور 100 حرف",
          roleDescTooLong: "يجب ألا يتجاوز الوصف 255 حرفاً",
          roleHasAssignedStaff: "{{count}} من الموظفين معيّنون حاليًا لهذا الدور. حذفه لن يعيد تعيينهم تلقائيًا.",
          roleAssignedCountUnknown: "تعذر التحقق من عدد الموظفين المعيّنين حاليًا لهذا الدور.",
          assignRoleFailed: "تعذر إعادة تعيين الدور، يرجى التحديث والمحاولة مرة أخرى.",
          pleaseSelectAtLeastOnePermission: "يرجى اختيار صلاحية واحدة على الأقل",
          customRoles: "أدوار مخصصة",
          standardRoles: "قياسي",
          selectRole: "اختر الدور",
          otherStaff: "موظفون آخرون",
          permissions: "الصلاحيات",
          noPermissionCashierCreate: "ليس لديك صلاحية لإنشاء كاشير.",

          "admin.permissionOwnerType.title": "أنواع مالكي الصلاحيات",
          "admin.permissionOwnerType.subtitle": "حدد نوع الحساب الذي يمكن منحه كل صلاحية",
          "admin.permissionOwnerType.id": "المعرف",
          "admin.permissionOwnerType.name": "الاسم",
          "admin.permissionOwnerType.displayLabel": "التسمية المعروضة",
          "admin.permissionOwnerType.resource": "المورد",
          "admin.permissionOwnerType.ownerType": "نوع المالك",
          "admin.permissionOwnerType.search": "ابحث بالاسم أو التسمية أو المورد",
          "admin.permissionOwnerType.loadFailed": "فشل تحميل الصلاحيات",
          "admin.permissionOwnerType.updateSuccess": "تم تحديث الصلاحية",
          "admin.permissionOwnerType.updateFailed": "فشل تحديث الصلاحية",
          "admin.permissionOwnerType.description": "الوصف",
          "admin.permissionOwnerType.reset": "إعادة التعيين إلى الافتراضي",

        },
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      convertDetectedLanguage: (lng: string) => {
        const bare = lng.split("-")[0];
        return bare === "ar" ? "ar" : "en";
      },
    },
    interpolation: {
      escapeValue: false,
      // Add formatting functions for dates and numbers
      format: (value, format, lng) => {
        if (format === 'currency') {
          return new Intl.NumberFormat(lng, {
            style: 'currency',
            currency: 'SAR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(value);
        }
        if (format === 'number') {
          return new Intl.NumberFormat(lng, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(value);
        }
        if (format === 'decimal') {
          return new Intl.NumberFormat(lng, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(value);
        }
        if (format === 'percent') {
          return new Intl.NumberFormat(lng, {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }).format(value / 100);
        }
        if (format === 'date') {
          return new Intl.DateTimeFormat(lng, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          }).format(new Date(value));
        }
        if (format === 'datetime') {
          return new Intl.DateTimeFormat(lng, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }).format(new Date(value));
        }
        if (format === 'time') {
          return new Intl.DateTimeFormat(lng, {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          }).format(new Date(value));
        }
        if (format === 'shortDate') {
          return new Intl.DateTimeFormat(lng, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }).format(new Date(value));
        }
        if (format === 'longDate') {
          return new Intl.DateTimeFormat(lng, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          }).format(new Date(value));
        }
        if (format === 'relativeTime') {
          const rtf = new Intl.RelativeTimeFormat(lng, { numeric: 'auto' });
          const diff = Math.floor((new Date(value).getTime() - Date.now()) / 1000);
          
          if (Math.abs(diff) < 60) return rtf.format(diff, 'second');
          if (Math.abs(diff) < 3600) return rtf.format(Math.floor(diff / 60), 'minute');
          if (Math.abs(diff) < 86400) return rtf.format(Math.floor(diff / 3600), 'hour');
          if (Math.abs(diff) < 2592000) return rtf.format(Math.floor(diff / 86400), 'day');
          if (Math.abs(diff) < 31536000) return rtf.format(Math.floor(diff / 2592000), 'month');
          return rtf.format(Math.floor(diff / 31536000), 'year');
        }
        return value;
      }
    },
  });

// Add empty state translations
addEmptyStateTranslations(i18n);

// Add on-demand transaction status retrieval translations
addTransactionStatusRetrievalTranslations(i18n);

export default i18n;

